// Marketing sections translations — Price Comparison + Fear Section
export const marketingTranslations = {
  en: {
    // Price Comparison
    pc_tag: "Stop overpaying for SEO",
    pc_h1: "Replace expensive SEO agencies",
    pc_h1_highlight: "for the price of a family dinner",
    pc_sub: "You can try it for free and start ranking today",
    pc_month: "month",
    pc_best_value: "BEST VALUE",
    pc_agency: "SEO Agency",
    pc_ads_1: "You need a big budget",
    pc_ads_2: "Manual keyword research",
    pc_ads_3: "Optimized for clicks, not sales",
    pc_ads_4: "Rented traffic",
    pc_ads_5: "Competitors outbid you",
    pc_ads_6: "Traffic stops when you stop spending",
    pc_ads_7: "€0 in lasting results",
    pc_trp_1: "AI writes quality daily content",
    pc_trp_2: "Automatic keyword research",
    pc_trp_3: "Quality backlinks included",
    pc_trp_4: "No contracts — cancel anytime",
    pc_trp_5: "Rank once, get traffic forever",
    pc_trp_6: "No technical knowledge needed",
    pc_trp_7: "Built to bring buyers, not random traffic",
    pc_cta: "START FREE TRIAL",
    pc_ag_1: "Months to see results",
    pc_ag_2: "Weekly meetings",
    pc_ag_3: "Locked into contracts",
    pc_ag_4: "2 blog posts/month for €2,300",
    pc_ag_5: "They own everything",
    pc_ag_6: "Traffic up 200%, Sales 0%",
    pc_ag_7: "No AI visibility optimization",
    pc_save_title: "Save 20+ hours & €2,000+/month",
    pc_save_sub: "Switch from agencies or Google Ads to TopRankPulse and keep more money in your pocket.",
    pc_save_cta: "SEE PLANS",

    // Brand Monitor
    bm_no_monitors: "No Brands Monitored Yet",
    bm_no_monitors_desc: "Add your brand to start tracking how AI search engines see you.",
    bm_add_brand: "Add Your Brand",
    bm_brand_name: "Brand Name",
    bm_website: "Website URL",
    bm_industry: "Industry",
    bm_location: "Location",
    bm_competitors: "Competitors",
    bm_comma: "comma separated",
    bm_start: "Start Monitoring",
    bm_recheck: "Re-check",
    bm_overall: "Overall AI Visibility",
    bm_citation_score: "Citation Score",
    bm_recommends: "Recommends",
    bm_not_cited: "Not cited",
    bm_top_rec: "Top Recommendation",
    bm_query_analysis: "Query Analysis",
    bm_last_checked: "Last checked",
    bm_loading: "Analyzing AI visibility...",
    bm_recommendations: "How to increase your visibility",
    bm_high: "High Impact",
    bm_medium: "Medium",
    bm_low: "Low",
    bm_vis_up: "Visibility increased since last check",
    bm_vis_down: "Visibility decreased since last check",

    // Attribution Page
    attr_desc: "See exactly how much traffic and revenue AI search engines bring you",
    attr_setup: "Setup Attribution",
    attr_demo: "Demo data — install the tracking pixel to see real numbers",
    attr_visits: "AI Visits",
    attr_conversions: "Conversions",
    attr_revenue: "Revenue",
    attr_conv_rate: "Conv. Rate",
    attr_traffic_30: "AI Traffic (30 Days)",
    attr_by_source: "Traffic by AI Source",
    attr_source_details: "Source Details",
    attr_visits_short: "visits",
    attr_insights: "AI Insights",
    attr_pixel: "Tracking Pixel",
    attr_copied: "Copied",
    attr_copy: "Copy",
    attr_pixel_desc: "Paste this before </head> on your website to start tracking real AI traffic.",
    attr_no_sites: "No Sites Tracked Yet",
    attr_no_sites_desc: "Add your website to see how much traffic AI search engines bring you.",
    attr_add_website: "Add Your Website",

    // Local SEO Page
    ls_stat1: "sites invisible to AI", ls_stat2: "avg visits from AI search", ls_stat3: "free audit results",
    ls_f1_t: "AI Visibility Tracking", ls_f1_d: "Check if ChatGPT, Perplexity & Gemini cite your website",
    ls_f2_t: "Complete SEO Audit", ls_f2_d: "Technical analysis with actionable recommendations",
    ls_f3_t: "Voice Search Score", ls_f3_d: "Optimize for Siri, Alexa, Google Assistant",
    ls_f4_t: "GEO Optimization", ls_f4_d: "Local SEO for",
    ls_f5_t: "Backlink Analysis", ls_f5_d: "Check dofollow, nofollow & domain authority",
    ls_f6_t: "Site Speed", ls_f6_d: "Core Web Vitals & performance score",
    ls_more_cities: "More cities in", ls_top_cities: "Top cities in",
    ls_cta_h1: "START YOUR FREE", ls_cta_h2: "SEO AUDIT",
    ls_cta_join: "Join businesses in", ls_cta_using: "using TopRankPulse.",
    ls_scan: "SCAN YOUR WEBSITE",
    ls_free: "Free forever", ls_no_card: "No credit card", ls_langs: "26 languages",

    // Plugin Page
    pl_f1_t: "AI Visibility Tracking", pl_f1_d: "See if ChatGPT, Perplexity & Gemini cite your website",

    // Social Proof + Trust + How it Works + Floating CTA
    sp_businesses: "businesses worldwide trust TopRankPulse",
    tb_gdpr: "GDPR Compliant", tb_ssl: "256-bit SSL", tb_no_cc: "No Credit Card", tb_30s: "Results in 30s", tb_langs: "26 Languages",
    hw_tag: "How it works", hw_title: "From zero to insights in", hw_seconds: "30 seconds",
    hw_s1_t: "Enter your URL", hw_s1_d: "Paste your website URL into the scanner. No signup required.",
    hw_s2_t: "AI analyzes everything", hw_s2_d: "Our AI checks 50+ SEO factors, AI visibility across 4 engines, and GEO optimization.",
    hw_s3_t: "Get actionable results", hw_s3_d: "Receive your score, detailed report, and step-by-step fixes in 30 seconds. Free.",
    fcta_text: "Your competitors are ranking while you read this.", fcta_sub: "Free scan. No credit card. 30 seconds.", fcta_btn: "SCAN NOW",

    // Comparison Pages (vs Semrush / vs Ahrefs)
    vs_try: "Try Free", vs_h1_why: "Why businesses switch from", vs_h1_to: "to",
    vs_sub: "Same powerful SEO tools. AI visibility included. Fraction of the price.",
    vs_save: "Save", vs_month: "month", vs_year: "year",
    vs_key_diff: "Key Differences",
    vs_d1_t: "65% cheaper", vs_d2_t: "AI Visibility Built-in", vs_d3_t: "26 Languages",
    vs_compare: "Feature Comparison", vs_feature: "Feature",
    vs_f_ai: "AI Visibility Tracking (ChatGPT, Perplexity, Gemini)", vs_f_audit: "Complete SEO Audit (50+ factors)",
    vs_f_kw: "Keyword Research", vs_f_content: "AI Content Writing (Blog Agent)",
    vs_f_bl: "Backlink Analysis", vs_f_rank: "Rank Tracking", vs_f_spy: "Competitor Analysis",
    vs_f_geo: "GEO Optimization (Local SEO)", vs_f_voice: "Voice Search Optimization",
    vs_f_cookie: "Cookie / GDPR Audit", vs_f_wp: "WordPress Plugin",
    vs_f_blog: "AI Blog Agent (25 articles/month)", vs_f_lang: "Multi-language Support",
    vs_f_brand: "AI Brand Monitoring", vs_f_rev: "Revenue Impact Calculator",
    vs_f_nocontract: "No Long-term Contract", vs_f_free: "Free SEO Scan",
    vs_pricing: "Pricing Plans Comparison", vs_best: "BEST VALUE", vs_everything: "everything included",
    vs_p_all: "All tools included", vs_p_ai: "AI visibility tracking", vs_p_26: "26 languages",
    vs_p_blog: "Blog Agent included", vs_p_unlimited: "Unlimited scans",
    vs_no_ai: "AI visibility costs extra", vs_no_blog: "No AI blog agent",
    vs_no_lang: "Limited language support", vs_limited: "Limited scans/credits",
    vs_cta_h: "Ready to switch?", vs_cta_h2: "Start for free.",
    vs_cta_btn: "SCAN YOUR WEBSITE FREE", vs_no_cc: "No credit card", vs_30s: "Results in 30s", vs_cancel: "Cancel anytime",
    pl_f2_t: "Complete SEO Audit", pl_f2_d: "Technical analysis with actionable recommendations",
    pl_f3_t: "Keyword Research", pl_f3_d: "Find better keywords with volume, difficulty & trends",
    pl_f4_t: "Voice Search Score", pl_f4_d: "Optimize for Siri, Alexa, Google Assistant",
    pl_f5_t: "AI Recommendations", pl_f5_d: "Step-by-step instructions to improve your score",
    pl_f6_t: "Dashboard Widget", pl_f6_d: "SEO score directly in your WordPress dashboard",
    pl_f7_t: "Auto-Scan on Publish", pl_f7_d: "Automatically analyzes new posts when published",
    pl_f8_t: "WooCommerce SEO", pl_f8_d: "Product SEO scores, AI descriptions & Google Shopping optimization",
    pl_f9_t: "Blog Agent (€25)", pl_f9_d: "25 SEO articles with backlinks to your site",
    pl_s3_t: "Scan Your Site", pl_s3_d: "Click 'Scan Now' and get your SEO score + AI visibility report in 30 seconds.",
    pl_w1_t: "Product SEO Score", pl_w1_d: "Each product gets a real-time SEO score.",
    pl_w2_t: "AI Description Generator", pl_w2_d: "One-click AI-generated SEO product descriptions.",
    pl_w3_t: "Google Shopping Ready", pl_w3_d: "Enhanced product schema markup for Google Shopping.",

    // Fear Section
    fear_warning: "WARNING",
    fear_h1: "AI recommends brands",
    fear_h1_2: "that rank",
    fear_h1_highlight: "TODAY",
    fear_desc: "ChatGPT, Gemini and Perplexity pull answers from top-ranking pages. If you're not ranking now, AI will recommend your competitors — and it only gets harder to catch up.",
    fear_m1_label: "Month 1",
    fear_m1_title: "Your competitor publishes content",
    fear_m1_desc: "While you wait, they're building SEO authority and getting cited by AI engines.",
    fear_m3_label: "Month 3",
    fear_m3_title: "AI starts recommending them",
    fear_m3_desc: "ChatGPT and Perplexity now cite your competitors by default. Your traffic drops.",
    fear_m6_label: "Month 6",
    fear_m6_title: "You're invisible. They own your niche.",
    fear_m6_desc: "AI models reinforce what already works. Catching up now costs 10x more effort and money.",
    fear_urgency: "Every day you wait, you lose customers",
    fear_cta_h: "Start ranking before your competitors do",
    fear_cta_sub: "The brands ranking today become the default AI recommendations tomorrow. Make sure that's you.",
    fear_cta_btn: "GET STARTED NOW",
  },
  sk: {
    // Price Comparison
    pc_tag: "Prestaňte preplácať za SEO",
    pc_h1: "Nahraďte drahé SEO agentúry",
    pc_h1_highlight: "za cenu rodinnej večere",
    pc_sub: "Vyskúšajte zadarmo a začnite rankovať ešte dnes",
    pc_month: "mesiac",
    pc_best_value: "NAJLEPŠIA HODNOTA",
    pc_agency: "SEO Agentúra",
    pc_ads_1: "Potrebujete veľký rozpočet",
    pc_ads_2: "Manuálny výskum kľúčových slov",
    pc_ads_3: "Optimalizované na kliknutia, nie na predaje",
    pc_ads_4: "Prenajatá návštevnosť",
    pc_ads_5: "Konkurenti vás preplatia",
    pc_ads_6: "Návštevnosť sa zastaví keď prestanete platiť",
    pc_ads_7: "€0 v trvalých výsledkoch",
    pc_trp_1: "AI píše kvalitný denný obsah",
    pc_trp_2: "Automatický výskum kľúčových slov",
    pc_trp_3: "Kvalitné spätné odkazy zahrnuté",
    pc_trp_4: "Žiadne zmluvy — zrušte kedykoľvek",
    pc_trp_5: "Rankujte raz, návštevnosť navždy",
    pc_trp_6: "Nepotrebujete technické znalosti",
    pc_trp_7: "Priťahujeme kupujúcich, nie náhodnú návštevnosť",
    pc_cta: "ZAČAŤ ZADARMO",
    pc_ag_1: "Mesiace čakania na výsledky",
    pc_ag_2: "Týždenné stretnutia",
    pc_ag_3: "Viazaní v zmluvách",
    pc_ag_4: "2 články/mesiac za €2 300",
    pc_ag_5: "Vlastnia všetko oni",
    pc_ag_6: "Návštevnosť +200%, Predaje 0%",
    pc_ag_7: "Žiadna AI optimalizácia viditeľnosti",
    pc_save_title: "Ušetrite 20+ hodín a €2 000+/mesiac",
    pc_save_sub: "Prejdite z agentúr alebo Google Ads na TopRankPulse a nechajte si viac peňazí.",
    pc_save_cta: "ZOBRAZIŤ PLÁNY",

    // Brand Monitor
    bm_no_monitors: "Zatiaľ nemonitorujete žiadnu značku",
    bm_no_monitors_desc: "Pridajte svoju značku a začnite sledovať, ako vás AI vyhľadávače vidia.",
    bm_add_brand: "Pridať značku",
    bm_brand_name: "Názov značky",
    bm_website: "URL webstránky",
    bm_industry: "Odvetvie",
    bm_location: "Lokalita",
    bm_competitors: "Konkurenti",
    bm_comma: "oddelené čiarkou",
    bm_start: "Začať monitorovanie",
    bm_recheck: "Znovu skontrolovať",
    bm_overall: "Celková AI viditeľnosť",
    bm_citation_score: "Skóre citácie",
    bm_recommends: "Odporúča",
    bm_not_cited: "Necitované",
    bm_top_rec: "Hlavné odporúčanie",
    bm_query_analysis: "Analýza otázok",
    bm_last_checked: "Posledná kontrola",
    bm_loading: "Analyzujem AI viditeľnosť...",
    bm_recommendations: "Ako zvýšiť vašu viditeľnosť",
    bm_high: "Vysoký dopad",
    bm_medium: "Stredný",
    bm_low: "Nízky",
    bm_vis_up: "Viditeľnosť stúpla od poslednej kontroly",
    bm_vis_down: "Viditeľnosť klesla od poslednej kontroly",

    // Attribution Page
    attr_desc: "Pozrite sa presne koľko návštevnosti a príjmov vám AI vyhľadávače prinášajú",
    attr_setup: "Nastaviť atribúciu",
    attr_demo: "Demo dáta — nainštalujte sledovací pixel pre reálne čísla",
    attr_visits: "AI návštevy",
    attr_conversions: "Konverzie",
    attr_revenue: "Príjmy",
    attr_conv_rate: "Miera konverzie",
    attr_traffic_30: "AI návštevnosť (30 dní)",
    attr_by_source: "Návštevnosť podľa AI zdroja",
    attr_source_details: "Detail zdrojov",
    attr_visits_short: "návštev",
    attr_insights: "AI prehľady",
    attr_pixel: "Sledovací pixel",
    attr_copied: "Skopírované",
    attr_copy: "Kopírovať",
    attr_pixel_desc: "Vložte tento kód pred </head> na vašej stránke pre sledovanie reálnej AI návštevnosti.",
    attr_no_sites: "Zatiaľ nesledujete žiadnu stránku",
    attr_no_sites_desc: "Pridajte vašu webstránku a zistite koľko návštevnosti vám AI vyhľadávače prinášajú.",
    attr_add_website: "Pridať web",

    // Local SEO Page
    ls_stat1: "webov neviditeľných pre AI", ls_stat2: "priem. návštev z AI vyhľadávania", ls_stat3: "výsledky auditu zadarmo",
    ls_f1_t: "Sledovanie AI viditeľnosti", ls_f1_d: "Skontrolujte či ChatGPT, Perplexity a Gemini citujú váš web",
    ls_f2_t: "Kompletný SEO audit", ls_f2_d: "Technická analýza s konkrétnymi odporúčaniami",
    ls_f3_t: "Skóre hlasového vyhľadávania", ls_f3_d: "Optimalizácia pre Siri, Alexu, Google Asistenta",
    ls_f4_t: "GEO optimalizácia", ls_f4_d: "Lokálne SEO pre",
    ls_f5_t: "Analýza spätných odkazov", ls_f5_d: "Kontrola dofollow, nofollow a autority domény",
    ls_f6_t: "Rýchlosť webu", ls_f6_d: "Core Web Vitals a výkonnostné skóre",
    ls_more_cities: "Ďalšie mestá v", ls_top_cities: "Top mestá v",
    ls_cta_h1: "ZAČNITE BEZPLATNÝ", ls_cta_h2: "SEO AUDIT",
    ls_cta_join: "Pridajte sa k firmám v", ls_cta_using: "ktoré používajú TopRankPulse.",
    ls_scan: "SKENOVAŤ VÁŠ WEB",
    ls_free: "Navždy zadarmo", ls_no_card: "Bez kreditnej karty", ls_langs: "26 jazykov",

    // Plugin Page
    pl_f1_t: "Sledovanie AI viditeľnosti", pl_f1_d: "Skontrolujte či ChatGPT, Perplexity a Gemini citujú váš web",

    // Social Proof + Trust + How it Works + Floating CTA
    sp_businesses: "firiem z celého sveta nám už dôveruje",
    tb_gdpr: "GDPR v súlade", tb_ssl: "256-bit SSL", tb_no_cc: "Bez kreditnej karty", tb_30s: "Výsledky za 30s", tb_langs: "26 jazykov",
    hw_tag: "Ako to funguje", hw_title: "Od nuly k výsledkom za", hw_seconds: "30 sekúnd",
    hw_s1_t: "Zadajte vašu URL", hw_s1_d: "Vložte URL vašej webstránky do skenera. Bez registrácie.",
    hw_s2_t: "AI analyzuje všetko", hw_s2_d: "Naša AI skontroluje 50+ SEO faktorov, AI viditeľnosť v 4 vyhľadávačoch a GEO optimalizáciu.",
    hw_s3_t: "Získajte konkrétne výsledky", hw_s3_d: "Dostanete skóre, detailný report a kroky na opravu za 30 sekúnd. Zadarmo.",
    fcta_text: "Vaša konkurencia rankuje kým vy čítate toto.", fcta_sub: "Bezplatný sken. Bez karty. 30 sekúnd.", fcta_btn: "SKENOVAŤ TERAZ",

    // Comparison Pages
    vs_try: "Vyskúšať zadarmo", vs_h1_why: "Prečo firmy prechádzajú z", vs_h1_to: "na",
    vs_sub: "Rovnaké SEO nástroje. AI viditeľnosť zahrnutá. Zlomok ceny.",
    vs_save: "Ušetríte", vs_month: "mesačne", vs_year: "ročne",
    vs_key_diff: "Hlavné rozdiely",
    vs_d1_t: "O 65% lacnejšie", vs_d2_t: "AI viditeľnosť zahrnutá", vs_d3_t: "26 jazykov",
    vs_compare: "Porovnanie funkcií", vs_feature: "Funkcia",
    vs_f_ai: "Sledovanie AI viditeľnosti (ChatGPT, Perplexity, Gemini)", vs_f_audit: "Kompletný SEO audit (50+ faktorov)",
    vs_f_kw: "Výskum kľúčových slov", vs_f_content: "AI písanie obsahu (Blog Agent)",
    vs_f_bl: "Analýza spätných odkazov", vs_f_rank: "Sledovanie pozícií", vs_f_spy: "Analýza konkurencie",
    vs_f_geo: "GEO optimalizácia (lokálne SEO)", vs_f_voice: "Optimalizácia hlasového vyhľadávania",
    vs_f_cookie: "Cookie / GDPR audit", vs_f_wp: "WordPress plugin",
    vs_f_blog: "AI Blog Agent (25 článkov/mesiac)", vs_f_lang: "Podpora viacerých jazykov",
    vs_f_brand: "AI monitorovanie značky", vs_f_rev: "Kalkulačka dopadu na príjmy",
    vs_f_nocontract: "Bez dlhodobej zmluvy", vs_f_free: "Bezplatný SEO sken",
    vs_pricing: "Porovnanie cenových plánov", vs_best: "NAJLEPŠIA HODNOTA", vs_everything: "všetko zahrnuté",
    vs_p_all: "Všetky nástroje zahrnuté", vs_p_ai: "Sledovanie AI viditeľnosti", vs_p_26: "26 jazykov",
    vs_p_blog: "Blog Agent zahrnutý", vs_p_unlimited: "Neobmedzené skeny",
    vs_no_ai: "AI viditeľnosť za príplatok", vs_no_blog: "Žiadny AI blog agent",
    vs_no_lang: "Obmedzená jazyková podpora", vs_limited: "Obmedzené skeny/kredity",
    vs_cta_h: "Pripravení prejsť?", vs_cta_h2: "Začnite zadarmo.",
    vs_cta_btn: "SKENOVAŤ VÁŠ WEB ZADARMO", vs_no_cc: "Bez kreditnej karty", vs_30s: "Výsledky za 30s", vs_cancel: "Zrušte kedykoľvek",
    pl_f2_t: "Kompletný SEO audit", pl_f2_d: "Technická analýza s konkrétnymi odporúčaniami",
    pl_f3_t: "Výskum kľúčových slov", pl_f3_d: "Nájdite lepšie kľúčové slová s objemom a náročnosťou",
    pl_f4_t: "Skóre hlasového vyhľadávania", pl_f4_d: "Optimalizácia pre Siri, Alexu, Google Asistenta",
    pl_f5_t: "AI odporúčania", pl_f5_d: "Kroky na zlepšenie vášho skóre",
    pl_f6_t: "Widget v dashboarde", pl_f6_d: "SEO skóre priamo vo vašom WordPress dashboarde",
    pl_f7_t: "Auto-sken pri publikovaní", pl_f7_d: "Automaticky analyzuje nové príspevky pri publikovaní",
    pl_f8_t: "WooCommerce SEO", pl_f8_d: "SEO skóre produktov, AI popisy a Google Shopping optimalizácia",
    pl_f9_t: "Blog Agent (€25)", pl_f9_d: "25 SEO článkov so spätnými odkazmi na váš web",
    pl_s3_t: "Skenujte váš web", pl_s3_d: "Kliknite 'Skenovať' a za 30 sekúnd získate SEO skóre + AI viditeľnosť. Zadarmo.",
    pl_w1_t: "SEO skóre produktu", pl_w1_d: "Každý produkt dostane real-time SEO skóre.",
    pl_w2_t: "AI generátor popisov", pl_w2_d: "AI generované SEO popisy produktov jedným kliknutím.",
    pl_w3_t: "Pripravené pre Google Shopping", pl_w3_d: "Vylepšený schema markup pre Google Shopping.",

    // Fear Section
    fear_warning: "VAROVANIE",
    fear_h1: "AI odporúča značky",
    fear_h1_2: "ktoré rankujú",
    fear_h1_highlight: "DNES",
    fear_desc: "ChatGPT, Gemini a Perplexity berú odpovede z najlepšie rankujúcich stránok. Ak nerankujete teraz, AI bude odporúčať vašu konkurenciu — a dohnať to bude len ťažšie.",
    fear_m1_label: "Mesiac 1",
    fear_m1_title: "Vaša konkurencia publikuje obsah",
    fear_m1_desc: "Kým vy čakáte, oni budujú SEO autoritu a AI ich začína citovať.",
    fear_m3_label: "Mesiac 3",
    fear_m3_title: "AI ich začína odporúčať",
    fear_m3_desc: "ChatGPT a Perplexity teraz predvolene citujú vašu konkurenciu. Vaša návštevnosť klesá.",
    fear_m6_label: "Mesiac 6",
    fear_m6_title: "Ste neviditeľní. Vlastnia váš trh.",
    fear_m6_desc: "AI modely posilňujú to, čo už funguje. Dohnať to teraz stojí 10x viac úsilia a peňazí.",
    fear_urgency: "Každý deň čakania vás stojí zákazníkov",
    fear_cta_h: "Začnite rankovať skôr ako vaša konkurencia",
    fear_cta_sub: "Značky, ktoré rankujú dnes, sa stanú predvolenými AI odporúčaniami zajtra. Uistite sa, že to ste vy.",
    fear_cta_btn: "ZAČAŤ TERAZ",
  },
  cs: {
    pc_tag: "Přestaňte přeplácet za SEO",
    pc_h1: "Nahraďte drahé SEO agentury",
    pc_h1_highlight: "za cenu rodinné večeře",
    pc_sub: "Vyzkoušejte zdarma a začněte rankovat ještě dnes",
    pc_month: "měsíc",
    pc_best_value: "NEJLEPŠÍ HODNOTA",
    pc_agency: "SEO Agentura",
    pc_ads_1: "Potřebujete velký rozpočet",
    pc_ads_2: "Manuální výzkum klíčových slov",
    pc_ads_3: "Optimalizováno na kliknutí, ne na prodeje",
    pc_ads_4: "Pronajatá návštěvnost",
    pc_ads_5: "Konkurenti vás přeplatí",
    pc_ads_6: "Návštěvnost se zastaví když přestanete platit",
    pc_ads_7: "€0 v trvalých výsledcích",
    pc_trp_1: "AI píše kvalitní denní obsah", pc_trp_2: "Automatický výzkum klíčových slov",
    pc_trp_3: "Kvalitní zpětné odkazy zahrnuty", pc_trp_4: "Žádné smlouvy — zrušte kdykoliv",
    pc_trp_5: "Rankujte jednou, návštěvnost navždy", pc_trp_6: "Nepotřebujete technické znalosti",
    pc_trp_7: "Přitahujeme kupující, ne náhodnou návštěvnost",
    pc_cta: "ZAČÍT ZDARMA", pc_save_title: "Ušetřete 20+ hodin a €2 000+/měsíc",
    pc_save_sub: "Přejděte z agentur nebo Google Ads na TopRankPulse.", pc_save_cta: "ZOBRAZIT PLÁNY",
    pc_ag_1: "Měsíce čekání na výsledky", pc_ag_2: "Týdenní schůzky", pc_ag_3: "Vázáni ve smlouvách",
    pc_ag_4: "2 články/měsíc za €2 300", pc_ag_5: "Vlastní vše oni", pc_ag_6: "Návštěvnost +200%, Prodeje 0%",
    pc_ag_7: "Žádná AI optimalizace viditelnosti",
    fear_warning: "VAROVÁNÍ", fear_h1: "AI doporučuje značky", fear_h1_2: "které rankují", fear_h1_highlight: "DNES",
    fear_desc: "ChatGPT, Gemini a Perplexity berou odpovědi z nejlépe rankujících stránek. Pokud nerankujete teď, AI bude doporučovat vaši konkurenci.",
    fear_m1_label: "Měsíc 1", fear_m1_title: "Vaše konkurence publikuje obsah",
    fear_m1_desc: "Zatímco vy čekáte, oni budují SEO autoritu.",
    fear_m3_label: "Měsíc 3", fear_m3_title: "AI je začíná doporučovat",
    fear_m3_desc: "ChatGPT nyní standardně cituje vaši konkurenci.",
    fear_m6_label: "Měsíc 6", fear_m6_title: "Jste neviditelní. Vlastní váš trh.",
    fear_m6_desc: "AI modely posilují to, co už funguje. Dohnat to stojí 10x více.",
    fear_urgency: "Každý den čekání vás stojí zákazníky",
    fear_cta_h: "Začněte rankovat dříve než vaše konkurence",
    fear_cta_sub: "Značky rankující dnes se stanou výchozími AI doporučeními zítra.",
    fear_cta_btn: "ZAČÍT TEĎ",
    // Brand Monitor
    bm_no_monitors: "Zatím nemonitorujete žádnou značku", bm_no_monitors_desc: "Přidejte svou značku a začněte sledovat, jak vás AI vyhledávače vidí.",
    bm_add_brand: "Přidat značku", bm_brand_name: "Název značky", bm_website: "URL webstránky",
    bm_industry: "Odvětví", bm_location: "Lokalita", bm_competitors: "Konkurenti", bm_comma: "oddělené čárkou",
    bm_start: "Začít monitorování", bm_recheck: "Znovu zkontrolovat", bm_overall: "Celková AI viditelnost",
    bm_citation_score: "Skóre citace", bm_recommends: "Doporučuje", bm_not_cited: "Necitováno",
    bm_top_rec: "Hlavní doporučení", bm_query_analysis: "Analýza dotazů", bm_last_checked: "Poslední kontrola",
    bm_loading: "Analyzuji AI viditelnost...", bm_recommendations: "Jak zvýšit vaši viditelnost",
    bm_high: "Vysoký dopad", bm_medium: "Střední", bm_low: "Nízký",
    bm_vis_up: "Viditelnost stoupla od poslední kontroly", bm_vis_down: "Viditelnost klesla od poslední kontroly",
    // Attribution
    attr_desc: "Podívejte se přesně kolik návštěvnosti vám AI vyhledávače přinášejí",
    attr_setup: "Nastavit atribuci", attr_demo: "Demo data — nainstalujte sledovací pixel pro reálná čísla",
    attr_visits: "AI návštěvy", attr_conversions: "Konverze", attr_revenue: "Příjmy",
    attr_conv_rate: "Míra konverze", attr_traffic_30: "AI návštěvnost (30 dní)",
    attr_by_source: "Návštěvnost podle AI zdroje", attr_source_details: "Detail zdrojů",
    attr_visits_short: "návštěv", attr_insights: "AI přehledy", attr_pixel: "Sledovací pixel",
    attr_copied: "Zkopírováno", attr_copy: "Kopírovat",
    attr_pixel_desc: "Vložte kód před </head> na vašem webu.", attr_no_sites: "Zatím nesledujete žádný web",
    attr_no_sites_desc: "Přidejte web a zjistěte kolik návštěvnosti vám AI přináší.", attr_add_website: "Přidat web",
    // Local SEO
    ls_stat1: "webů neviditelných pro AI", ls_stat2: "průměr návštěv z AI", ls_stat3: "výsledky auditu zdarma",
    ls_f1_t: "Sledování AI viditelnosti", ls_f1_d: "Zkontrolujte zda ChatGPT, Perplexity a Gemini citují váš web",
    ls_f2_t: "Kompletní SEO audit", ls_f2_d: "Technická analýza s doporučeními",
    ls_f3_t: "Skóre hlasového vyhledávání", ls_f3_d: "Optimalizace pro Siri, Alexu, Google Asistenta",
    ls_f4_t: "GEO optimalizace", ls_f4_d: "Lokální SEO pro",
    ls_f5_t: "Analýza zpětných odkazů", ls_f5_d: "Kontrola dofollow, nofollow a autority domény",
    ls_f6_t: "Rychlost webu", ls_f6_d: "Core Web Vitals a výkonnostní skóre",
    ls_more_cities: "Další města v", ls_top_cities: "Top města v",
    ls_cta_h1: "ZAČNĚTE BEZPLATNÝ", ls_cta_h2: "SEO AUDIT",
    ls_cta_join: "Přidejte se k firmám v", ls_cta_using: "používajícím TopRankPulse.",
    ls_scan: "SKENOVAT VÁŠ WEB", ls_free: "Navždy zdarma", ls_no_card: "Bez kreditní karty", ls_langs: "26 jazyků",
    // Plugin
    pl_f1_t: "Sledování AI viditelnosti", pl_f1_d: "Zkontrolujte zda ChatGPT a Gemini citují váš web",
    pl_f2_t: "Kompletní SEO audit", pl_f2_d: "Technická analýza s doporučeními",
    pl_f3_t: "Výzkum klíčových slov", pl_f3_d: "Najděte lepší klíčová slova",
    pl_f4_t: "Skóre hlasového vyhledávání", pl_f4_d: "Optimalizace pro Siri, Alexu, Google",
    pl_f5_t: "AI doporučení", pl_f5_d: "Kroky ke zlepšení vašeho skóre",
    pl_f6_t: "Widget v dashboardu", pl_f6_d: "SEO skóre přímo ve WordPress",
    pl_f7_t: "Auto-sken při publikování", pl_f7_d: "Automatická analýza nových příspěvků",
    pl_f8_t: "WooCommerce SEO", pl_f8_d: "SEO skóre produktů a Google Shopping",
    pl_f9_t: "Blog Agent (€25)", pl_f9_d: "25 SEO článků se zpětnými odkazy",
    pl_s3_t: "Skenujte váš web", pl_s3_d: "Klikněte 'Skenovat' a za 30 sekund získáte SEO skóre.",
    pl_w1_t: "SEO skóre produktu", pl_w1_d: "Každý produkt dostane real-time SEO skóre.",
    pl_w2_t: "AI generátor popisů", pl_w2_d: "AI generované SEO popisy produktů.",
    pl_w3_t: "Připraveno pro Google Shopping", pl_w3_d: "Schema markup pro Google Shopping.",
  },
  de: {
    pc_tag: "Hören Sie auf, für SEO zu viel zu bezahlen",
    pc_h1: "Ersetzen Sie teure SEO-Agenturen",
    pc_h1_highlight: "zum Preis eines Familienabendessens",
    pc_sub: "Testen Sie kostenlos und starten Sie heute mit dem Ranking",
    pc_month: "Monat", pc_best_value: "BESTES ANGEBOT", pc_agency: "SEO-Agentur",
    pc_ads_1: "Sie brauchen ein großes Budget", pc_ads_2: "Manuelle Keyword-Recherche",
    pc_ads_3: "Optimiert für Klicks, nicht Verkäufe", pc_ads_4: "Gemieteter Traffic",
    pc_ads_5: "Konkurrenten überbieten Sie", pc_ads_6: "Traffic stoppt wenn Sie aufhören zu zahlen",
    pc_ads_7: "€0 in dauerhaften Ergebnissen",
    pc_trp_1: "KI schreibt täglich Qualitätsinhalte", pc_trp_2: "Automatische Keyword-Recherche",
    pc_trp_3: "Qualitäts-Backlinks inklusive", pc_trp_4: "Keine Verträge — jederzeit kündbar",
    pc_trp_5: "Einmal ranken, Traffic für immer", pc_trp_6: "Keine technischen Kenntnisse nötig",
    pc_trp_7: "Bringt Käufer, keinen zufälligen Traffic",
    pc_cta: "KOSTENLOS STARTEN", pc_save_title: "Sparen Sie 20+ Stunden & €2.000+/Monat",
    pc_save_sub: "Wechseln Sie von Agenturen zu TopRankPulse.", pc_save_cta: "PLÄNE ANSEHEN",
    pc_ag_1: "Monate bis zu Ergebnissen", pc_ag_2: "Wöchentliche Meetings",
    pc_ag_3: "In Verträge gebunden", pc_ag_4: "2 Blogbeiträge/Monat für €2.300",
    pc_ag_5: "Alles gehört ihnen", pc_ag_6: "Traffic +200%, Verkäufe 0%",
    pc_ag_7: "Keine KI-Sichtbarkeitsoptimierung",
    fear_warning: "WARNUNG", fear_h1: "KI empfiehlt Marken", fear_h1_2: "die", fear_h1_highlight: "HEUTE ranken",
    fear_desc: "ChatGPT und Gemini ziehen Antworten von Top-Seiten. Wenn Sie nicht jetzt ranken, empfiehlt KI Ihre Konkurrenten.",
    fear_m1_label: "Monat 1", fear_m1_title: "Ihr Wettbewerber veröffentlicht Inhalte",
    fear_m1_desc: "Während Sie warten, bauen sie SEO-Autorität auf.",
    fear_m3_label: "Monat 3", fear_m3_title: "KI empfiehlt sie",
    fear_m3_desc: "ChatGPT zitiert standardmäßig Ihre Konkurrenten.",
    fear_m6_label: "Monat 6", fear_m6_title: "Sie sind unsichtbar.",
    fear_m6_desc: "KI-Modelle verstärken was funktioniert. Aufholen kostet 10x mehr.",
    fear_urgency: "Jeder Tag Warten kostet Sie Kunden",
    fear_cta_h: "Ranken Sie vor Ihren Konkurrenten",
    fear_cta_sub: "Marken die heute ranken werden morgen die Standard-KI-Empfehlungen.",
    fear_cta_btn: "JETZT STARTEN",
    // Brand Monitor
    bm_no_monitors: "Noch keine Marken überwacht", bm_no_monitors_desc: "Fügen Sie Ihre Marke hinzu und verfolgen Sie, wie KI-Suchmaschinen Sie sehen.",
    bm_add_brand: "Marke hinzufügen", bm_brand_name: "Markenname", bm_website: "Website-URL",
    bm_industry: "Branche", bm_location: "Standort", bm_competitors: "Wettbewerber", bm_comma: "kommagetrennt",
    bm_start: "Überwachung starten", bm_recheck: "Erneut prüfen", bm_overall: "Gesamte KI-Sichtbarkeit",
    bm_citation_score: "Zitierungsscore", bm_recommends: "Empfiehlt", bm_not_cited: "Nicht zitiert",
    bm_top_rec: "Top-Empfehlung", bm_query_analysis: "Abfrageanalyse", bm_last_checked: "Zuletzt geprüft",
    bm_loading: "Analysiere KI-Sichtbarkeit...", bm_recommendations: "So erhöhen Sie Ihre Sichtbarkeit",
    bm_high: "Hohe Wirkung", bm_medium: "Mittel", bm_low: "Niedrig",
    bm_vis_up: "Sichtbarkeit seit letzter Prüfung gestiegen", bm_vis_down: "Sichtbarkeit seit letzter Prüfung gesunken",
    // Attribution
    attr_desc: "Sehen Sie genau, wie viel Traffic KI-Suchmaschinen bringen",
    attr_setup: "Attribution einrichten", attr_demo: "Demo-Daten — installieren Sie das Tracking-Pixel",
    attr_visits: "KI-Besuche", attr_conversions: "Konversionen", attr_revenue: "Umsatz",
    attr_conv_rate: "Konversionsrate", attr_traffic_30: "KI-Traffic (30 Tage)",
    attr_by_source: "Traffic nach KI-Quelle", attr_source_details: "Quellendetails",
    attr_visits_short: "Besuche", attr_insights: "KI-Einblicke", attr_pixel: "Tracking-Pixel",
    attr_copied: "Kopiert", attr_copy: "Kopieren",
    attr_no_sites: "Noch keine Websites verfolgt", attr_add_website: "Website hinzufügen",
    // Local SEO
    ls_stat1: "Websites für KI unsichtbar", ls_stat2: "Ø Besuche aus KI-Suche", ls_stat3: "kostenlose Audit-Ergebnisse",
    ls_f1_t: "KI-Sichtbarkeit", ls_f1_d: "Prüfen Sie ob ChatGPT und Gemini Ihre Website zitieren",
    ls_f2_t: "Komplettes SEO-Audit", ls_f2_d: "Technische Analyse mit Empfehlungen",
    ls_f3_t: "Sprachsuche-Score", ls_f3_d: "Optimierung für Siri, Alexa, Google",
    ls_f4_t: "GEO-Optimierung", ls_f4_d: "Lokales SEO für",
    ls_f5_t: "Backlink-Analyse", ls_f5_d: "Dofollow, Nofollow & Domain-Autorität",
    ls_f6_t: "Seitengeschwindigkeit", ls_f6_d: "Core Web Vitals & Performance",
    ls_more_cities: "Weitere Städte in", ls_top_cities: "Top-Städte in",
    ls_cta_h1: "STARTEN SIE IHR KOSTENLOSES", ls_cta_h2: "SEO-AUDIT",
    ls_scan: "WEBSITE SCANNEN", ls_free: "Für immer kostenlos", ls_no_card: "Keine Kreditkarte", ls_langs: "26 Sprachen",
    // Plugin
    pl_f1_t: "KI-Sichtbarkeit", pl_f2_t: "Komplettes SEO-Audit", pl_f3_t: "Keyword-Recherche",
    pl_f4_t: "Sprachsuche-Score", pl_f5_t: "KI-Empfehlungen", pl_f6_t: "Dashboard-Widget",
    pl_f7_t: "Auto-Scan bei Veröffentlichung", pl_f8_t: "WooCommerce SEO", pl_f9_t: "Blog Agent (€25)",
    pl_s3_t: "Scannen Sie Ihre Website", pl_w1_t: "Produkt-SEO-Score", pl_w2_t: "KI-Beschreibungsgenerator", pl_w3_t: "Google Shopping bereit",
  },
  pl: {
    pc_tag: "Przestań przepłacać za SEO", pc_h1: "Zastąp drogie agencje SEO", pc_h1_highlight: "za cenę rodzinnej kolacji",
    pc_month: "miesiąc", pc_best_value: "NAJLEPSZA WARTOŚĆ", pc_agency: "Agencja SEO",
    pc_ads_1: "Potrzebujesz dużego budżetu", pc_ads_2: "Ręczne wyszukiwanie słów kluczowych", pc_ads_3: "Zoptymalizowane pod kliknięcia", pc_ads_4: "Wynajęty ruch", pc_ads_5: "Konkurencja cię przebija", pc_ads_6: "Ruch się zatrzymuje gdy przestajesz płacić", pc_ads_7: "€0 trwałych wyników",
    pc_trp_1: "AI pisze jakościowe treści codziennie", pc_trp_2: "Automatyczne wyszukiwanie słów kluczowych", pc_trp_3: "Jakościowe linki zwrotne w zestawie", pc_trp_4: "Bez umów — anuluj kiedy chcesz", pc_trp_5: "Rankuj raz, ruch na zawsze", pc_trp_6: "Nie potrzebujesz wiedzy technicznej", pc_trp_7: "Przyciągamy kupujących",
    pc_cta: "ZACZNIJ ZA DARMO", pc_sub: "Wypróbuj za darmo i zacznij rankować już dziś",
    pc_save_title: "Oszczędź 20+ godzin i €2 000+/miesiąc", pc_save_cta: "ZOBACZ PLANY",
    pc_ag_1: "Miesiące czekania", pc_ag_2: "Cotygodniowe spotkania", pc_ag_3: "Związani umowami", pc_ag_4: "2 artykuły za €2 300", pc_ag_5: "Wszystko należy do nich", pc_ag_6: "Ruch +200%, Sprzedaż 0%", pc_ag_7: "Brak optymalizacji AI",
    fear_warning: "OSTRZEŻENIE", fear_h1: "AI rekomenduje marki", fear_h1_2: "które rankują", fear_h1_highlight: "DZIŚ",
    fear_desc: "ChatGPT i Gemini biorą odpowiedzi z najlepiej rankujących stron. Jeśli nie rankujesz teraz, AI będzie polecać twoją konkurencję.",
    fear_m1_label: "Miesiąc 1", fear_m1_title: "Twoja konkurencja publikuje treści", fear_m1_desc: "Budują autorytet SEO.",
    fear_m3_label: "Miesiąc 3", fear_m3_title: "AI zaczyna ich polecać", fear_m3_desc: "ChatGPT cytuje twoją konkurencję.",
    fear_m6_label: "Miesiąc 6", fear_m6_title: "Jesteś niewidoczny.", fear_m6_desc: "Nadrobienie kosztuje 10x więcej.",
    fear_urgency: "Każdy dzień czekania kosztuje cię klientów", fear_cta_h: "Zacznij rankować przed konkurencją",
    fear_cta_sub: "Marki rankujące dziś staną się domyślnymi rekomendacjami AI jutro.", fear_cta_btn: "ZACZNIJ TERAZ",
    bm_no_monitors: "Brak monitorowanych marek", bm_add_brand: "Dodaj markę", bm_brand_name: "Nazwa marki", bm_website: "URL strony",
    bm_industry: "Branża", bm_location: "Lokalizacja", bm_competitors: "Konkurenci", bm_comma: "oddzielone przecinkami",
    bm_start: "Rozpocznij monitorowanie", bm_recheck: "Sprawdź ponownie", bm_overall: "Ogólna widoczność AI",
    bm_citation_score: "Wynik cytowania", bm_recommends: "Poleca", bm_not_cited: "Nie cytowany",
    bm_recommendations: "Jak zwiększyć widoczność", bm_high: "Wysoki wpływ", bm_medium: "Średni", bm_low: "Niski",
    bm_query_analysis: "Analiza zapytań", bm_last_checked: "Ostatnio sprawdzono", bm_loading: "Analizuję widoczność AI...",
    attr_visits: "Wizyty AI", attr_conversions: "Konwersje", attr_revenue: "Przychody", attr_conv_rate: "Współczynnik konwersji",
    attr_traffic_30: "Ruch AI (30 dni)", attr_by_source: "Ruch według źródła AI", attr_insights: "Wgląd AI",
    attr_no_sites: "Brak śledzonych stron", attr_add_website: "Dodaj stronę",
    ls_f1_t: "Śledzenie widoczności AI", ls_f2_t: "Kompletny audyt SEO", ls_f3_t: "Wynik wyszukiwania głosowego",
    ls_f4_t: "Optymalizacja GEO", ls_f5_t: "Analiza linków zwrotnych", ls_f6_t: "Szybkość strony",
    ls_scan: "SKANUJ SWOJĄ STRONĘ", ls_free: "Na zawsze za darmo", ls_no_card: "Bez karty kredytowej", ls_langs: "26 języków",
  },
  hu: {
    pc_tag: "Ne fizessen túl az SEO-ért", pc_h1: "Cserélje le a drága SEO ügynökségeket", pc_h1_highlight: "egy családi vacsora áráért",
    pc_month: "hónap", pc_best_value: "LEGJOBB ÉRTÉK", pc_agency: "SEO Ügynökség",
    pc_ads_1: "Nagy költségvetés kell", pc_ads_2: "Manuális kulcsszó kutatás", pc_ads_3: "Kattintásra optimalizálva", pc_ads_4: "Bérelt forgalom", pc_ads_5: "Versenytársak túllicitálnak", pc_ads_6: "Forgalom leáll ha nem fizet", pc_ads_7: "€0 tartós eredmény",
    pc_trp_1: "AI minőségi napi tartalmat ír", pc_trp_2: "Automatikus kulcsszó kutatás", pc_trp_3: "Minőségi visszahivatkozások", pc_trp_4: "Nincs szerződés — bármikor lemondható", pc_trp_5: "Egyszer rangsorol, örökké forgalom", pc_trp_6: "Nincs szükség technikai tudásra", pc_trp_7: "Vevőket hoz, nem véletlenszerű forgalmat",
    pc_cta: "INDÍTÁS INGYEN", pc_sub: "Próbálja ki ingyen és kezdjen el rangsorolni még ma",
    pc_save_title: "Spóroljon 20+ órát és €2 000+/hó", pc_save_cta: "TERVEK MEGTEKINTÉSE",
    pc_ag_1: "Hónapok az eredményekig", pc_ag_2: "Heti megbeszélések", pc_ag_3: "Szerződésekhez kötve", pc_ag_4: "2 cikk €2 300-ért", pc_ag_5: "Minden az övék", pc_ag_6: "Forgalom +200%, Eladás 0%", pc_ag_7: "Nincs AI optimalizáció",
    fear_warning: "FIGYELEM", fear_h1: "Az AI márkákat ajánl", fear_h1_2: "amelyek", fear_h1_highlight: "MA rangsorolnak",
    fear_desc: "A ChatGPT és Gemini a legjobban rangsorolt oldalakból merít. Ha most nem rangsorol, az AI a versenytársait ajánlja.",
    fear_m1_label: "1. hónap", fear_m1_title: "Versenytársa tartalmat publikál", fear_m3_label: "3. hónap", fear_m3_title: "AI elkezdi ajánlani őket",
    fear_m6_label: "6. hónap", fear_m6_title: "Ön láthatatlan.", fear_urgency: "Minden nap várakozás ügyfelekbe kerül",
    fear_cta_h: "Rangsoroljon a versenytársai előtt", fear_cta_btn: "KEZDJE MOST",
    bm_add_brand: "Márka hozzáadása", bm_overall: "Összesített AI láthatóság", bm_recheck: "Újra ellenőrzés",
    bm_recommendations: "Hogyan növelje a láthatóságot", bm_high: "Magas hatás", bm_medium: "Közepes", bm_low: "Alacsony",
    attr_visits: "AI látogatások", attr_conversions: "Konverziók", attr_revenue: "Bevétel",
    ls_scan: "WEBHELY SZKENNELÉSE", ls_free: "Örökre ingyenes", ls_no_card: "Bankkártya nélkül", ls_langs: "26 nyelv",
  },
  fr: {
    pc_tag: "Arrêtez de surpayer le SEO", pc_h1: "Remplacez les agences SEO coûteuses", pc_h1_highlight: "pour le prix d'un dîner en famille",
    pc_month: "mois", pc_best_value: "MEILLEUR RAPPORT", pc_agency: "Agence SEO",
    pc_ads_1: "Gros budget nécessaire", pc_ads_2: "Recherche manuelle de mots-clés", pc_ads_3: "Optimisé pour les clics", pc_ads_4: "Trafic loué", pc_ads_5: "Les concurrents surenchérissent", pc_ads_6: "Le trafic s'arrête quand vous arrêtez de payer", pc_ads_7: "€0 de résultats durables",
    pc_trp_1: "L'IA écrit du contenu de qualité chaque jour", pc_trp_2: "Recherche automatique de mots-clés", pc_trp_3: "Backlinks de qualité inclus", pc_trp_4: "Sans contrat — annulez quand vous voulez", pc_trp_5: "Classez une fois, trafic pour toujours", pc_trp_6: "Aucune connaissance technique requise", pc_trp_7: "Attire des acheteurs, pas du trafic aléatoire",
    pc_cta: "ESSAYER GRATUITEMENT", pc_save_title: "Économisez 20+ heures et €2 000+/mois", pc_save_cta: "VOIR LES PLANS",
    pc_ag_1: "Des mois pour voir les résultats", pc_ag_2: "Réunions hebdomadaires", pc_ag_3: "Liés par contrat", pc_ag_4: "2 articles pour €2 300", pc_ag_5: "Tout leur appartient", pc_ag_6: "Trafic +200%, Ventes 0%", pc_ag_7: "Aucune optimisation IA",
    fear_warning: "ATTENTION", fear_h1: "L'IA recommande les marques", fear_h1_2: "qui sont classées", fear_h1_highlight: "AUJOURD'HUI",
    fear_desc: "ChatGPT et Gemini puisent dans les pages les mieux classées. Si vous ne vous classez pas maintenant, l'IA recommandera vos concurrents.",
    fear_m1_label: "Mois 1", fear_m1_title: "Vos concurrents publient du contenu", fear_m3_label: "Mois 3", fear_m3_title: "L'IA commence à les recommander",
    fear_m6_label: "Mois 6", fear_m6_title: "Vous êtes invisible.", fear_urgency: "Chaque jour d'attente vous coûte des clients",
    fear_cta_h: "Classez-vous avant vos concurrents", fear_cta_sub: "Les marques classées aujourd'hui deviennent les recommandations IA par défaut demain.", fear_cta_btn: "COMMENCER MAINTENANT",
    pc_sub: "Essayez gratuitement et commencez à vous classer dès aujourd'hui",
    bm_add_brand: "Ajouter une marque", bm_overall: "Visibilité IA globale", bm_recheck: "Revérifier",
    bm_recommendations: "Comment augmenter votre visibilité", bm_high: "Impact élevé", bm_medium: "Moyen", bm_low: "Faible",
    attr_visits: "Visites IA", attr_conversions: "Conversions", attr_revenue: "Revenus",
    attr_traffic_30: "Trafic IA (30 jours)", attr_insights: "Aperçus IA",
    ls_f1_t: "Suivi de visibilité IA", ls_f2_t: "Audit SEO complet", ls_f3_t: "Score recherche vocale",
    ls_scan: "SCANNER VOTRE SITE", ls_free: "Gratuit pour toujours", ls_no_card: "Sans carte bancaire", ls_langs: "26 langues",
  },
  es: {
    pc_tag: "Deja de pagar de más por SEO", pc_h1: "Reemplaza las costosas agencias SEO", pc_h1_highlight: "por el precio de una cena familiar",
    pc_month: "mes", pc_best_value: "MEJOR VALOR", pc_agency: "Agencia SEO",
    pc_ads_1: "Necesitas un gran presupuesto", pc_ads_2: "Investigación manual de palabras clave", pc_ads_3: "Optimizado para clics", pc_ads_4: "Tráfico alquilado", pc_ads_5: "Los competidores te superan", pc_ads_6: "El tráfico se detiene cuando dejas de pagar", pc_ads_7: "€0 en resultados duraderos",
    pc_trp_1: "La IA escribe contenido de calidad diariamente", pc_trp_2: "Investigación automática de palabras clave", pc_trp_3: "Backlinks de calidad incluidos", pc_trp_4: "Sin contratos — cancela cuando quieras", pc_trp_5: "Posiciónate una vez, tráfico para siempre", pc_trp_6: "Sin conocimientos técnicos necesarios", pc_trp_7: "Atrae compradores, no tráfico aleatorio",
    pc_cta: "EMPEZAR GRATIS", pc_sub: "Prueba gratis y empieza a posicionar hoy",
    pc_save_title: "Ahorra 20+ horas y €2 000+/mes", pc_save_cta: "VER PLANES",
    pc_ag_1: "Meses para ver resultados", pc_ag_2: "Reuniones semanales", pc_ag_3: "Atados a contratos", pc_ag_4: "2 artículos por €2 300", pc_ag_5: "Todo les pertenece", pc_ag_6: "Tráfico +200%, Ventas 0%", pc_ag_7: "Sin optimización IA",
    fear_warning: "ADVERTENCIA", fear_h1: "La IA recomienda marcas", fear_h1_2: "que posicionan", fear_h1_highlight: "HOY",
    fear_desc: "ChatGPT y Gemini obtienen respuestas de las páginas mejor posicionadas. Si no posicionas ahora, la IA recomendará a tu competencia.",
    fear_m1_label: "Mes 1", fear_m1_title: "Tu competencia publica contenido", fear_m3_label: "Mes 3", fear_m3_title: "La IA empieza a recomendarlos",
    fear_m6_label: "Mes 6", fear_m6_title: "Eres invisible.", fear_urgency: "Cada día de espera te cuesta clientes",
    fear_cta_h: "Posiciónate antes que tu competencia", fear_cta_btn: "EMPEZAR AHORA",
    bm_add_brand: "Agregar marca", bm_overall: "Visibilidad IA general", bm_recheck: "Verificar de nuevo",
    bm_recommendations: "Cómo aumentar tu visibilidad", bm_high: "Alto impacto", bm_medium: "Medio", bm_low: "Bajo",
    attr_visits: "Visitas IA", attr_conversions: "Conversiones", attr_revenue: "Ingresos",
    attr_traffic_30: "Tráfico IA (30 días)", attr_insights: "Análisis IA",
    ls_scan: "ESCANEAR TU WEB", ls_free: "Gratis para siempre", ls_no_card: "Sin tarjeta de crédito", ls_langs: "26 idiomas",
  },
  pt: {
    pc_tag: "Pare de pagar caro por SEO", pc_h1: "Substitua agências SEO caras", pc_h1_highlight: "pelo preço de um jantar em família",
    pc_month: "mês", pc_best_value: "MELHOR VALOR", pc_agency: "Agência SEO",
    pc_cta: "COMEÇAR GRÁTIS", pc_sub: "Experimente grátis e comece a ranquear hoje",
    pc_save_title: "Economize 20+ horas e €2 000+/mês", pc_save_cta: "VER PLANOS",
    fear_warning: "AVISO", fear_h1: "A IA recomenda marcas", fear_h1_2: "que estão ranqueadas", fear_h1_highlight: "HOJE",
    fear_cta_h: "Ranqueie antes da concorrência", fear_cta_btn: "COMEÇAR AGORA",
    bm_add_brand: "Adicionar marca", bm_overall: "Visibilidade IA geral", bm_recheck: "Verificar novamente",
    bm_recommendations: "Como aumentar sua visibilidade", bm_high: "Alto impacto", bm_medium: "Médio", bm_low: "Baixo",
    attr_visits: "Visitas IA", attr_conversions: "Conversões", attr_revenue: "Receita",
    ls_scan: "ESCANEAR SEU SITE", ls_free: "Grátis para sempre", ls_no_card: "Sem cartão de crédito", ls_langs: "26 idiomas",
  
    pc_ads_1: "Você precisa de um grande orçamento",
    pc_ads_2: "Pesquisa de palavras-chave manual",
    pc_ads_3: "Otimizado para cliques, não vendas",
    pc_ads_4: "Tráfego alugado",
    pc_ads_5: "Concorrentes superam seu lance",
    pc_ads_6: "O tráfego para quando você para de gastar",
    pc_ads_7: "€0 em resultados duradouros",
    pc_trp_1: "A IA escreve conteúdo diário de qualidade",
    pc_trp_2: "Pesquisa de palavras-chave automática",
    pc_trp_3: "Backlinks de qualidade incluídos",
    pc_trp_4: "Sem contratos — cancele a qualquer momento",
    pc_trp_5: "Classifique uma vez, receba tráfego para sempre",
    pc_trp_6: "Nenhum conhecimento técnico necessário",
    pc_trp_7: "Feito para trazer compradores, não tráfego aleatório",
    pc_ag_1: "Meses para ver resultados",
    pc_ag_2: "Reuniões semanais",
    pc_ag_3: "Presos a contratos",
    pc_ag_4: "2 postagens de blog/mês por €2.300",
    pc_ag_5: "Eles possuem tudo",
    pc_ag_6: "Tráfego aumento de 200%, Vendas 0%",
    pc_ag_7: "Sem otimização de visibilidade em IA",
    pc_save_sub: "Mude de agências ou Google Ads para TopRankPulse e mantenha mais dinheiro no seu bolso.",
    bm_no_monitors: "Nenhuma Marca Monitorada Ainda",
    bm_no_monitors_desc: "Adicione sua marca para começar a rastrear como os buscadores de IA o veem.",
    bm_brand_name: "Nome da Marca",
    bm_website: "URL do Site",
    bm_industry: "Indústria",
    bm_location: "Localização",
    bm_competitors: "Concorrentes",
    bm_comma: "separado por vírgula",
    bm_start: "Começar a Monitorar",
    bm_citation_score: "Pontuação de Citação",
    bm_recommends: "Recomenda",
    bm_not_cited: "Não citado",
    bm_top_rec: "Melhor Recomendação",
    bm_query_analysis: "Análise de Consulta",
    bm_last_checked: "Última verificação",
    bm_loading: "Analisando visibilidade em IA...",
    bm_vis_up: "Visibilidade aumentou desde a última verificação",
    bm_vis_down: "Visibilidade diminuiu desde a última verificação",
    attr_desc: "Veja exatamente quanto tráfego e receita os motores de busca de IA trazem para você",
    attr_setup: "Configurar Atribuição",
    attr_demo: "Dados de demonstração — instale o pixel de rastreamento para ver números reais",
    attr_conv_rate: "Taxa de Conversão",
    attr_traffic_30: "Tráfego de IA (30 Dias)",
    attr_by_source: "Tráfego por Fonte de IA",
    attr_source_details: "Detalhes da Fonte",
    attr_visits_short: "visitas",
    attr_insights: "Insights de IA",
    attr_pixel: "Pixel de Rastreamento",
    attr_copied: "Copiado",
    attr_copy: "Copiar",
    attr_pixel_desc: "Cole isso antes de </head> no seu site para começar a rastrear o tráfego real de IA.",
    attr_no_sites: "Nenhum Site Rastreado Ainda",
    attr_no_sites_desc: "Adicione seu site para ver quanto tráfego os motores de busca de IA trazem para você.",
    attr_add_website: "Adicionar Seu Site",
    ls_stat1: "sites invisíveis para IA",
    ls_stat2: "visitas médias da busca de IA",
    ls_stat3: "resultados de auditoria gratuitos",
    ls_f1_t: "Rastreamento de Visibilidade de IA",
    ls_f1_d: "Verifique se ChatGPT, Perplexity e Gemini citam seu site",
    ls_f2_t: "Auditoria SEO Completa",
    ls_f2_d: "Análise técnica com recomendações acionáveis",
    ls_f3_t: "Pontuação de Busca por Voz",
    ls_f3_d: "Otimize para Siri, Alexa, Google Assistant",
    ls_f4_t: "Otimização GEO",
    ls_f4_d: "SEO Local para",
    ls_f5_t: "Análise de Backlinks",
    ls_f5_d: "Verifique dofollow, nofollow e autoridade de domínio",
    ls_f6_t: "Velocidade do Site",
    ls_f6_d: "Core Web Vitals e pontuação de desempenho",
    ls_more_cities: "Mais cidades em",
    ls_top_cities: "Principais cidades em",
    ls_cta_h1: "COMECE SEU GRÁTIS",
    ls_cta_h2: "AUDITORIA SEO",
    ls_cta_join: "Junte-se a empresas em",
    ls_cta_using: "usando TopRankPulse.",
    pl_f1_t: "Rastreamento de Visibilidade de IA",
    pl_f1_d: "Veja se ChatGPT, Perplexity e Gemini citam seu site",
    pl_f2_t: "Auditoria SEO Completa",
    pl_f2_d: "Análise técnica com recomendações acionáveis",
    pl_f3_t: "Pesquisa de Palavras-chave",
    pl_f3_d: "Encontre melhores palavras-chave com volume, dificuldade e tendências",
    pl_f4_t: "Pontuação de Busca por Voz",
    pl_f4_d: "Otimize para Siri, Alexa, Google Assistant",
    pl_f5_t: "Recomendações de IA",
    pl_f5_d: "Instruções passo a passo para melhorar sua pontuação",
    pl_f6_t: "Widget do Painel",
    pl_f6_d: "Pontuação de SEO diretamente no seu painel do WordPress",
    pl_f7_t: "Auto-Escanear ao Publicar",
    pl_f7_d: "Analisa automaticamente novos posts quando publicados",
    pl_f8_t: "SEO para WooCommerce",
    pl_f8_d: "Pontuações de SEO de produtos, descrições de IA e otimização para Google Shopping",
    pl_f9_t: "Agente de Blog (€25)",
    pl_f9_d: "25 artigos de SEO com backlinks para o seu site",
    pl_s3_t: "Escaneie Seu Site",
    pl_s3_d: "Clique em 'Escanear Agora' e obtenha sua pontuação de SEO + relatório de visibilidade de IA em 30 segundos.",
    pl_w1_t: "Pontuação de SEO do Produto",
    pl_w1_d: "Cada produto recebe uma pontuação de SEO em tempo real.",
    pl_w2_t: "Gerador de Descrições de IA",
    pl_w2_d: "Descrições de produtos geradas por IA com um clique.",
    pl_w3_t: "Pronto para Google Shopping",
    pl_w3_d: "Marcação de esquema de produto aprimorada para Google Shopping.",
    fear_desc: "ChatGPT, Gemini e Perplexity puxam respostas de páginas bem posicionadas. Se você não está ranqueando agora, a IA recomendará seus concorrentes — e fica cada vez mais difícil alcançar.",
    fear_m1_label: "Mês 1",
    fear_m1_title: "Seu concorrente publica conteúdo",
    fear_m1_desc: "Enquanto você espera, eles estão construindo autoridade de SEO e sendo citados pelos motores de IA.",
    fear_m3_label: "Mês 3",
    fear_m3_title: "A IA começa a recomendá-los",
    fear_m3_desc: "ChatGPT e Perplexity agora citam seus concorrentes por padrão. Seu tráfego diminui.",
    fear_m6_label: "Mês 6",
    fear_m6_title: "Você está invisível. Eles dominam seu nicho.",
    fear_m6_desc: "Modelos de IA reforçam o que já funciona. Alcançar agora custa 10 vezes mais esforço e dinheiro.",
    fear_urgency: "A cada dia que você espera, você perde clientes",
    fear_cta_sub: "As marcas que ranqueiam hoje se tornam as recomendações padrão de IA amanhã. Certifique-se de que você é uma delas.",
    pp_start_trial: "Iniciar Teste Grátis",
    pp_download_plugin: "Baixar Plugin",
    pp_ready: "PRONTO PARA",
    pp_start: "COMEÇAR",
    pp_join: "Junte-se a milhares de empresas que usam o TopRankPulse.",
    pp_ai_vis_name: "Rastreamento de Visibilidade em IA",
    pp_ai_vis_tag: "Veja se o ChatGPT, Perplexity e Gemini citam seu site",
    pp_ai_vis_desc: "O Rastreamento de Visibilidade em IA monitora se os principais motores de busca em IA do mundo — ChatGPT, Perplexity, Gemini e Copilot — mencionam seu site quando os usuários fazem perguntas relevantes.",
    pp_ai_vis_f1: "Monitoramento de citações em tempo real em 4 motores de IA",
    pp_ai_vis_f2: "Relatórios semanais de tendência de visibilidade",
    pp_ai_vis_f3: "Comparação de citações de concorrentes",
    pp_ai_vis_f4: "Pontuação de prontidão para pesquisa por voz",
    pp_ai_vis_f5: "Recomendações de conteúdo otimizadas para IA",
    pp_ai_vis_f6: "Suporte em 26 idiomas com detecção automática",
    pp_seo_name: "Auditoria Completa de SEO",
    pp_seo_tag: "Análise técnica de SEO com recomendações impulsionadas por IA",
    pp_seo_desc: "Nossa Auditoria Completa de SEO analisa mais de 50 fatores de classificação, incluindo SEO técnico, qualidade do conteúdo, backlinks, velocidade da página, otimização para dispositivos móveis e prontidão para IA.",
    pp_seo_f1: "Mais de 50 fatores de classificação analisados",
    pp_seo_f2: "Verificações de SEO técnico (meta tags, cabeçalhos, schema)",
    pp_seo_f3: "Pontuação de qualidade do conteúdo",
    pp_seo_f4: "Análise do perfil de backlinks",
    pp_seo_f5: "Avaliação dos Core Web Vitals",
    pp_seo_f6: "Dicas de otimização para mobile-first",
    pp_seo_f7: "Pontuação de prontidão para IA",
    pp_seo_f8: "Relatório em PDF para download",
    pp_brand_name: "Monitoramento de Marca em IA",
    pp_brand_tag: "Monitoramento 24/7 se os motores de busca em IA mencionam sua marca",
    pp_brand_f1: "Monitoramento 24/7 em 4 motores de IA",
    pp_brand_f2: "Alertas de citações em tempo real via email",
    pp_brand_f3: "Comparação de benchmark de concorrentes",
    pp_brand_f4: "Monitoramento de tendências históricas com gráficos",
    pp_brand_f5: "Análise em nível de consulta",
    pp_brand_f6: "Recomendações de otimização acionáveis de IA",
    pp_comp_name: "Espião de Concorrentes em IA",
    pp_comp_tag: "Inteligência competitiva em tempo real impulsionada por IA",
    pp_comp_f1: "Monitoramento de SEO de concorrentes em tempo real",
    pp_comp_f2: "Alertas de mudanças de conteúdo",
    pp_comp_f3: "Rastreamento de aquisição de backlinks",
    pp_comp_f4: "Comparação de visibilidade em IA",
    pp_comp_f5: "Análise de força/fraca",
    pp_comp_f6: "Identificação de oportunidades",
    pp_comp_f7: "Alertas prioritários para mudanças de alto impacto",
    pp_blog_name: "Agente de Blog",
    pp_blog_tag: "25 artigos de SEO com 4 backlinks cada — escritos por IA, publicados diariamente",
    pp_blog_f1: "25 artigos únicos otimizados para SEO",
    pp_blog_f2: "Publicado 1 por dia durante 25 dias",
    pp_blog_f3: "4 backlinks dofollow por artigo",
    pp_blog_f4: "Traduzido automaticamente em 26 idiomas",
    pp_blog_f5: "Pesquisa de tópicos baseada na sua indústria",
    pp_blog_f6: "Conteúdo longo (mais de 1.500 palavras)",
    pp_blog_f7: "Estrutura de links internos",
    pp_blog_f8: "Markup de Schema incluído",
    pp_wp_name: "Plugin WordPress + WooCommerce",
    pp_wp_tag: "Plugin SEO gratuito com acompanhamento de visibilidade de IA integrado",
    pp_auto_name: "Piloto Automático de SEO",
    pp_auto_tag: "A IA corrige automaticamente seu SEO — não apenas recomendações",
    pp_auto_desc: "O Piloto Automático de SEO não apenas diz o que corrigir — ele corrige para você. Nossa IA gera automaticamente títulos, descrições, textos alternativos de imagens, links internos e seções de perguntas frequentes otimizados. Funciona com WordPress e Shopify através de nossos plugins.",
    pp_auto_f1: "Geração automática de títulos e descrições meta de SEO",
    pp_auto_f2: "Geração automática de textos alternativos de imagens",
    pp_auto_f3: "Sugestões inteligentes de links internos",
    pp_auto_f4: "Geração de seção de FAQ com markup de schema",
    pp_auto_f5: "Detecção de links quebrados e sugestões de redirecionamento",
    pp_auto_f6: "Escaneamentos automatizados semanais",
    pp_auto_f7: "Integração com plugins WordPress e Shopify",
    pp_auto_f8: "Acompanhamento de pontuação antes/depois",
    pp_sim_name: "Simulador de Busca de IA",
    pp_sim_tag: "Veja o que ChatGPT, Perplexity e Gemini responderiam — gratuitamente",
    pp_sim_desc: "O Simulador de Busca de IA permite que você digite qualquer pergunta e veja respostas simuladas de ChatGPT, Perplexity, Gemini e Copilot. Descubra se seu site seria mencionado nos resultados de busca de IA.",
    pp_sim_f1: "Simular respostas de busca de IA de 4 motores",
    pp_sim_f2: "Verifique se seu site é citado",
    pp_sim_f3: "Teste qualquer palavra-chave ou pergunta",
    pp_sim_f4: "Consultas gratuitas ilimitadas",
    pp_sim_f5: "Suporte para 26 idiomas",
    pp_blog_desc: "O Blog Agent escreve 25 artigos otimizados para SEO para seu site — um por dia durante 25 dias. Cada artigo inclui 4 backlinks dofollow, é traduzido automaticamente em 26 idiomas e publicado conforme programado.",
    pp_brand_desc: "O Monitoramento de Marca de IA rastreia se ChatGPT, Perplexity, Gemini e Copilot mencionam sua marca quando os usuários fazem perguntas relevantes. Receba alertas em tempo real e faça comparações com concorrentes.",
    pp_comp_desc: "O Espião de Concorrente de IA monitora as estratégias de SEO de seus concorrentes em tempo real. Receba alertas quando publicarem novo conteúdo, adquirirem backlinks ou melhorarem sua pontuação de visibilidade de IA.",
    pp_wp_desc: "Nosso plugin gratuito para WordPress traz o TopRankPulse diretamente para o seu admin do WordPress. Obtenha pontuações de SEO, acompanhamento de visibilidade de IA e correções com um clique sem sair do seu painel.",
    pp_wp_f1: "Correções de SEO com um clique no admin do WordPress",
    pp_wp_f2: "Acompanhamento de visibilidade de IA integrado",
    pp_wp_f3: "Otimização de SEO para produtos WooCommerce",
    pp_wp_f4: "Markup de schema automático",
    pp_wp_f5: "Gratuito para sempre para todos os planos",
  },
  it: {
    pc_tag: "Smetti di strapagare per la SEO", pc_h1: "Sostituisci le costose agenzie SEO", pc_h1_highlight: "al prezzo di una cena in famiglia",
    pc_month: "mese", pc_best_value: "MIGLIOR VALORE", pc_agency: "Agenzia SEO",
    pc_cta: "INIZIA GRATIS", pc_sub: "Prova gratis e inizia a posizionarti oggi",
    pc_save_title: "Risparmia 20+ ore e €2 000+/mese", pc_save_cta: "VEDI PIANI",
    fear_warning: "ATTENZIONE", fear_h1: "L'IA raccomanda i marchi", fear_h1_2: "che si posizionano", fear_h1_highlight: "OGGI",
    fear_cta_h: "Posizionati prima dei concorrenti", fear_cta_btn: "INIZIA ORA",
    bm_add_brand: "Aggiungi marchio", bm_overall: "Visibilità IA complessiva", bm_recheck: "Ricontrolla",
    bm_recommendations: "Come aumentare la visibilità", bm_high: "Alto impatto", bm_medium: "Medio", bm_low: "Basso",
    attr_visits: "Visite IA", attr_conversions: "Conversioni", attr_revenue: "Entrate",
    ls_scan: "SCANSIONA IL TUO SITO", ls_free: "Gratis per sempre", ls_no_card: "Senza carta di credito", ls_langs: "26 lingue",
  
    pc_ads_1: "Hai bisogno di un budget elevato",
    pc_ads_2: "Ricerca manuale delle parole chiave",
    pc_ads_3: "Ottimizzato per i clic, non per le vendite",
    pc_ads_4: "Traffico a pagamento",
    pc_ads_5: "I concorrenti ti superano",
    pc_ads_6: "Il traffico si ferma quando smetti di spendere",
    pc_ads_7: "€0 in risultati duraturi",
    pc_trp_1: "L'AI scrive contenuti di qualità ogni giorno",
    pc_trp_2: "Ricerca automatica delle parole chiave",
    pc_trp_3: "Backlink di qualità inclusi",
    pc_trp_4: "Nessun contratto — cancella in qualsiasi momento",
    pc_trp_5: "Posizionati una volta, ricevi traffico per sempre",
    pc_trp_6: "Nessuna conoscenza tecnica necessaria",
    pc_trp_7: "Progettato per portare acquirenti, non traffico casuale",
    pc_ag_1: "Mesi per vedere risultati",
    pc_ag_2: "Riunioni settimanali",
    pc_ag_3: "Vincolati ai contratti",
    pc_ag_4: "2 post sul blog/mese per €2.300",
    pc_ag_5: "Possiedono tutto",
    pc_ag_6: "Traffico +200%, Vendite 0%",
    pc_ag_7: "Nessuna ottimizzazione della visibilità AI",
    pc_save_sub: "Passa da agenzie o Google Ads a TopRankPulse e mantieni più denaro nella tua tasca.",
    bm_no_monitors: "Nessun Brand Monitorato Yet",
    bm_no_monitors_desc: "Aggiungi il tuo brand per iniziare a monitorare come ti vedono i motori di ricerca AI.",
    bm_brand_name: "Nome del Brand",
    bm_website: "URL del Sito Web",
    bm_industry: "Settore",
    bm_location: "Posizione",
    bm_competitors: "Concorrenti",
    bm_comma: "separati da virgola",
    bm_start: "Inizia a Monitorare",
    bm_citation_score: "Punteggio di Citazione",
    bm_recommends: "Raccomanda",
    bm_not_cited: "Non citato",
    bm_top_rec: "Migliore Raccomandazione",
    bm_query_analysis: "Analisi della Query",
    bm_last_checked: "Ultimo controllo",
    bm_loading: "Analizzando la visibilità AI...",
    bm_vis_up: "Visibilità aumentata dall'ultimo controllo",
    bm_vis_down: "Visibilità diminuita dall'ultimo controllo",
    attr_desc: "Vedi esattamente quanto traffico e guadagni ti portano i motori di ricerca AI",
    attr_setup: "Imposta Attribuzione",
    attr_demo: "Dati demo — installa il pixel di tracciamento per vedere numeri reali",
    attr_conv_rate: "Tasso di Conv.",
    attr_traffic_30: "Traffico AI (30 Giorni)",
    attr_by_source: "Traffico per Sorgente AI",
    attr_source_details: "Dettagli Sorgente",
    attr_visits_short: "visite",
    attr_insights: "Insight AI",
    attr_pixel: "Pixel di Tracciamento",
    attr_copied: "Copiato",
    attr_copy: "Copia",
    attr_pixel_desc: "Incolla questo prima di </head> sul tuo sito web per iniziare a tracciare il traffico AI reale.",
    attr_no_sites: "Nessun Sito Tracciato Ancora",
    attr_no_sites_desc: "Aggiungi il tuo sito web per vedere quanto traffico ti portano i motori di ricerca AI.",
    attr_add_website: "Aggiungi Il Tuo Sito",
    ls_stat1: "siti invisibili all'AI",
    ls_stat2: "visite medie da ricerca AI",
    ls_stat3: "risultati di audit gratuiti",
    ls_f1_t: "Tracciamento Visibilità AI",
    ls_f1_d: "Controlla se ChatGPT, Perplexity e Gemini citano il tuo sito",
    ls_f2_t: "Audit SEO Completo",
    ls_f2_d: "Analisi tecnica con raccomandazioni applicabili",
    ls_f3_t: "Punteggio Ricerca Vocale",
    ls_f3_d: "Ottimizza per Siri, Alexa, Google Assistant",
    ls_f4_t: "Ottimizzazione GEO",
    ls_f4_d: "SEO Locale per",
    ls_f5_t: "Analisi Backlink",
    ls_f5_d: "Controlla dofollow, nofollow e autorità di dominio",
    ls_f6_t: "Velocità del Sito",
    ls_f6_d: "Core Web Vitals e punteggio di performance",
    ls_more_cities: "Altre città in",
    ls_top_cities: "Città principali in",
    ls_cta_h1: "INIZIA IL TUO GRATIS",
    ls_cta_h2: "AUDIT SEO",
    ls_cta_join: "Unisciti alle aziende in",
    ls_cta_using: "che utilizzano TopRankPulse.",
    pl_f1_t: "Tracciamento Visibilità AI",
    pl_f1_d: "Vedi se ChatGPT, Perplexity e Gemini citano il tuo sito",
    pl_f2_t: "Audit SEO Completo",
    pl_f2_d: "Analisi tecnica con raccomandazioni pratiche",
    pl_f3_t: "Ricerca delle Parole Chiave",
    pl_f3_d: "Trova parole chiave migliori con volume, difficoltà e tendenze",
    pl_f4_t: "Punteggio Ricerca Vocale",
    pl_f4_d: "Ottimizza per Siri, Alexa, Google Assistant",
    pl_f5_t: "Raccomandazioni AI",
    pl_f5_d: "Istruzioni passo per passo per migliorare il tuo punteggio",
    pl_f6_t: "Widget Dashboard",
    pl_f6_d: "Punteggio SEO direttamente nel tuo dashboard di WordPress",
    pl_f7_t: "Analisi Automatica alla Pubblicazione",
    pl_f7_d: "Analizza automaticamente i nuovi post quando pubblicati",
    pl_f8_t: "SEO per WooCommerce",
    pl_f8_d: "Punteggi SEO dei prodotti, descrizioni AI e ottimizzazione per Google Shopping",
    pl_f9_t: "Agente Blog (€25)",
    pl_f9_d: "25 articoli SEO con backlink verso il tuo sito",
    pl_s3_t: "Scansiona il Tuo Sito",
    pl_s3_d: "Clicca su 'Scansiona Ora' e ricevi il tuo punteggio SEO + rapporto di visibilità AI in 30 secondi.",
    pl_w1_t: "Punteggio SEO del Prodotto",
    pl_w1_d: "Ogni prodotto ottiene un punteggio SEO in tempo reale.",
    pl_w2_t: "Generatore di Descrizioni AI",
    pl_w2_d: "Descrizioni di prodotto SEO generate da AI con un clic.",
    pl_w3_t: "Pronto per Google Shopping",
    pl_w3_d: "Markup di schema prodotto migliorato per Google Shopping.",
    fear_desc: "ChatGPT, Gemini e Perplexity estraggono risposte dalle pagine più in alto nelle classifiche. Se non stai classificando ora, l'AI consiglierà i tuoi concorrenti — e sarà sempre più difficile recuperare.",
    fear_m1_label: "Mese 1",
    fear_m1_title: "Il tuo concorrente pubblica contenuti",
    fear_m1_desc: "Mentre aspetti, stanno costruendo autorità SEO e vengono citati dai motori AI.",
    fear_m3_label: "Mese 3",
    fear_m3_title: "L'AI inizia a consigliarli",
    fear_m3_desc: "ChatGPT e Perplexity ora citano i tuoi concorrenti per impostazione predefinita. Il tuo traffico diminuisce.",
    fear_m6_label: "Mese 6",
    fear_m6_title: "Sei invisibile. Loro possiedono la tua nicchia.",
    fear_m6_desc: "I modelli AI rinforzano ciò che funziona già. Recuperare ora costa 10 volte più sforzo e denaro.",
    fear_urgency: "Ogni giorno che aspetti, perdi clienti",
    fear_cta_sub: "I marchi che si classificano oggi diventano le raccomandazioni AI predefinite domani. Assicurati che sia tu.",
    pp_start_trial: "Inizia Prova Gratuita",
    pp_download_plugin: "Scarica Plugin",
    pp_ready: "PRONTO A",
    pp_start: "INIZIARE",
    pp_join: "Unisciti a migliaia di aziende che utilizzano TopRankPulse.",
    pp_ai_vis_name: "Monitoraggio della Visibilità AI",
    pp_ai_vis_tag: "Verifica se ChatGPT, Perplexity e Gemini citano il tuo sito web",
    pp_ai_vis_desc: "Il monitoraggio della visibilità AI verifica se i principali motori di ricerca AI - ChatGPT, Perplexity, Gemini e Copilot - menzionano il tuo sito web quando gli utenti pongono domande pertinenti.",
    pp_ai_vis_f1: "Monitoraggio delle citazioni in tempo reale su 4 motori AI",
    pp_ai_vis_f2: "Report settimanali sulle tendenze di visibilità",
    pp_ai_vis_f3: "Confronto delle citazioni con i concorrenti",
    pp_ai_vis_f4: "Punteggio di prontezza alla ricerca vocale",
    pp_ai_vis_f5: "Raccomandazioni di contenuto ottimizzate per l'AI",
    pp_ai_vis_f6: "Supporto in 26 lingue con auto-rilevamento",
    pp_seo_name: "Audit SEO Completo",
    pp_seo_tag: "Analisi SEO tecnica con raccomandazioni basate su AI",
    pp_seo_desc: "Il nostro Audit SEO Completo analizza oltre 50 fattori di ranking, inclusi SEO tecnico, qualità dei contenuti, backlink, velocità della pagina, ottimizzazione mobile e prontezza per l'AI.",
    pp_seo_f1: "Oltre 50 fattori di ranking analizzati",
    pp_seo_f2: "Controlli SEO tecnici (meta tag, intestazioni, schema)",
    pp_seo_f3: "Valutazione della qualità dei contenuti",
    pp_seo_f4: "Analisi del profilo backlink",
    pp_seo_f5: "Valutazione dei Core Web Vitals",
    pp_seo_f6: "Suggerimenti per l'ottimizzazione mobile-first",
    pp_seo_f7: "Punteggio di prontezza all'AI",
    pp_seo_f8: "Report PDF scaricabile",
    pp_brand_name: "Monitoraggio del Marchio AI",
    pp_brand_tag: "Monitoraggio 24/7 se i motori di ricerca AI menzionano il tuo marchio",
    pp_brand_f1: "Monitoraggio 24/7 su 4 motori AI",
    pp_brand_f2: "Avvisi di citazione in tempo reale via email",
    pp_brand_f3: "Confronto benchmark con i concorrenti",
    pp_brand_f4: "Monitoraggio delle tendenze storiche con grafici",
    pp_brand_f5: "Analisi a livello di query",
    pp_brand_f6: "Raccomandazioni di ottimizzazione AI applicabili",
    pp_comp_name: "AI Competitor Spy",
    pp_comp_tag: "Intelligence competitiva in tempo reale alimentata da AI",
    pp_comp_f1: "Monitoraggio SEO dei concorrenti in tempo reale",
    pp_comp_f2: "Avvisi di modifica dei contenuti",
    pp_comp_f3: "Monitoraggio dell'acquisizione di backlink",
    pp_comp_f4: "Confronto della visibilità AI",
    pp_comp_f5: "Analisi di punti di forza/debolezze",
    pp_comp_f6: "Identificazione delle opportunità",
    pp_comp_f7: "Avvisi prioritari per cambiamenti ad alto impatto",
    pp_blog_name: "Blog Agent",
    pp_blog_tag: "25 articoli SEO con 4 backlink ciascuno — scritti da AI, pubblicati quotidianamente",
    pp_blog_f1: "25 articoli unici ottimizzati per SEO",
    pp_blog_f2: "Pubblicato 1 al giorno per 25 giorni",
    pp_blog_f3: "4 backlink dofollow per articolo",
    pp_blog_f4: "Tradotto automaticamente in 26 lingue",
    pp_blog_f5: "Ricerca argomenti basata sulla tua industria",
    pp_blog_f6: "Contenuti long-form (oltre 1.500 parole)",
    pp_blog_f7: "Struttura di linking interna",
    pp_blog_f8: "Schema markup incluso",
    pp_wp_name: "Plugin WordPress + WooCommerce",
    pp_wp_tag: "Plugin SEO gratuito con tracciamento della visibilità AI integrato",
    pp_auto_name: "SEO Autopilot",
    pp_auto_tag: "L'AI corregge automaticamente il tuo SEO — non solo raccomandazioni",
    pp_auto_desc: "SEO Autopilot non ti dice solo cosa correggere — lo fa per te. La nostra AI genera automaticamente titoli meta ottimizzati, descrizioni, testi alternativi delle immagini, link interni e sezioni FAQ. Funziona con WordPress e Shopify tramite i nostri plugin.",
    pp_auto_f1: "Genera automaticamente titoli e descrizioni SEO",
    pp_auto_f2: "Genera automaticamente testi alternativi per le immagini",
    pp_auto_f3: "Suggerimenti per linking interno intelligenti",
    pp_auto_f4: "Generazione di sezioni FAQ con schema markup",
    pp_auto_f5: "Rilevamento di link interrotti e suggerimenti di redirect",
    pp_auto_f6: "Scansioni settimanali automatiche",
    pp_auto_f7: "Integrazione del plugin WordPress e Shopify",
    pp_auto_f8: "Tracciamento dei punteggi prima/dopo",
    pp_sim_name: "Simulatori di Ricerca AI",
    pp_sim_tag: "Scopri cosa risponderebbero ChatGPT, Perplexity e Gemini — gratis",
    pp_sim_desc: "Il Simulatore di Ricerca AI ti consente di digitare qualsiasi domanda e vedere risposte simulate da ChatGPT, Perplexity, Gemini e Copilot. Scopri se il tuo sito web sarebbe citato nei risultati di ricerca AI.",
    pp_sim_f1: "Simula risposte di ricerca AI da 4 motori",
    pp_sim_f2: "Controlla se il tuo sito web viene citato",
    pp_sim_f3: "Testa qualsiasi parola chiave o domanda",
    pp_sim_f4: "Richieste illimitate gratuite",
    pp_sim_f5: "Supporto per 26 lingue",
    pp_blog_desc: "Blog Agent scrive 25 articoli ottimizzati per SEO per il tuo sito web — uno al giorno per 25 giorni. Ogni articolo include 4 backlink dofollow, è tradotto automaticamente in 26 lingue e pubblicato secondo il programma.",
    pp_brand_desc: "AI Brand Monitoring tiene traccia di se ChatGPT, Perplexity, Gemini e Copilot menzionano il tuo marchio quando gli utenti pongono domande rilevanti. Ricevi avvisi in tempo reale e confrontati con i concorrenti.",
    pp_comp_desc: "AI Competitor Spy monitora le strategie SEO dei tuoi concorrenti in tempo reale. Ricevi avvisi quando pubblicano nuovi contenuti, acquisiscono backlink o migliorano il punteggio di visibilità AI.",
    pp_wp_desc: "Il nostro plugin gratuito per WordPress porta TopRankPulse direttamente nella tua amministrazione di WordPress. Ottieni punteggi SEO, tracciamento della visibilità AI e correzioni con un clic senza lasciare la tua dashboard.",
    pp_wp_f1: "Correzioni SEO con un clic dall'amministrazione di WordPress",
    pp_wp_f2: "Tracciamento della visibilità AI integrato",
    pp_wp_f3: "Ottimizzazione SEO per i prodotti WooCommerce",
    pp_wp_f4: "Schema markup automatico",
    pp_wp_f5: "Gratuito per sempre per tutti i piani",
  },
  nl: {
    pc_tag: "Stop met teveel betalen voor SEO", pc_h1: "Vervang dure SEO-bureaus", pc_h1_highlight: "voor de prijs van een familiediner",
    pc_month: "maand", pc_best_value: "BESTE WAARDE", pc_agency: "SEO Bureau",
    pc_cta: "GRATIS BEGINNEN", pc_sub: "Probeer gratis en start vandaag met ranken",
    pc_save_title: "Bespaar 20+ uur en €2 000+/maand", pc_save_cta: "PLANNEN BEKIJKEN",
    fear_warning: "WAARSCHUWING", fear_h1: "AI beveelt merken aan", fear_h1_2: "die", fear_h1_highlight: "VANDAAG ranken",
    fear_cta_h: "Rank voor uw concurrenten", fear_cta_btn: "NU BEGINNEN",
    bm_add_brand: "Merk toevoegen", bm_overall: "Totale AI-zichtbaarheid", bm_recheck: "Opnieuw controleren",
    bm_recommendations: "Hoe uw zichtbaarheid te verhogen", bm_high: "Hoge impact", bm_medium: "Gemiddeld", bm_low: "Laag",
    attr_visits: "AI-bezoeken", attr_conversions: "Conversies", attr_revenue: "Omzet",
    ls_scan: "SCAN UW WEBSITE", ls_free: "Voor altijd gratis", ls_no_card: "Geen creditcard", ls_langs: "26 talen",
  
    pc_ads_1: "Je hebt een groot budget nodig",
    pc_ads_2: "Handmatig zoekwoordonderzoek",
    pc_ads_3: "Geoptimaliseerd voor klikken, niet voor verkoop",
    pc_ads_4: "Huurverkeer",
    pc_ads_5: "Concurrenten bieden meer",
    pc_ads_6: "Verkeer stopt wanneer je stopt met uitgeven",
    pc_ads_7: "€0 aan blijvende resultaten",
    pc_trp_1: "AI schrijft dagelijks kwalitatieve content",
    pc_trp_2: "Automatisch zoekwoordonderzoek",
    pc_trp_3: "Kwalitatieve backlinks inbegrepen",
    pc_trp_4: "Geen contracten — annuleer op elk moment",
    pc_trp_5: "Eens ranken, voor altijd verkeer",
    pc_trp_6: "Geen technische kennis nodig",
    pc_trp_7: "Gebouwd om kopers te brengen, niet willekeurig verkeer",
    pc_ag_1: "Maanden om resultaten te zien",
    pc_ag_2: "Wekelijkse vergaderingen",
    pc_ag_3: "Vastgelegd in contracten",
    pc_ag_4: "2 blogberichten/maand voor €2.300",
    pc_ag_5: "Zij bezitten alles",
    pc_ag_6: "Verkeer met 200% gestegen, Verkoop 0%",
    pc_ag_7: "Geen AI zichtbaarheid optimalisatie",
    pc_save_sub: "Verander van bureaus of Google Ads naar TopRankPulse en houd meer geld in je zak.",
    bm_no_monitors: "Geen merken nog gemonitord",
    bm_no_monitors_desc: "Voeg je merk toe om te beginnen met het volgen van hoe AI-zoekmachines jou zien.",
    bm_brand_name: "Merknaam",
    bm_website: "Website URL",
    bm_industry: "Sector",
    bm_location: "Locatie",
    bm_competitors: "Concurrenten",
    bm_comma: "komma gescheiden",
    bm_start: "Start Monitoren",
    bm_citation_score: "Citatiescore",
    bm_recommends: "Raadt aan",
    bm_not_cited: "Niet geciteerd",
    bm_top_rec: "Top Aanbeveling",
    bm_query_analysis: "Query Analyse",
    bm_last_checked: "Laatst gecontroleerd",
    bm_loading: "AI zichtbaarheid analyseren...",
    bm_vis_up: "Zichtbaarheid toegenomen sinds laatste controle",
    bm_vis_down: "Zichtbaarheid afgenomen sinds laatste controle",
    attr_desc: "Bekijk precies hoeveel verkeer en omzet AI-zoekmachines je opleveren",
    attr_setup: "Attribuut Instellen",
    attr_demo: "Demo-gegevens — installeer de trackingpixel om echte cijfers te zien",
    attr_conv_rate: "Conversiepercentage",
    attr_traffic_30: "AI Verkeer (30 Dagen)",
    attr_by_source: "Verkeer per AI-bron",
    attr_source_details: "Brongegevens",
    attr_visits_short: "bezoeken",
    attr_insights: "AI Inzichten",
    attr_pixel: "Trackingpixel",
    attr_copied: "Gekopieerd",
    attr_copy: "Kopiëren",
    attr_pixel_desc: "Plak dit voor </head> op je website om echt AI-verkeer te volgen.",
    attr_no_sites: "Geen Sites Nog Gevolgd",
    attr_no_sites_desc: "Voeg je website toe om te zien hoeveel verkeer AI-zoekmachines je opleveren.",
    attr_add_website: "Voeg Je Website Toe",
    ls_stat1: "sites onzichtbaar voor AI",
    ls_stat2: "gem. bezoeken van AI-zoekopdrachten",
    ls_stat3: "gratis auditresultaten",
    ls_f1_t: "AI Zichtbaarheid Volgen",
    ls_f1_d: "Controleer of ChatGPT, Perplexity & Gemini je website vermelden",
    ls_f2_t: "Volledige SEO Audit",
    ls_f2_d: "Technische analyse met uitvoerbare aanbevelingen",
    ls_f3_t: "Stem Zoekscore",
    ls_f3_d: "Optimaliseer voor Siri, Alexa, Google Assistant",
    ls_f4_t: "GEO Optimalisatie",
    ls_f4_d: "Lokale SEO voor",
    ls_f5_t: "Backlinkanalyse",
    ls_f5_d: "Controleer dofollow, nofollow & domein autoriteit",
    ls_f6_t: "Site Snelheid",
    ls_f6_d: "Core Web Vitals & prestatiecijfer",
    ls_more_cities: "Meer steden in",
    ls_top_cities: "Topsteden in",
    ls_cta_h1: "START JE GRATIS",
    ls_cta_h2: "SEO AUDIT",
    ls_cta_join: "Sluit je aan bij bedrijven in",
    ls_cta_using: "die TopRankPulse gebruiken.",
    pl_f1_t: "AI Zichtbaarheid Volgen",
    pl_f1_d: "Bekijk of ChatGPT, Perplexity & Gemini je website vermelden",
    pl_f2_t: "Volledige SEO Audit",
    pl_f2_d: "Technische analyse met actiegerichte aanbevelingen",
    pl_f3_t: "Trefwoordonderzoek",
    pl_f3_d: "Vind betere trefwoorden met volume, moeilijkheidsgraad en trends",
    pl_f4_t: "Stemmenzoekscore",
    pl_f4_d: "Optimaliseer voor Siri, Alexa, Google Assistant",
    pl_f5_t: "AI-aanbevelingen",
    pl_f5_d: "Stapsgewijze instructies om je score te verbeteren",
    pl_f6_t: "Dashboard-widget",
    pl_f6_d: "SEO-score direct in je WordPress-dashboard",
    pl_f7_t: "Auto-scan bij publicatie",
    pl_f7_d: "Analyseert automatisch nieuwe berichten bij publicatie",
    pl_f8_t: "WooCommerce SEO",
    pl_f8_d: "Product-SEO-scores, AI-beschrijvingen en Google Shopping-optimalisatie",
    pl_f9_t: "Blog Agent (€25)",
    pl_f9_d: "25 SEO-artikelen met backlinks naar je site",
    pl_s3_t: "Scan Je Site",
    pl_s3_d: "Klik op 'Nu scannen' en ontvang je SEO-score + AI-zichtbaarheidsrapport in 30 seconden.",
    pl_w1_t: "Product SEO-score",
    pl_w1_d: "Elk product krijgt een realtime SEO-score.",
    pl_w2_t: "AI Beschrijving Generator",
    pl_w2_d: "AI-gegenereerde SEO-productbeschrijvingen met één klik.",
    pl_w3_t: "Google Shopping Klaar",
    pl_w3_d: "Verbeterde product schema markup voor Google Shopping.",
    fear_desc: "ChatGPT, Gemini en Perplexity halen antwoorden van hoograngschikkende pagina's. Als je nu niet rankt, zal AI je concurrenten aanbevelen — en het wordt alleen maar moeilijker om in te halen.",
    fear_m1_label: "Maand 1",
    fear_m1_title: "Je concurrent publiceert content",
    fear_m1_desc: "Terwijl je wacht, bouwen ze SEO-autoriteit op en worden ze geciteerd door AI-engines.",
    fear_m3_label: "Maand 3",
    fear_m3_title: "AI begint hen aan te bevelen",
    fear_m3_desc: "ChatGPT en Perplexity citeren nu standaard je concurrenten. Je verkeer daalt.",
    fear_m6_label: "Maand 6",
    fear_m6_title: "Je bent onzichtbaar. Zij beheersen jouw niche.",
    fear_m6_desc: "AI-modellen versterken wat al werkt. Inhalen kost nu 10x meer moeite en geld.",
    fear_urgency: "Elke dag dat je wacht, verlies je klanten",
    fear_cta_sub: "De merken die vandaag ranken, worden morgen de standaard AI-aanbevelingen. Zorg dat jij dat bent.",
    pp_what_clients_say: "WAT KLANTEN ZEGGEN",
    pp_start_trial: "Begin Gratis Proefperiode",
    pp_download_plugin: "Download Plugin",
    pp_ready: "KLAAR OM",
    pp_start: "START",
    pp_join: "Sluit je aan bij duizenden bedrijven die TopRankPulse gebruiken.",
    pp_ai_vis_name: "AI Zichtbaarheid Tracking",
    pp_ai_vis_tag: "Bekijk of ChatGPT, Perplexity & Gemini jouw website citeren",
    pp_ai_vis_desc: "AI Zichtbaarheid Tracking monitort of de leidende AI zoekmachines ter wereld — ChatGPT, Perplexity, Gemini en Copilot — jouw website vermelden wanneer gebruikers relevante vragen stellen.",
    pp_ai_vis_f1: "Realtime citatie monitoring over 4 AI-engines",
    pp_ai_vis_f2: "Weekly zichtbaarheid trendrapporten",
    pp_ai_vis_f3: "Vergelijking van concurrentie citaties",
    pp_ai_vis_f4: "Score voor stemzoekgereedheid",
    pp_ai_vis_f5: "AI-geoptimaliseerde contentaanbevelingen",
    pp_ai_vis_f6: "Ondersteuning voor 26 talen met autodetectie",
    pp_seo_name: "Volledige SEO Audit",
    pp_seo_tag: "Technische SEO-analyse met AI-gestuurde aanbevelingen",
    pp_seo_desc: "Onze Volledige SEO Audit analyseert 50+ rankingfactoren, waaronder technische SEO, contentkwaliteit, backlinks, paginasnelheid, mobiele optimalisatie en AI gereedheid.",
    pp_seo_f1: "50+ rankingfactoren geanalyseerd",
    pp_seo_f2: "Technische SEO-controles (meta-tags, koppen, schema)",
    pp_seo_f3: "Beoordeling van contentkwaliteit",
    pp_seo_f4: "Analyse van backlinkprofielen",
    pp_seo_f5: "Evaluatie van Core Web Vitals",
    pp_seo_f6: "Tips voor mobiele optimalisatie",
    pp_seo_f7: "Score voor AI gereedheid",
    pp_seo_f8: "Downloadbaar PDF-rapport",
    pp_brand_name: "AI Merkenmonitoring",
    pp_brand_tag: "24/7 monitoring of AI zoekmachines jouw merk vermelden",
    pp_brand_f1: "24/7 monitoring over 4 AI-engines",
    pp_brand_f2: "Realtime citatie alerts via e-mail",
    pp_brand_f3: "Concurrentie benchmarkvergelijking",
    pp_brand_f4: "Historische trendbewaking met grafieken",
    pp_brand_f5: "Analyse op query-niveau",
    pp_brand_f6: "Uitvoerbare AI optimalisatie aanbevelingen",
    pp_comp_name: "AI Concurrentie Spy",
    pp_comp_tag: "Realtime concurrentie-intelligentie aangedreven door AI",
    pp_comp_f1: "Realtime concurrentie SEO monitoring",
    pp_comp_f2: "Content wijzigingsalerts",
    pp_comp_f3: "Tracking van backlinkverwerving",
    pp_comp_f4: "Vergelijking van AI zichtbaarheid",
    pp_comp_f5: "Sterkte/zwakte analyse",
    pp_comp_f6: "Identificatie van kansen",
    pp_comp_f7: "Prioriteitsalerts voor belangrijke veranderingen",
    pp_blog_name: "Blog Agent",
    pp_blog_tag: "25 SEO-artikelen met elk 4 backlinks — geschreven door AI, dagelijks gepubliceerd",
    pp_blog_f1: "25 unieke SEO-geoptimaliseerde artikelen",
    pp_blog_f2: "Elke dag 1 gepubliceerd gedurende 25 dagen",
    pp_blog_f3: "4 dofollow backlinks per artikel",
    pp_blog_f4: "Automatisch vertaald in 26 talen",
    pp_blog_f5: "Onderzoek naar onderwerpen op basis van jouw branche",
    pp_blog_f6: "Langformaat inhoud (1.500+ woorden)",
    pp_blog_f7: "Interne linkstructuur",
    pp_blog_f8: "Schema markup inbegrepen",
    pp_wp_name: "WordPress + WooCommerce Plugin",
    pp_wp_tag: "Gratis SEO-plugin met ingebouwde AI zichtbaarheid tracking",
    pp_auto_name: "SEO Autopilot",
    pp_auto_tag: "AI corrigeert automatisch jouw SEO — niet alleen aanbevelingen",
    pp_auto_desc: "SEO Autopilot vertelt je niet alleen wat je moet verbeteren — het verbetert het voor je. Onze AI genereert automatisch geoptimaliseerde meta-titels, beschrijvingen, afbeeldings-alt-teksten, interne links en FAQ-secties. Werkt met WordPress en Shopify via onze plugins.",
    pp_auto_f1: "Automatisch genereren van SEO-meta-titels & beschrijvingen",
    pp_auto_f2: "Automatisch genereren van afbeeldings-alt-teksten",
    pp_auto_f3: "Slimme suggesties voor interne links",
    pp_auto_f4: "Generatie van FAQ-sectie met schema markup",
    pp_auto_f5: "Detectie van gebroken links & omleidingssuggesties",
    pp_auto_f6: "Wekelijkse geautomatiseerde scans",
    pp_auto_f7: "Integratie met WordPress & Shopify plugin",
    pp_auto_f8: "Voor/na score tracking",
    pp_sim_name: "AI Zoek Simulator",
    pp_sim_tag: "Zie wat ChatGPT, Perplexity & Gemini zouden antwoorden — gratis",
    pp_sim_desc: "AI Zoek Simulator laat je elke vraag typen en geeft gesimuleerde antwoorden van ChatGPT, Perplexity, Gemini en Copilot. Ontdek of jouw website genoemd zou worden in AI zoekresultaten.",
    pp_sim_f1: "Simuleer AI zoekantwoorden van 4 systemen",
    pp_sim_f2: "Controleer of jouw website wordt geciteerd",
    pp_sim_f3: "Test elk zoekwoord of elke vraag",
    pp_sim_f4: "Gratis onbeperkte queries",
    pp_sim_f5: "Ondersteuning voor 26 talen",
    pp_blog_desc: "Blog Agent schrijft 25 SEO-geoptimaliseerde artikelen voor jouw website — één per dag gedurende 25 dagen. Elk artikel bevat 4 dofollow backlinks, is automatisch vertaald in 26 talen en wordt op schema gepubliceerd.",
    pp_brand_desc: "AI Brand Monitoring volgt of ChatGPT, Perplexity, Gemini en Copilot jouw merk noemen wanneer gebruikers relevante vragen stellen. Ontvang realtime meldingen en benchmark tegen concurrenten.",
    pp_comp_desc: "AI Competitor Spy monitort de SEO-strategieën van jouw concurrenten in realtime. Ontvang meldingen wanneer zij nieuwe inhoud publiceren, backlinks verwerven of hun AI zichtbaarheidsscore verbeteren.",
    pp_wp_desc: "Onze gratis WordPress plugin brengt TopRankPulse direct in jouw WordPress admin. Krijg SEO-scores, AI zichtbaarheid tracking en één-klik oplossingen zonder je dashboard te verlaten.",
    pp_wp_f1: "Een klik SEO-oplossingen vanuit WordPress admin",
    pp_wp_f2: "Ingebouwde AI zichtbaarheid tracking",
    pp_wp_f3: "SEO-optimalisatie voor WooCommerce-producten",
    pp_wp_f4: "Automatische schema markup",
    pp_wp_f5: "Voor altijd gratis voor alle abonnementen",
    pp_free_scan: "Gratis eerste scan",
  },
  sv: {
    pc_tag: "Sluta betala för mycket för SEO", pc_h1: "Ersätt dyra SEO-byråer", pc_h1_highlight: "till priset av en familjemiddag",
    pc_month: "månad", pc_best_value: "BÄSTA VÄRDE", pc_cta: "BÖRJA GRATIS",
    fear_warning: "VARNING", fear_h1: "AI rekommenderar varumärken", fear_h1_highlight: "IDAG",
    fear_cta_btn: "BÖRJA NU", bm_add_brand: "Lägg till varumärke", bm_overall: "Total AI-synlighet",
    attr_visits: "AI-besök", attr_conversions: "Konverteringar", ls_scan: "SKANNA DIN WEBBPLATS",
  
    pc_sub: "Du kan prova gratis och börja ranka idag",
    pc_agency: "SEO-byrå",
    pc_ads_1: "Du behöver en stor budget",
    pc_ads_2: "Manuell nyckelordsforskning",
    pc_ads_3: "Optimerad för klick, inte försäljning",
    pc_ads_4: "Hyrd trafik",
    pc_ads_5: "Konkurrenter överbudar dig",
    pc_ads_6: "Trafiken stoppas när du slutar spendera",
    pc_ads_7: "€0 i bestående resultat",
    pc_trp_1: "AI skriver kvalitetsinnehåll dagligen",
    pc_trp_2: "Automatisk nyckelordsforskning",
    pc_trp_3: "Kvalitetsbacklinks ingår",
    pc_trp_4: "Inga kontrakt - avbryt när som helst",
    pc_trp_5: "Ranka en gång, få trafik för alltid",
    pc_trp_6: "Ingen teknisk kunskap krävs",
    pc_trp_7: "Byggd för att generera köpare, inte slumpmässig trafik",
    pc_ag_1: "Månader för att se resultat",
    pc_ag_2: "Veckovisa möten",
    pc_ag_3: "Inlåsta i kontrakt",
    pc_ag_4: "2 blogginlägg/månad för €2,300",
    pc_ag_5: "De äger allt",
    pc_ag_6: "Trafik upp 200%, Försäljning 0%",
    pc_ag_7: "Ingen AI-synlighet optimering",
    pc_save_title: "Spara 20+ timmar & €2,000+/månad",
    pc_save_sub: "Byt från byråer eller Google Ads till TopRankPulse och behåll mer pengar i fickan.",
    pc_save_cta: "SE PLANER",
    bm_no_monitors: "Inga märken övervakade än",
    bm_no_monitors_desc: "Lägg till ditt märke för att börja spåra hur AI-sökmotorer ser dig.",
    bm_brand_name: "Märkesnamn",
    bm_website: "Webbplats URL",
    bm_industry: "Bransch",
    bm_location: "Plats",
    bm_competitors: "Konkurrenter",
    bm_comma: "komma separerade",
    bm_start: "Börja övervaka",
    bm_recheck: "Kontrollera igen",
    bm_citation_score: "Citationspoäng",
    bm_recommends: "Rekommenderar",
    bm_not_cited: "Inte citerad",
    bm_top_rec: "Bästa rekommendation",
    bm_query_analysis: "Frågeanalys",
    bm_last_checked: "Senast kontrollerad",
    bm_loading: "Analyserar AI-synlighet...",
    bm_recommendations: "Hur du ökar din synlighet",
    bm_high: "Hög påverkan",
    bm_medium: "Medel",
    bm_low: "Låg",
    bm_vis_up: "Synlighet ökad sedan senaste kontroll",
    bm_vis_down: "Synlighet minskad sedan senaste kontroll",
    attr_desc: "Se exakt hur mycket trafik och intäkter AI-sökmotorer ger dig",
    attr_setup: "Ställ in attribuering",
    attr_demo: "Demodata — installera spårningspixeln för att se verkliga siffror",
    attr_revenue: "Intäkter",
    attr_conv_rate: "Konv. Rate",
    attr_traffic_30: "AI-trafik (30 dagar)",
    attr_by_source: "Trafik efter AI-källa",
    attr_source_details: "Källinformation",
    attr_visits_short: "besök",
    attr_insights: "AI-insikter",
    attr_pixel: "Spårningspixel",
    attr_copied: "Kopierad",
    attr_copy: "Kopiera",
    attr_pixel_desc: "Klistra in detta före </head> på din webbplats för att börja spåra verklig AI-trafik.",
    attr_no_sites: "Inga webbplatser spårade än",
    attr_no_sites_desc: "Lägg till din webbplats för att se hur mycket trafik AI-sökmotorer ger dig.",
    attr_add_website: "Lägg till din webbplats",
    ls_stat1: "webbplatser osynliga för AI",
    ls_stat2: "genomsnittliga besök från AI-sökning",
    ls_stat3: "gratis revisionsresultat",
    ls_f1_t: "Spårning av AI-synlighet",
    ls_f1_d: "Kontrollera om ChatGPT, Perplexity & Gemini nämner din webbplats",
    ls_f2_t: "Omfattande SEO-revision",
    ls_f2_d: "Teknisk analys med genomförbara rekommendationer",
    ls_f3_t: "Röst sökpoäng",
    ls_f3_d: "Optimera för Siri, Alexa, Google Assistant",
    ls_f4_t: "GEO-optimering",
    ls_f4_d: "Lokal SEO för",
    ls_f5_t: "Backlinkanalys",
    ls_f5_d: "Kontrollera dofollow, nofollow & domänauktoritet",
    ls_f6_t: "Webbplatsens hastighet",
    ls_f6_d: "Core Web Vitals & prestandapoäng",
    ls_more_cities: "Fler städer i",
    ls_top_cities: "Toppstäder i",
    ls_cta_h1: "BÖRJA DIN GRATIS",
    ls_cta_h2: "SEO GRANSKNING",
    ls_cta_join: "Gå med företag i",
    ls_cta_using: "som använder TopRankPulse.",
    ls_free: "Gratis för alltid",
    ls_no_card: "Ingen kreditkort",
    ls_langs: "26 språk",
    pl_f1_t: "AI Synlighetsspårning",
    pl_f1_d: "Se om ChatGPT, Perplexity & Gemini hänvisar till din webbplats",
    pl_f2_t: "Fullständig SEO Granskning",
    pl_f2_d: "Teknisk analys med handlingsbara rekommendationer",
    pl_f3_t: "Nyckelordsforskning",
    pl_f3_d: "Hitta bättre nyckelord med volym, svårighet & trender",
    pl_f4_t: "Röst Sök Poäng",
    pl_f4_d: "Optimera för Siri, Alexa, Google Assistant",
    pl_f5_t: "AI Rekommendationer",
    pl_f5_d: "Steg-för-steg-instruktioner för att förbättra din poäng",
    pl_f6_t: "Dashboard Widget",
    pl_f6_d: "SEO-poäng direkt i din WordPress-instrumentpanel",
    pl_f7_t: "Auto-Scan vid Publicering",
    pl_f7_d: "Analyserar automatiskt nya inlägg vid publicering",
    pl_f8_t: "WooCommerce SEO",
    pl_f8_d: "Produkt-SEO-poäng, AI-beskrivningar & Google Shopping-optimering",
    pl_f9_t: "Blogg Agent (€25)",
    pl_f9_d: "25 SEO-artiklar med bakåtlänkar till din webbplats",
    pl_s3_t: "Skanna Din Webbplats",
    pl_s3_d: "Klicka på 'Skanna Nu' och få din SEO-poäng + AI-synlighetsrapport på 30 sekunder.",
    pl_w1_t: "Produkt SEO Poäng",
    pl_w1_d: "Varje produkt får en aktuell SEO-poäng.",
    pl_w2_t: "AI Beskrivningsgenerator",
    pl_w2_d: "AI-genererade SEO-produktbeskrivningar med ett klick.",
    pl_w3_t: "Google Shopping Klar",
    pl_w3_d: "Förbättrad produkt-schema markup för Google Shopping.",
    fear_h1_2: "som rankar",
    fear_desc: "ChatGPT, Gemini och Perplexity hämtar svar från högst rankade sidor. Om du inte rankar nu, kommer AI att rekommendera dina konkurrenter - och det blir bara svårare att ta igen.",
    fear_m1_label: "Månad 1",
    fear_m1_title: "Din konkurrent publicerar innehåll",
    fear_m1_desc: "Medan du väntar bygger de SEO-authoritet och blir citerade av AI-motorer.",
    fear_m3_label: "Månad 3",
    fear_m3_title: "AI börjar rekommendera dem",
    fear_m3_desc: "ChatGPT och Perplexity citerar nu automatiskt dina konkurrenter. Din trafik sjunker.",
    fear_m6_label: "Månad 6",
    fear_m6_title: "Du är osynlig. De äger din nisch.",
    fear_m6_desc: "AI-modeller förstärker det som redan fungerar. Att ikapp komma kostar nu 10 gånger mer ansträngning och pengar.",
    fear_urgency: "Varje dag du väntar, förlorar du kunder",
    fear_cta_h: "Börja ranka innan dina konkurrenter gör det",
    fear_cta_sub: "De varumärken som rankar idag blir de standard AI-rekommendationerna imorgon. Se till att det är du.",
    pp_what_clients_say: "VAD KUNDER SÄGER",
    pp_start_trial: "Börja Gratis Provperiod",
    pp_download_plugin: "Ladda Ner Plugin",
    pp_ready: "REDO ATT",
    pp_start: "BÖRJA",
    pp_join: "Gå med i tusentals företag som använder TopRankPulse.",
    pp_ai_vis_name: "AI Synlighetsspårning",
    pp_ai_vis_tag: "Se om ChatGPT, Perplexity & Gemini citerar din webbplats",
    pp_ai_vis_desc: "AI Synlighetsspårning övervakar om världens ledande AI-sökmotorer — ChatGPT, Perplexity, Gemini och Copilot — nämner din webbplats när användare ställer relevanta frågor.",
    pp_ai_vis_f1: "Real-tids citeringsövervakning över 4 AI-motorer",
    pp_ai_vis_f2: "Veckovisa synlighetstrendsrapporter",
    pp_ai_vis_f3: "Jämförelse av konkurrentciteringar",
    pp_ai_vis_f4: "Röstsökbarhetsresultat",
    pp_ai_vis_f5: "AI-optimerade innehållsrekommendationer",
    pp_ai_vis_f6: "26-språk stöd med automatisk detektion",
    pp_seo_name: "Komplett SEO Granskning",
    pp_seo_tag: "Teknisk SEO-analys med AI-drivna rekommendationer",
    pp_seo_desc: "Vår Kompletta SEO Granskning analyserar 50+ rankningsfaktorer inklusive teknisk SEO, innehållskvalitet, bakåtlänkar, sidans hastighet, mobiloptimering och AI-beredskap.",
    pp_seo_f1: "50+ rankningsfaktorer analyserade",
    pp_seo_f2: "Tekniska SEO-kontroller (meta-taggar, rubriker, schema)",
    pp_seo_f3: "Innehållskvalitetsbedömning",
    pp_seo_f4: "Analys av bakåtlänkar",
    pp_seo_f5: "Bedömning av Core Web Vitals",
    pp_seo_f6: "Tips för mobilprioriterad optimering",
    pp_seo_f7: "AI-beredskapsresultat",
    pp_seo_f8: "Nedladdningsbar PDF-rapport",
    pp_brand_name: "AI Varumärkesövervakning",
    pp_brand_tag: "24/7 övervakning om AI-sökmotorer nämner ditt varumärke",
    pp_brand_f1: "24/7 övervakning över 4 AI-motorer",
    pp_brand_f2: "Citeringslarm i realtid via e-post",
    pp_brand_f3: "Jämförelse av konkurrenter",
    pp_brand_f4: "Historisk trendspårning med diagram",
    pp_brand_f5: "Analys på frågenivå",
    pp_brand_f6: "Genomförbara AI-optimiseringsrekommandationer",
    pp_comp_name: "AI Konkurrent Spy",
    pp_comp_tag: "Realtids konkurrentinformation driven av AI",
    pp_comp_f1: "Realtidsövervakning av konkurrenters SEO",
    pp_comp_f2: "Aviseringar om ändringar i innehållet",
    pp_comp_f3: "Spårning av backlink-förvärv",
    pp_comp_f4: "Jämförelse av AI-synlighet",
    pp_comp_f5: "Styrk/svaghet analys",
    pp_comp_f6: "Identifiering av möjligheter",
    pp_comp_f7: "Prioriterade aviseringar för högpåverkan förändringar",
    pp_blog_name: "Blogg Agent",
    pp_blog_tag: "25 SEO-artiklar med 4 backlinks vardera — skrivna av AI, publicerade dagligen",
    pp_blog_f1: "25 unika SEO-optimerade artiklar",
    pp_blog_f2: "Publiceras 1 per dag under 25 dagar",
    pp_blog_f3: "4 dofollow backlinks per artikel",
    pp_blog_f4: "Autoöversatt till 26 språk",
    pp_blog_f5: "Ämnesforskning baserat på din bransch",
    pp_blog_f6: "Långformigt innehåll (1 500+ ord)",
    pp_blog_f7: "Intern länkstruktur",
    pp_blog_f8: "Schema markup inkluderat",
    pp_wp_name: "WordPress + WooCommerce Plugin",
    pp_wp_tag: "Gratis SEO-plugin med inbyggd AI-synlighetsspårning",
    pp_auto_name: "SEO Autopilot",
    pp_auto_tag: "AI åtgärdar automatiskt din SEO — inte bara rekommendationer",
    pp_auto_desc: "SEO Autopilot berättar inte bara vad du ska fixa — den fixar det åt dig. Vår AI genererar automatiskt optimerade metatitlar, beskrivningar, bild alt-texter, interna länkar och FAQ-sektioner. Fungerar med WordPress och Shopify via våra plugins.",
    pp_auto_f1: "Automatiskt generera SEO-metatitlar och -beskrivningar",
    pp_auto_f2: "Automatiskt generera bild alt-texter",
    pp_auto_f3: "Smart förslag på interna länkar",
    pp_auto_f4: "Generering av FAQ-sektion med schema markup",
    pp_auto_f5: "Upptäckte brutna länkar och omdirigeringsförslag",
    pp_auto_f6: "Veckovis automatiserade skanningar",
    pp_auto_f7: "Integration med WordPress och Shopify plugins",
    pp_auto_f8: "Före/efter poängspårning",
    pp_sim_name: "AI Sök Simulator",
    pp_sim_tag: "Se vad ChatGPT, Perplexity & Gemini skulle svara — gratis",
    pp_sim_desc: "AI Sök Simulator låter dig ställa vilken fråga som helst och se simulerade svar från ChatGPT, Perplexity, Gemini och Copilot. Ta reda på om din webbplats skulle nämnas i AI-sökresultat.",
    pp_sim_f1: "Simulera AI-sökrespons från 4 motorer",
    pp_sim_f2: "Kontrollera om din webbplats nämns",
    pp_sim_f3: "Testa valfritt nyckelord eller fråga",
    pp_sim_f4: "Obegränsade kostnadsfria sökningar",
    pp_sim_f5: "Stöd för 26 språk",
    pp_blog_desc: "Blog Agent skriver 25 SEO-optimerade artiklar för din webbplats — en per dag i 25 dagar. Varje artikel innehåller 4 dofollow-länkar, översätts automatiskt till 26 språk och publiceras enligt schema.",
    pp_brand_desc: "AI Brand Monitoring spårar om ChatGPT, Perplexity, Gemini och Copilot nämner ditt varumärke när användare ställer relevanta frågor. Få realtidsvarningar och jämför med konkurrenter.",
    pp_comp_desc: "AI Competitor Spy övervakar dina konkurrenters SEO-strategier i realtid. Få varningar när de publicerar nytt innehåll, skaffar bakåtlänkar eller förbättrar sin AI-synlighetspoäng.",
    pp_wp_desc: "Vår kostnadsfria WordPress-plugin tar TopRankPulse direkt till din WordPress-administratör. Få SEO-poäng, spårning av AI-synlighet och en-klicks-korrigeringar utan att lämna din instrumentpanel.",
    pp_wp_f1: "En-klicks SEO-korrigeringar från WordPress-administratör",
    pp_wp_f2: "Inbyggd spårning av AI-synlighet",
    pp_wp_f3: "SEO-optimering av WooCommerce-produkter",
    pp_wp_f4: "Automatisk schema-märkning",
    pp_wp_f5: "Kostnadsfritt för alltid för alla planer",
    pp_free_scan: "Kostnadsfri första skanning",
  },
  ro: {
    pc_tag: "Nu mai plătiți prea mult pentru SEO", pc_h1: "Înlocuiți agențiile SEO scumpe", pc_h1_highlight: "la prețul unei cine în familie",
    pc_month: "lună", pc_best_value: "CEA MAI BUNĂ VALOARE", pc_cta: "ÎNCEPEȚI GRATUIT",
    fear_warning: "AVERTISMENT", fear_h1: "AI recomandă branduri", fear_h1_highlight: "ASTĂZI",
    fear_cta_btn: "ÎNCEPEȚI ACUM", bm_add_brand: "Adaugă brand", bm_overall: "Vizibilitate AI totală",
    attr_visits: "Vizite AI", attr_conversions: "Conversii", ls_scan: "SCANEAZĂ SITE-UL",
  
    pc_sub: "Îl poți încerca gratuit și începe să te clasezi azi",
    pc_agency: "Agenție SEO",
    pc_ads_1: "Ai nevoie de un buget mare",
    pc_ads_2: "Cercetare manuală de cuvinte cheie",
    pc_ads_3: "Optimizat pentru clicuri, nu pentru vânzări",
    pc_ads_4: "Trafic închiriat",
    pc_ads_5: "Concurenții te depășesc",
    pc_ads_6: "Traficul se oprește când încetezi cheltuielile",
    pc_ads_7: "€0 în rezultate durabile",
    pc_trp_1: "AI scrie conținut de calitate zilnic",
    pc_trp_2: "Cercetare automată de cuvinte cheie",
    pc_trp_3: "Backlink-uri de calitate incluse",
    pc_trp_4: "Fără contracte — poți anula oricând",
    pc_trp_5: "Clasifică-te o dată, obține trafic pentru totdeauna",
    pc_trp_6: "Nu este nevoie de cunoștințe tehnice",
    pc_trp_7: "Construit pentru a aduce cumpărători, nu trafic aleator",
    pc_ag_1: "Luni pentru a vedea rezultate",
    pc_ag_2: "Întâlniri săptămânale",
    pc_ag_3: "Închiși în contracte",
    pc_ag_4: "2 articole de blog/lună pentru €2,300",
    pc_ag_5: "Ei dețin totul",
    pc_ag_6: "Trafic cu 200% mai mult, Vânzări 0%",
    pc_ag_7: "Nici o optimizare pentru vizibilitatea AI",
    pc_save_title: "Economisește 20+ ore și €2,000+/lună",
    pc_save_sub: "Trecerea de la agenții sau Google Ads la TopRankPulse și păstrează mai mulți bani în buzunar.",
    pc_save_cta: "VEZI PLANURI",
    bm_no_monitors: "Nici o marcă monitorizată încă",
    bm_no_monitors_desc: "Adaugă marca ta pentru a începe monitorizarea modului în care motoarele de căutare AI te văd.",
    bm_brand_name: "Numele Mărcii",
    bm_website: "URL-ul site-ului",
    bm_industry: "Industrie",
    bm_location: "Locație",
    bm_competitors: "Concurenți",
    bm_comma: "separate prin virgulă",
    bm_start: "Începe Monitorizarea",
    bm_recheck: "Reverifică",
    bm_citation_score: "Scor de Citație",
    bm_recommends: "Recomandă",
    bm_not_cited: "Netrecut în revistă",
    bm_top_rec: "Recomandare Principală",
    bm_query_analysis: "Analiza Interogărilor",
    bm_last_checked: "Verificat ultima dată",
    bm_loading: "Se analizează vizibilitatea AI...",
    bm_recommendations: "Cum să îți crești vizibilitatea",
    bm_high: "Impact Mare",
    bm_medium: "Mediu",
    bm_low: "Mic",
    bm_vis_up: "Vizibilitate crescută de la ultima verificare",
    bm_vis_down: "Vizibilitate scăzută de la ultima verificare",
    attr_desc: "Vezi exact câte vizite și venituri îți aduc motoarele de căutare AI",
    attr_setup: "Configurare Atribuire",
    attr_demo: "Date demo — instalează pixelul de urmărire pentru a vedea cifre reale",
    attr_revenue: "Venituri",
    attr_conv_rate: "Rata de Conversie",
    attr_traffic_30: "Trafic AI (30 Zile)",
    attr_by_source: "Trafic după Sursă AI",
    attr_source_details: "Detalii Sursă",
    attr_visits_short: "vizite",
    attr_insights: "Informații AI",
    attr_pixel: "Pixel de Urmărire",
    attr_copied: "Copiat",
    attr_copy: "Copiază",
    attr_pixel_desc: "Lipește acesta înainte de </head> pe site-ul tău pentru a începe urmărirea traficului real AI.",
    attr_no_sites: "Niciun Site Încă Urmărit",
    attr_no_sites_desc: "Adaugă-ți site-ul pentru a vedea cât trafic îți aduc motoarele de căutare AI.",
    attr_add_website: "Adaugă-ți Site-ul",
    ls_stat1: "site-uri invizibile pentru AI",
    ls_stat2: "vizite medii din căutările AI",
    ls_stat3: "rezultate audit gratuite",
    ls_f1_t: "Urmărirea Vizibilității AI",
    ls_f1_d: "Verifică dacă ChatGPT, Perplexity & Gemini menționează site-ul tău",
    ls_f2_t: "Audit SEO Complet",
    ls_f2_d: "Analiză tehnică cu recomandări aplicabile",
    ls_f3_t: "Scor Căutare Vocală",
    ls_f3_d: "Optimizează pentru Siri, Alexa, Google Assistant",
    ls_f4_t: "Optimizare GEO",
    ls_f4_d: "SEO Local pentru",
    ls_f5_t: "Analiza Backlink-urilor",
    ls_f5_d: "Verifică dofollow, nofollow & autoritatea domeniului",
    ls_f6_t: "Viteza Site-ului",
    ls_f6_d: "Core Web Vitals & scor de performanță",
    ls_more_cities: "Mai multe orașe în",
    ls_top_cities: "Orașe de top în",
    ls_cta_h1: "ÎNCEPEȚI GRATUIT",
    ls_cta_h2: "AUDIT SEO",
    ls_cta_join: "Alăturați-vă afacerilor din",
    ls_cta_using: "utilizând TopRankPulse.",
    ls_free: "Gratuit pentru totdeauna",
    ls_no_card: "Fără card de credit",
    ls_langs: "26 limbi",
    pl_f1_t: "Urmărirea Vizibilității AI",
    pl_f1_d: "Verificați dacă ChatGPT, Perplexity & Gemini citesc site-ul dvs.",
    pl_f2_t: "Audit SEO Complet",
    pl_f2_d: "Analiză tehnică cu recomandări aplicabile",
    pl_f3_t: "Cercetare Cuvinte Cheie",
    pl_f3_d: "Găsiți cuvinte cheie mai bune cu volum, dificultate & tendințe",
    pl_f4_t: "Scor Căutare Vocală",
    pl_f4_d: "Optimizați pentru Siri, Alexa, Google Assistant",
    pl_f5_t: "Recomandări AI",
    pl_f5_d: "Instrucțiuni pas cu pas pentru a vă îmbunătăți scorul",
    pl_f6_t: "Widget Tablou de Bord",
    pl_f6_d: "Scor SEO direct în tabloul de bord WordPress",
    pl_f7_t: "Scanare Automată la Publicare",
    pl_f7_d: "Analizează automat postările noi la publicare",
    pl_f8_t: "SEO WooCommerce",
    pl_f8_d: "Scoruri SEO pentru produse, descrieri AI & optimizare Google Shopping",
    pl_f9_t: "Agent Blog (€25)",
    pl_f9_d: "25 articole SEO cu backlinkuri către site-ul dvs.",
    pl_s3_t: "Scanați Site-ul Dvs.",
    pl_s3_d: "Click pe 'Scanare Acum' și obțineți scorul dvs. SEO + raportul de vizibilitate AI în 30 de secunde.",
    pl_w1_t: "Scor SEO Produs",
    pl_w1_d: "Fiecare produs primește un scor SEO în timp real.",
    pl_w2_t: "Generator Descriere AI",
    pl_w2_d: "Descrieri de produse SEO generate de AI, cu un singur clic.",
    pl_w3_t: "Pregătit pentru Google Shopping",
    pl_w3_d: "Marcaj schema pentru produse îmbunătățit pentru Google Shopping.",
    fear_h1_2: "care se clasează",
    fear_desc: "ChatGPT, Gemini și Perplexity extrag răspunsuri din paginile de top. Dacă nu sunteți clasat acum, AI va recomanda competitorii dvs. — și devine din ce în ce mai greu să recuperați.",
    fear_m1_label: "Luna 1",
    fear_m1_title: "Competitorul dvs. publică conținut",
    fear_m1_desc: "În timp ce aștepți, ei își construiesc autoritatea SEO și sunt citați de motoarele AI.",
    fear_m3_label: "Luna 3",
    fear_m3_title: "AI începe să îi recomande",
    fear_m3_desc: "ChatGPT și Perplexity acum își citesc competitorii în mod implicit. Traficul tău scade.",
    fear_m6_label: "Luna 6",
    fear_m6_title: "Ești invizibil. Ei dețin nișa ta.",
    fear_m6_desc: "Modelele AI întăresc ceea ce funcționează deja. Să recuperezi acum costă de 10 ori mai mult efort și bani.",
    fear_urgency: "Fiecare zi în care aștepți, pierzi clienți",
    fear_cta_h: "Începe să te poziționezi înaintea competitorilor",
    fear_cta_sub: "Brandurile care se clasează azi devin recomandările implicite AI mâine. Asigură-te că ești tu.",
    pp_what_clients_say: "CE SPUN CLIENȚII",
    pp_start_trial: "Începe Trial Gratuit",
    pp_download_plugin: "Descarcă Plugin",
    pp_ready: "GATA PENTRU",
    pp_start: "START",
    pp_join: "Alătură-te miilor de afaceri care folosesc TopRankPulse.",
    pp_ai_vis_name: "Monitorizarea Vizibilității AI",
    pp_ai_vis_tag: "Vezi dacă ChatGPT, Perplexity & Gemini citesc site-ul tău",
    pp_ai_vis_desc: "Monitorizarea Vizibilității AI urmărește dacă cele mai importante motoare de căutare AI — ChatGPT, Perplexity, Gemini și Copilot — menționează site-ul tău când utilizatorii pun întrebări relevante.",
    pp_ai_vis_f1: "Monitorizare a citațiilor în timp real pe 4 motoare AI",
    pp_ai_vis_f2: "Rapoarte săptămânale ale tendințelor de vizibilitate",
    pp_ai_vis_f3: "Compararea citațiilor competitorilor",
    pp_ai_vis_f4: "Scor de pregătire pentru căutări vocale",
    pp_ai_vis_f5: "Recomandări de conținut optimizate pentru AI",
    pp_ai_vis_f6: "Asistență în 26 de limbi cu detectare automată",
    pp_seo_name: "Audit SEO Complet",
    pp_seo_tag: "Analiză tehnică SEO cu recomandări bazate pe AI",
    pp_seo_desc: "Auditul nostru SEO Complet analizează peste 50 de factori de clasare, incluzând SEO tehnic, calitatea conținutului, backlink-uri, viteza paginii, optimizarea mobilă și pregătirea pentru AI.",
    pp_seo_f1: "Peste 50 de factori de clasare analizați",
    pp_seo_f2: "Verificări SEO tehnice (meta etichete, titluri, schema)",
    pp_seo_f3: "Evaluarea calității conținutului",
    pp_seo_f4: "Analiza profilului de backlink-uri",
    pp_seo_f5: "Evaluarea Core Web Vitals",
    pp_seo_f6: "Sfaturi pentru optimizarea mobil-first",
    pp_seo_f7: "Scor de pregătire pentru AI",
    pp_seo_f8: "Raport PDF descărcabil",
    pp_brand_name: "Monitorizarea Brandului AI",
    pp_brand_tag: "Monitorizare 24/7 dacă motoarele de căutare AI menționează brandul tău",
    pp_brand_f1: "Monitorizare 24/7 pe 4 motoare AI",
    pp_brand_f2: "Alerta citațiilor în timp real prin email",
    pp_brand_f3: "Compararea benchmark-urilor competitorilor",
    pp_brand_f4: "Urmărirea tendințelor istorice cu grafice",
    pp_brand_f5: "Analiza la nivel de interogare",
    pp_brand_f6: "Recomandări de optimizare AI aplicabile",
    pp_comp_name: "AI Competitor Spy",
    pp_comp_tag: "Inteligență competitivă în timp real alimentată de AI",
    pp_comp_f1: "Monitorizarea SEO a competitorilor în timp real",
    pp_comp_f2: "Alerte pentru modificările de conținut",
    pp_comp_f3: "Urmărirea achiziției de backlink-uri",
    pp_comp_f4: "Compararea vizibilității AI",
    pp_comp_f5: "Analiza punctelor forte/slabe",
    pp_comp_f6: "Identificarea oportunităților",
    pp_comp_f7: "Alerte prioritare pentru modificări cu impact mare",
    pp_blog_name: "Blog Agent",
    pp_blog_tag: "25 de articole SEO cu câte 4 backlink-uri fiecare — scrise de AI, publicate zilnic",
    pp_blog_f1: "25 de articole unice optimizate SEO",
    pp_blog_f2: "Publicat câte unul pe zi timp de 25 de zile",
    pp_blog_f3: "4 backlink-uri dofollow per articol",
    pp_blog_f4: "Tradus automat în 26 de limbi",
    pp_blog_f5: "Cercetare de subiecte pe baza industriei tale",
    pp_blog_f6: "Conținut lung (peste 1,500 cuvinte)",
    pp_blog_f7: "Structura de legături interne",
    pp_blog_f8: "Markup schema inclus",
    pp_wp_name: "Plugin WordPress + WooCommerce",
    pp_wp_tag: "Plugin SEO gratuit cu urmărirea vizibilității AI integrată",
    pp_auto_name: "SEO Autopilot",
    pp_auto_tag: "AI repară automat SEO-ul tău — nu doar recomandări",
    pp_auto_desc: "SEO Autopilot nu doar îți spune ce să repari — îl repară pentru tine. AI-ul nostru generează automat titluri meta optimizate, descrieri, texte alternative pentru imagini, linkuri interne și secțiuni FAQ. Funcționează cu WordPress și Shopify prin plugin-urile noastre.",
    pp_auto_f1: "Generare automată a titlurilor și descrierilor meta SEO",
    pp_auto_f2: "Generare automată a textelor alternative pentru imagini",
    pp_auto_f3: "Sugestii de legături interne inteligente",
    pp_auto_f4: "Generarea secțiunii FAQ cu markup schema",
    pp_auto_f5: "Detectarea linkurilor rupte & sugestii de redirecționare",
    pp_auto_f6: "Scanări automate săptămânale",
    pp_auto_f7: "Integrare plugin WordPress & Shopify",
    pp_auto_f8: "Urmărirea scorului înainte/după",
    pp_sim_name: "Simulator de Căutare AI",
    pp_sim_tag: "Vezi ce ar răspunde ChatGPT, Perplexity & Gemini — gratuit",
    pp_sim_desc: "Simulatorul de Căutare AI îți permite să scrii orice întrebare și să vezi răspunsuri simulate de la ChatGPT, Perplexity, Gemini și Copilot. Află dacă site-ul tău ar fi menționat în rezultatele căutării AI.",
    pp_sim_f1: "Simulează răspunsurile de căutare AI din 4 motoare",
    pp_sim_f2: "Verifică dacă site-ul tău este menționat",
    pp_sim_f3: "Testează orice cuvânt cheie sau întrebare",
    pp_sim_f4: "Întrebări nelimitate gratuite",
    pp_sim_f5: "Suport în 26 de limbi",
    pp_blog_desc: "Agentul Blog scrie 25 de articole optimizate SEO pentru site-ul tău — câte unul pe zi timp de 25 de zile. Fiecare articol include 4 backlink-uri dofollow, este tradus automat în 26 de limbi și publicat conform programului.",
    pp_brand_desc: "Monitorizarea Brandurilor AI urmărește dacă ChatGPT, Perplexity, Gemini și Copilot menționează brandul tău atunci când utilizatorii pun întrebări relevante. Primește alerte în timp real și compară-te cu competitorii.",
    pp_comp_desc: "AI Competitor Spy monitorizează strategiile SEO ale competitorilor tăi în timp real. Primești alerte când publică conținut nou, obțin backlink-uri sau își îmbunătățesc scorul de vizibilitate AI.",
    pp_wp_desc: "Pluginul nostru gratuit pentru WordPress aduce TopRankPulse direct în admin-ul tău WordPress. Obține scoruri SEO, urmărește vizibilitatea AI și soluții cu un singur click fără a părăsi tabloul de bord.",
    pp_wp_f1: "Soluții SEO cu un singur click din admin WordPress",
    pp_wp_f2: "Urmărire vizibilitate AI integrată",
    pp_wp_f3: "Optimizare SEO pentru produse WooCommerce",
    pp_wp_f4: "Marcaj schema automat",
    pp_wp_f5: "Gratuit pentru totdeauna pentru toate planurile",
    pp_free_scan: "Primul scan gratuit",
  },
  hr: {
    pc_tag: "Prestanite preplaćivati SEO", pc_h1: "Zamijenite skupe SEO agencije", pc_h1_highlight: "za cijenu obiteljske večere",
    pc_month: "mjesec", pc_best_value: "NAJBOLJA VRIJEDNOST", pc_cta: "POČNITE BESPLATNO",
    fear_warning: "UPOZORENJE", fear_h1: "AI preporučuje brendove", fear_h1_highlight: "DANAS",
    fear_cta_btn: "POČNITE SADA", bm_add_brand: "Dodaj brend", bm_overall: "Ukupna AI vidljivost",
    attr_visits: "AI posjete", attr_conversions: "Konverzije", ls_scan: "SKENIRAJTE WEB",
  
    pc_sub: "Možete isprobati besplatno i početi s rangiranjem danas",
    pc_agency: "SEO Agencija",
    pc_ads_1: "Trebate veliki budžet",
    pc_ads_2: "Ručno istraživanje ključnih riječi",
    pc_ads_3: "Optimizirano za klikove, a ne za prodaju",
    pc_ads_4: "Najam prometa",
    pc_ads_5: "Konkurenti vas nadmašuju",
    pc_ads_6: "Promet prestaje kada prestanete trošiti",
    pc_ads_7: "€0 trajnih rezultata",
    pc_trp_1: "AI piše kvalitetan dnevni sadržaj",
    pc_trp_2: "Automatsko istraživanje ključnih riječi",
    pc_trp_3: "Kvalitetni povratni linkovi uključeni",
    pc_trp_4: "Bez ugovora — otkažite u bilo kojem trenutku",
    pc_trp_5: "Jednom rangirajte, dobijete promet zauvijek",
    pc_trp_6: "Nema potrebe za tehničkim znanjem",
    pc_trp_7: "Izrađeno za privlačenje kupaca, a ne slučajnog prometa",
    pc_ag_1: "Mjeseci do rezultata",
    pc_ag_2: "Tjedni sastanci",
    pc_ag_3: "Zaključani u ugovorima",
    pc_ag_4: "2 objave na blogu/mjesečno za €2,300",
    pc_ag_5: "Sve posjeduju",
    pc_ag_6: "Promet povećan 200%, Prodaja 0%",
    pc_ag_7: "Bez optimizacije za vidljivost AI",
    pc_save_title: "Uštedite 20+ sati & €2,000+/mjesečno",
    pc_save_sub: "Prebacite se s agencija ili Google Ads na TopRankPulse i zadržite više novca u svom džepu.",
    pc_save_cta: "VIDI PLANOVE",
    bm_no_monitors: "Nema brendova koji se prate",
    bm_no_monitors_desc: "Dodajte svoj brend da biste započeli praćenje kako vas vide AI pretraživači.",
    bm_brand_name: "Ime brenda",
    bm_website: "URL web stranice",
    bm_industry: "Industrija",
    bm_location: "Lokacija",
    bm_competitors: "Konkurenti",
    bm_comma: "odvojeno zarezom",
    bm_start: "Započni praćenje",
    bm_recheck: "Ponovno provjeri",
    bm_citation_score: "Rezultat citiranja",
    bm_recommends: "Preporučuje",
    bm_not_cited: "Nije citirano",
    bm_top_rec: "Najbolja preporuka",
    bm_query_analysis: "Analiza upita",
    bm_last_checked: "Zadnji pregled",
    bm_loading: "Analiziram AI vidljivost...",
    bm_recommendations: "Kako povećati svoju vidljivost",
    bm_high: "Visoki utjecaj",
    bm_medium: "Srednji",
    bm_low: "Niski",
    bm_vis_up: "Vidljivost povećana od zadnjeg pregleda",
    bm_vis_down: "Vidljivost smanjena od zadnjeg pregleda",
    attr_desc: "Pogledajte koliko prometa i prihoda donose AI tražilice",
    attr_setup: "Postavljanje atribucije",
    attr_demo: "Demo podaci — instalirajte praćenje piksela da vidite stvarne brojke",
    attr_revenue: "Prihod",
    attr_conv_rate: "Stopa konverzije",
    attr_traffic_30: "AI promet (30 dana)",
    attr_by_source: "Promet po AI izvoru",
    attr_source_details: "Detalji izvora",
    attr_visits_short: "posjeta",
    attr_insights: "AI uvidi",
    attr_pixel: "Piksel praćenja",
    attr_copied: "Kopirano",
    attr_copy: "Kopiraj",
    attr_pixel_desc: "Zalijepite ovo prije </head> na svojoj web stranici kako biste počeli pratiti stvarni AI promet.",
    attr_no_sites: "Nema praćenih stranica još",
    attr_no_sites_desc: "Dodajte svoju web stranicu da vidite koliko prometa donose AI tražilice.",
    attr_add_website: "Dodajte svoju web stranicu",
    ls_stat1: "stranice nevidljive za AI",
    ls_stat2: "prosječne posjete iz AI pretraživanja",
    ls_stat3: "besplatni rezultati revizije",
    ls_f1_t: "Praćenje AI vidljivosti",
    ls_f1_d: "Provjerite citira li ChatGPT, Perplexity & Gemini vašu web stranicu",
    ls_f2_t: "Potpuna SEO revizija",
    ls_f2_d: "Tehnička analiza s preporukama za akciju",
    ls_f3_t: "Ocjena glasovnog pretraživanja",
    ls_f3_d: "Optimizirajte za Siri, Alexa, Google Assistant",
    ls_f4_t: "GEO optimizacija",
    ls_f4_d: "Lokalni SEO za",
    ls_f5_t: "Analiza povratnih veza",
    ls_f5_d: "Provjerite dofollow, nofollow & autoritet domene",
    ls_f6_t: "Brzina stranice",
    ls_f6_d: "Osnovni Web Vitali i rezultat izvedbe",
    ls_more_cities: "Više gradova u",
    ls_top_cities: "Najbolji gradovi u",
    ls_cta_h1: "ZAPOČNITE SVOJU BESPLATNU",
    ls_cta_h2: "SEO AUDIT",
    ls_cta_join: "Pridružite se tvrtkama u",
    ls_cta_using: "koristeći TopRankPulse.",
    ls_free: "Besplatno zauvijek",
    ls_no_card: "Bez kreditne kartice",
    ls_langs: "26 jezika",
    pl_f1_t: "Praćenje AI vidljivosti",
    pl_f1_d: "Provjerite citiraju li ChatGPT, Perplexity i Gemini vašu web stranicu",
    pl_f2_t: "Potpuni SEO Audit",
    pl_f2_d: "Tehnička analiza s preporukama za akciju",
    pl_f3_t: "Istraživanje Ključnih Riječi",
    pl_f3_d: "Pronađite bolje ključne riječi s volumenom, težinom i trendovima",
    pl_f4_t: "Ocjena Glasovnog Pretraživanja",
    pl_f4_d: "Optimizirajte za Siri, Alexu, Google Assistenta",
    pl_f5_t: "AI Preporuke",
    pl_f5_d: "Upute korak po korak za poboljšanje vaše ocjene",
    pl_f6_t: "Widget na Nadzornoj Ploči",
    pl_f6_d: "SEO rezultat izravno u vašoj WordPress nadzornoj ploči",
    pl_f7_t: "Automatsko Skener na Publikaciji",
    pl_f7_d: "Automatski analizira nove objave pri objavi",
    pl_f8_t: "WooCommerce SEO",
    pl_f8_d: "SEO rezultati proizvoda, AI opisi i Google Shopping optimizacija",
    pl_f9_t: "Blog Agent (€25)",
    pl_f9_d: "25 SEO članaka s povratnim vezama na vašu stranicu",
    pl_s3_t: "Skenirajte Vašu Stranicu",
    pl_s3_d: "Kliknite 'Skeniraj Sada' i dobijte svoj SEO rezultat + AI izvještaj o vidljivosti u 30 sekundi.",
    pl_w1_t: "SEO Rezultat Proizvoda",
    pl_w1_d: "Svaki proizvod dobiva SEO rezultat u stvarnom vremenu.",
    pl_w2_t: "Generator AI Opisa",
    pl_w2_d: "AI-generirani SEO opisi proizvoda jednim klikom.",
    pl_w3_t: "Spreman za Google Shopping",
    pl_w3_d: "Poboljšani proizvodni shema za Google Shopping.",
    fear_h1_2: "koji se rangira",
    fear_desc: "ChatGPT, Gemini i Perplexity dobivaju odgovore s stranica s vrhunskim rangiranjem. Ako se sada ne rangirate, AI će preporučiti vaše konkurente — a bit će sve teže stići.",
    fear_m1_label: "Mjesec 1",
    fear_m1_title: "Vaša konkurentska objavljuje sadržaj",
    fear_m1_desc: "Dok čekate, oni grade SEO autoritet i citiraju ih AI alati.",
    fear_m3_label: "Mjesec 3",
    fear_m3_title: "AI ih počinje preporučivati",
    fear_m3_desc: "ChatGPT i Perplexity sada po defaultu citiraju vaše konkurente. Vaša posjeta opada.",
    fear_m6_label: "Mjesec 6",
    fear_m6_title: "Niste vidljivi. Oni posjeduju vašu nišu.",
    fear_m6_desc: "AI modeli podržavaju ono što već funkcionira. Vraćanje na vrh sada košta 10x više truda i novca.",
    fear_urgency: "Svaki dan koji čekate gubite kupce",
    fear_cta_h: "Počnite rangirati prije konkurencije",
    fear_cta_sub: "Brendovi koji danas rangiraju postaju defaultne AI preporuke sutra. Pobrinite se da to budete vi.",
    pp_what_clients_say: "ŠTO KLIJENTI KAŽU",
    pp_start_trial: "Započni besplatno suđenje",
    pp_download_plugin: "Preuzmi dodatak",
    pp_ready: "SPREMNI ZA",
    pp_start: "POČNI",
    pp_join: "Pridružite se tisućama tvrtki koje koriste TopRankPulse.",
    pp_ai_vis_name: "Praćenje AI vidljivosti",
    pp_ai_vis_tag: "Pogledajte citiraju li ChatGPT, Perplexity i Gemini vašu web stranicu",
    pp_ai_vis_desc: "Praćenje AI vidljivosti prati spominju li vodeći AI pretraživači — ChatGPT, Perplexity, Gemini i Copilot — vašu web stranicu kada korisnici postavljaju relevantna pitanja.",
    pp_ai_vis_f1: "Praćenje citata u stvarnom vremenu na 4 AI alata",
    pp_ai_vis_f2: "Tjedni izvještaji o trendovima vidljivosti",
    pp_ai_vis_f3: "Usporedba citata konkurenata",
    pp_ai_vis_f4: "Ocjena spremnosti za glasovno pretraživanje",
    pp_ai_vis_f5: "Preporuke optimiziranog sadržaja za AI",
    pp_ai_vis_f6: "Podrška za 26 jezika s automatskim prepoznavanjem",
    pp_seo_name: "Kompletna SEO analiza",
    pp_seo_tag: "Tehnička SEO analiza s preporukama podržanim AI-jem",
    pp_seo_desc: "Naša Kompletna SEO analiza analizira više od 50 faktora rangiranja uključujući tehnički SEO, kvalitetu sadržaja, povratne veze, brzinu učitavanja stranica, optimizaciju za mobilne uređaje i spremnost za AI.",
    pp_seo_f1: "Analizirano više od 50 faktora rangiranja",
    pp_seo_f2: "Tehničke SEO provjere (meta oznake, naslovi, shema)",
    pp_seo_f3: "Ocjenjivanje kvalitete sadržaja",
    pp_seo_f4: "Analiza profila povratnih veza",
    pp_seo_f5: "Procjena Core Web Vitals-a",
    pp_seo_f6: "Savjeti za optimizaciju za mobilne uređaje",
    pp_seo_f7: "Ocjena spremnosti za AI",
    pp_seo_f8: "PDF izvještaj za preuzimanje",
    pp_brand_name: "Praćenje AI brenda",
    pp_brand_tag: "Praćenje 24/7 ako AI pretraživači spominju vaš brend",
    pp_brand_f1: "Praćenje 24/7 na 4 AI alata",
    pp_brand_f2: "Obavijesti o citatima u stvarnom vremenu putem e-maila",
    pp_brand_f3: "Komparacija benchmarka konkurencije",
    pp_brand_f4: "Praćenje povijesnih trendova s grafikonima",
    pp_brand_f5: "Analiza na razini upita",
    pp_brand_f6: "Preporuke za optimizaciju AI s akcijskim stavkama",
    pp_comp_name: "AI Spy Konkurencije",
    pp_comp_tag: "Inteligencija o konkurenciji u stvarnom vremenu pokretačka od AI",
    pp_comp_f1: "Praćenje SEO-a konkurencije u stvarnom vremenu",
    pp_comp_f2: "Obavijesti o promjenama sadržaja",
    pp_comp_f3: "Praćenje akvizicije povratnih linkova",
    pp_comp_f4: "Usporedba vidljivosti AI",
    pp_comp_f5: "Analiza snaga/slabosti",
    pp_comp_f6: "Identifikacija prilika",
    pp_comp_f7: "Prioritetne obavijesti za promjene s velikim utjecajem",
    pp_blog_name: "Blog Agent",
    pp_blog_tag: "25 SEO članaka s 4 povratna linka svaki — napisano od AI, objavljeno svakodnevno",
    pp_blog_f1: "25 jedinstvenih SEO optimiziranih članaka",
    pp_blog_f2: "Objavljeno 1 dnevno tijekom 25 dana",
    pp_blog_f3: "4 dofollow povratna linka po članku",
    pp_blog_f4: "Automatski prevedeno na 26 jezika",
    pp_blog_f5: "Istraživanje tema temeljenih na vašoj industriji",
    pp_blog_f6: "Dugi sadržaj (1.500+ riječi)",
    pp_blog_f7: "Struktura unutarnjih poveznica",
    pp_blog_f8: "Uključena shema oznaka",
    pp_wp_name: "WordPress + WooCommerce Plugin",
    pp_wp_tag: "Besplatan SEO plugin s ugrađenim praćenjem vidljivosti AI",
    pp_auto_name: "SEO Autopilot",
    pp_auto_tag: "AI automatski ispravlja vaš SEO — ne samo preporuke",
    pp_auto_desc: "SEO Autopilot ne govori samo što treba popraviti — već to popravlja umjesto vas. Naš AI automatski generira optimizirane meta naslove, opise, alt tekstove slika, unutarnje veze i FAQ sekcije. Radi s WordPressom i Shopify-em putem naših pluginova.",
    pp_auto_f1: "Automatski generiraj SEO meta naslove i opise",
    pp_auto_f2: "Automatski generiraj alt tekstove slika",
    pp_auto_f3: "Pametni prijedlozi za unutarnje povezivanje",
    pp_auto_f4: "Generiranje FAQ sekcije s shema oznakom",
    pp_auto_f5: "Otkrivanje neispravnih veza i prijedlozi za preusmjeravanje",
    pp_auto_f6: "Tjedno automatsko skeniranje",
    pp_auto_f7: "Integracija pluginova za WordPress i Shopify",
    pp_auto_f8: "Praćenje rezultata prije/poslije",
    pp_sim_name: "AI Simulator Pretraživanja",
    pp_sim_tag: "Pogledajte što bi ChatGPT, Perplexity & Gemini odgovorili — gratis",
    pp_sim_desc: "AI Simulator Pretraživanja omogućuje vam da postavite bilo koje pitanje i vidite simulirane odgovore iz ChatGPT-a, Perplexity-a, Gemini-a i Copilota. Saznajte bi li vaša web stranica bila spomenuta u AI pretraživačkim rezultatima.",
    pp_sim_f1: "Simuliraj AI pretraživačke odgovore iz 4 motora",
    pp_sim_f2: "Provjerite citira li se vaša web stranica",
    pp_sim_f3: "Testirajte bilo koju ključnu riječ ili pitanje",
    pp_sim_f4: "Besplatna neograničena pretraživanja",
    pp_sim_f5: "Podrška za 26 jezika",
    pp_blog_desc: "Blog Agent piše 25 SEO-optimiziranih članaka za vašu web stranicu — jedan dnevno tijekom 25 dana. Svaki članak uključuje 4 dofollow povratne veze, automatski se prevodi na 26 jezika i objavljuje prema rasporedu.",
    pp_brand_desc: "AI Praćenje brenda prati spominje li ChatGPT, Perplexity, Gemini i Copilot vaš brend kada korisnici postavljaju relevantna pitanja. Dobijte obavijesti u stvarnom vremenu i usporedite se s konkurencijom.",
    pp_comp_desc: "AI Špijun konkurencije prati strategije SEO-a vaših konkurenata u stvarnom vremenu. Dobijte obavijesti kada objave novi sadržaj, dobiju povratne veze ili poboljšaju svoj rezultat vidljivosti u AI.",
    pp_wp_desc: "Naš besplatni WordPress dodatak dovodi TopRankPulse izravno u vašu WordPress administraciju. Dobijte SEO rezultate, praćenje vidljivosti u AI i ispravke jednim klikom bez napuštanja vašeg kontrolnog panela.",
    pp_wp_f1: "Ispravke SEO-a jednim klikom iz WordPress administracije",
    pp_wp_f2: "Ugrađeno praćenje vidljivosti u AI",
    pp_wp_f3: "SEO optimizacija proizvoda za WooCommerce",
    pp_wp_f4: "Automatsko označavanje sheme",
    pp_wp_f5: "Besplatno zauvijek za sve planove",
    pp_free_scan: "Besplatno prvo skeniranje",
  },
  tr: {
    pc_tag: "SEO'ya fazla ödemeyi bırakın", pc_h1: "Pahalı SEO ajanslarını değiştirin", pc_h1_highlight: "bir aile yemeği fiyatına",
    pc_month: "ay", pc_best_value: "EN İYİ DEĞER", pc_cta: "ÜCRETSİZ BAŞLA",
    fear_warning: "UYARI", fear_h1: "AI markaları öneriyor", fear_h1_highlight: "BUGÜN",
    fear_cta_btn: "ŞİMDİ BAŞLA", bm_add_brand: "Marka ekle", bm_overall: "Genel AI görünürlüğü",
    attr_visits: "AI ziyaretleri", attr_conversions: "Dönüşümler", ls_scan: "WEB SİTENİZİ TARAYIN",
  
    pc_sub: "Ücretsiz deneyebilir ve bugünden itibaren sıralamaya başlayabilirsiniz",
    pc_agency: "SEO Ajansı",
    pc_ads_1: "Büyük bir bütçeye ihtiyacınız var",
    pc_ads_2: "Manuel anahtar kelime araştırması",
    pc_ads_3: "Tıklamalar için optimize edilmiş, satış için değil",
    pc_ads_4: "Kiralık trafik",
    pc_ads_5: "Rakipler sizi geçiyor",
    pc_ads_6: "Harcamayı bıraktığınızda trafik durur",
    pc_ads_7: "Kalıcı sonuçlar için €0",
    pc_trp_1: "AI kaliteli günlük içerik yazar",
    pc_trp_2: "Otomatik anahtar kelime araştırması",
    pc_trp_3: "Kaliteli geri bağlantılar dahil",
    pc_trp_4: "Sözleşme yok — istediğiniz zaman iptal edin",
    pc_trp_5: "Bir kez sıralama al, sonsuza dek trafik elde et",
    pc_trp_6: "Teknik bilgiye gerek yok",
    pc_trp_7: "Alıcıları getirmek üzere tasarlandı, rastgele trafik değil",
    pc_ag_1: "Sonuç görmek için aylar",
    pc_ag_2: "Haftalık toplantılar",
    pc_ag_3: "Sözleşmelere bağlısınız",
    pc_ag_4: "Aylık €2,300 karşılığında 2 blog yazısı",
    pc_ag_5: "Her şeye sahipler",
    pc_ag_6: "Trafik %200 arttı, Satış %0",
    pc_ag_7: "AI görünürlük optimizasyonu yok",
    pc_save_title: "20+ saat ve €2,000+/ay tasarruf edin",
    pc_save_sub: "Ajanslardan veya Google Ads'ten TopRankPulse'a geçin ve cebinizde daha fazla para tutun.",
    pc_save_cta: "PLÂNLARI GÖRÜN",
    bm_no_monitors: "Henüz İzlenen Marka Yok",
    bm_no_monitors_desc: "Markanızı ekleyin, AI arama motorlarının sizi nasıl gördüğünü takip etmeye başlayın.",
    bm_brand_name: "Marka Adı",
    bm_website: "Web Sitesi URL'si",
    bm_industry: "Sektör",
    bm_location: "Konum",
    bm_competitors: "Rakipler",
    bm_comma: "virgülle ayrılmış",
    bm_start: "İzlemeye Başlayın",
    bm_recheck: "Yeniden Kontrol Et",
    bm_citation_score: "Atıf Skoru",
    bm_recommends: "Önerilen",
    bm_not_cited: "Atıf yok",
    bm_top_rec: "En İyi Öneri",
    bm_query_analysis: "Sorgu Analizi",
    bm_last_checked: "Son kontrol tarihi",
    bm_loading: "AI görünürlüğü analiz ediliyor...",
    bm_recommendations: "Görünürlüğünüzü nasıl artırabilirsiniz",
    bm_high: "Yüksek Etki",
    bm_medium: "Orta",
    bm_low: "Düşük",
    bm_vis_up: "Son kontrolden bu yana görünürlük artırıldı",
    bm_vis_down: "Son kontrolden bu yana görünürlük azaldı",
    attr_desc: "AI arama motorlarının size ne kadar trafik ve gelir getirdiğini tam olarak görün",
    attr_setup: "Attribution Ayarları",
    attr_demo: "Demo verisi — gerçek rakamları görmek için izleme pikselini kurun",
    attr_revenue: "Gelir",
    attr_conv_rate: "Dönüşüm Oranı",
    attr_traffic_30: "AI Trafiği (30 Gün)",
    attr_by_source: "AI Kaynağına Göre Trafik",
    attr_source_details: "Kaynak Ayrıntıları",
    attr_visits_short: "ziyaretler",
    attr_insights: "AI İçgörüleri",
    attr_pixel: "İzleme Pikseli",
    attr_copied: "Kopyalandı",
    attr_copy: "Kopyala",
    attr_pixel_desc: "Gerçek AI trafiğini izlemeye başlamak için bunu web sitenizin </head> kısmından önce yapıştırın.",
    attr_no_sites: "Henüz İzlenen Site Yok",
    attr_no_sites_desc: "AI arama motorlarının size ne kadar trafik getirdiğini görmek için web sitenizi ekleyin.",
    attr_add_website: "Web Sitenizi Ekleyin",
    ls_stat1: "AI'ye görünmeyen siteler",
    ls_stat2: "AI aramasından ortalama ziyaretler",
    ls_stat3: "ücretsiz denetim sonuçları",
    ls_f1_t: "AI Görünürlüğü İzleme",
    ls_f1_d: "ChatGPT, Perplexity & Gemini web sitenizi atıf ediyor mu kontrol edin",
    ls_f2_t: "Tam SEO Denetimi",
    ls_f2_d: "Eyleme dönüştürülebilir önerilerle teknik analiz",
    ls_f3_t: "Sesli Arama Puanı",
    ls_f3_d: "Siri, Alexa, Google Asistan için optimize edin",
    ls_f4_t: "GEO Optimizasyonu",
    ls_f4_d: "Yerel SEO için",
    ls_f5_t: "Backlink Analizi",
    ls_f5_d: "dofollow, nofollow & alan otoritesini kontrol edin",
    ls_f6_t: "Site Hızı",
    ls_f6_d: "Ana Web Vitals ve performans puanı",
    ls_more_cities: "Daha fazla şehirde",
    ls_top_cities: "En iyi şehirler",
    ls_cta_h1: "ÜCRETSİZ BAŞLAYIN",
    ls_cta_h2: "SEO DENETİMİ",
    ls_cta_join: "işletmelere katılın",
    ls_cta_using: "TopRankPulse kullanarak.",
    ls_free: "Sonsuza dek ücretsiz",
    ls_no_card: "Kredi kartı yok",
    ls_langs: "26 dil",
    pl_f1_t: "AI Görünürlük Takibi",
    pl_f1_d: "ChatGPT, Perplexity ve Gemini sitenizi alıntılayacak mı görün",
    pl_f2_t: "Tam SEO Denetimi",
    pl_f2_d: "Eyleme geçirilebilir önerilerle teknik analiz",
    pl_f3_t: "Anahtar Kelime Araştırması",
    pl_f3_d: "Hacim, zorluk ve trendlerle daha iyi anahtar kelimeleri bulun",
    pl_f4_t: "Sesli Arama Puanı",
    pl_f4_d: "Siri, Alexa, Google Asistan için optimize edin",
    pl_f5_t: "AI Önerileri",
    pl_f5_d: "Puanınızı artırmak için adım adım talimatlar",
    pl_f6_t: "Gösterge Tablosu Aracı",
    pl_f6_d: "WordPress gösterge tablonuzda doğrudan SEO puanı",
    pl_f7_t: "Yayınlandığında Otomatik Tarama",
    pl_f7_d: "Yeni gönderiler yayımlandığında otomatik olarak analiz eder",
    pl_f8_t: "WooCommerce SEO",
    pl_f8_d: "Ürün SEO puanları, AI açıklamaları ve Google Alışveriş optimizasyonu",
    pl_f9_t: "Blog Temsilcisi (€25)",
    pl_f9_d: "Sitenize geri bağlantı veren 25 SEO makalesi",
    pl_s3_t: "Sitenizi Tara",
    pl_s3_d: "'Tara'ya tıklayın ve 30 saniyede SEO puanınızı + AI görünürlük raporunuzu alın.",
    pl_w1_t: "Ürün SEO Puanı",
    pl_w1_d: "Her ürün gerçek zamanlı bir SEO puanı alır.",
    pl_w2_t: "AI Açıklama Üretici",
    pl_w2_d: "Tek tıklamayla AI tarafından üretilen SEO ürün açıklamaları.",
    pl_w3_t: "Google Alışverişe Hazır",
    pl_w3_d: "Google Alışveriş için geliştirilmiş ürün şeması işaretlemesi.",
    fear_h1_2: "bu sıralarda",
    fear_desc: "ChatGPT, Gemini ve Perplexity en yüksek sıralamalardaki sayfalardan cevaplar çekiyor. Eğer şimdi sıralamada değilseniz, AI rakiplerinizi önerecek - ve yetişmek sadece zorlaşıyor.",
    fear_m1_label: "1. Ay",
    fear_m1_title: "Rakibiniz içerik yayımlıyor",
    fear_m1_desc: "Beklerken, SEO otoritesi oluşturuyorlar ve AI motorları tarafından alıntı alıyorlar.",
    fear_m3_label: "3. Ay",
    fear_m3_title: "AI onları önermeye başlıyor",
    fear_m3_desc: "ChatGPT ve Perplexity artık rakiplerinizi varsayılan olarak alıntı alıyor. Trafiğiniz düşüyor.",
    fear_m6_label: "6. Ay",
    fear_m6_title: "Görünmezsiniz. Onlar nişinizi sahipleniyor.",
    fear_m6_desc: "AI modelleri, zaten işe yarayanları pekiştiriyor. Yakalamak artık 10 kat daha fazla çaba ve para gerektiriyor.",
    fear_urgency: "Her gün bekledikçe, müşterilerinizi kaybediyorsunuz",
    fear_cta_h: "Rakiplerinizden önce sıralamaya başlayın",
    fear_cta_sub: "Bugün sıralanan markalar, yarın varsayılan AI önerileri olur. Bu, siz olun.",
    pp_what_clients_say: "MÜŞTERİLER NE DİYOR",
    pp_start_trial: "Ücretsiz Deneme Başlat",
    pp_download_plugin: "Eklentiyi İndir",
    pp_ready: "HAZIR",
    pp_start: "BAŞLA",
    pp_join: "TopRankPulse'u kullanan binlerce işletmeye katılın.",
    pp_ai_vis_name: "AI Görünürlük Takibi",
    pp_ai_vis_tag: "ChatGPT, Perplexity ve Gemini web sitenizi alıntı alıyor mu görün",
    pp_ai_vis_desc: "AI Görünürlük Takibi, dünyanın önde gelen AI arama motorları - ChatGPT, Perplexity, Gemini ve Copilot - kullanıcılar ilgili sorular sorduğunda web sitenizi bahsedip bahsetmediğini izler.",
    pp_ai_vis_f1: "4 AI motorunda gerçek zamanlı alıntı takibi",
    pp_ai_vis_f2: "Haftalık görünürlük trend raporları",
    pp_ai_vis_f3: "Rakip alıntı karşılaştırması",
    pp_ai_vis_f4: "Sesli arama hazırlık puanı",
    pp_ai_vis_f5: "AI optimize içerik önerileri",
    pp_ai_vis_f6: "Otomatik algılama ile 26 dil desteği",
    pp_seo_name: "Tam SEO Denetimi",
    pp_seo_tag: "AI destekli önerilerle teknik SEO analizi",
    pp_seo_desc: "Tam SEO Denetimimiz, teknik SEO, içerik kalitesi, geri bağlantılar, sayfa hızı, mobil optimizasyon ve AI hazırlığı dahil 50+ sıralama faktörünü analiz eder.",
    pp_seo_f1: "50+ sıralama faktörü analiz edildi",
    pp_seo_f2: "Teknik SEO kontrolleri (meta etiketleri, başlıklar, şema)",
    pp_seo_f3: "İçerik kalitesi puanlaması",
    pp_seo_f4: "Geri bağlantı profili analizi",
    pp_seo_f5: "Core Web Vitals değerlendirmesi",
    pp_seo_f6: "Mobil öncelikli optimizasyon ipuçları",
    pp_seo_f7: "AI hazırlık puanı",
    pp_seo_f8: "İndirilebilir PDF raporu",
    pp_brand_name: "AI Marka Takibi",
    pp_brand_tag: "AI arama motorlarının markanızı bahsetmesi durumunda 24/7 izleme",
    pp_brand_f1: "4 AI motorunda 24/7 izleme",
    pp_brand_f2: "E-posta ile gerçek zamanlı alıntı uyarıları",
    pp_brand_f3: "Rakip benchmark karşılaştırması",
    pp_brand_f4: "Grafiklerle tarihsel trend takibi",
    pp_brand_f5: "Sorgu düzeyinde analiz",
    pp_brand_f6: "Uygulanabilir AI optimizasyon önerileri",
    pp_comp_name: "AI Rakip Casusu",
    pp_comp_tag: "AI destekli gerçek zamanlı rekabetçi zeka",
    pp_comp_f1: "Gerçek zamanlı rakip SEO izleme",
    pp_comp_f2: "İçerik değişiklik uyarıları",
    pp_comp_f3: "Geri bağlantı edinim takibi",
    pp_comp_f4: "AI görünürlük karşılaştırması",
    pp_comp_f5: "Güçlü/zayıf analiz",
    pp_comp_f6: "Fırsat belirleme",
    pp_comp_f7: "Yüksek etkili değişiklikler için öncelik uyarıları",
    pp_blog_name: "Blog Aracı",
    pp_blog_tag: "Her biri 4 geri bağlantıya sahip 25 SEO makalesi — AI tarafından yazılmış, günlük yayınlanıyor",
    pp_blog_f1: "25 benzersiz SEO uyumlu makale",
    pp_blog_f2: "25 gün boyunca günde 1 yayınlandı",
    pp_blog_f3: "Her makalede 4 dofollow geri bağlantı",
    pp_blog_f4: "26 dile otomatik olarak çevrildi",
    pp_blog_f5: "Sektörünüze dayalı konu araştırması",
    pp_blog_f6: "Uzun biçimli içerik (1.500+ kelime)",
    pp_blog_f7: "Dahili bağlantı yapısı",
    pp_blog_f8: "Schema işaretlemesi dahil",
    pp_wp_name: "WordPress + WooCommerce Eklentisi",
    pp_wp_tag: "AI görünürlük takibi ile ücretsiz SEO eklentisi",
    pp_auto_name: "SEO Otonom Pilot",
    pp_auto_tag: "AI, SEO'nuzu otomatik olarak düzeltir — sadece öneriler değil",
    pp_auto_desc: "SEO Otonom Pilot, size neyi düzeltmeniz gerektiğini söylemekle kalmaz — bunu sizin yerinize düzeltir. AI'ımız otomatik olarak optimize edilmiş meta başlıkları, açıklamaları, resim alternatif metinlerini, dahili bağlantıları ve SSS bölümlerini oluşturur. WordPress ve Shopify ile eklentilerimiz aracılığıyla çalışır.",
    pp_auto_f1: "SEO meta başlıkları ve açıklamaları otomatik oluştur",
    pp_auto_f2: "Resim alternatif metinleri otomatik oluştur",
    pp_auto_f3: "Akıllı dahili bağlantı önerileri",
    pp_auto_f4: "Schema işaretlemesi ile SSS bölümü oluşturma",
    pp_auto_f5: "Kırık bağlantı tespiti ve yönlendirme önerileri",
    pp_auto_f6: "Haftalık otomatik taramalar",
    pp_auto_f7: "WordPress & Shopify eklenti entegrasyonu",
    pp_auto_f8: "Önceki/sonraki puan takibi",
    pp_sim_name: "AI Arama Simülatörü",
    pp_sim_tag: "ChatGPT, Perplexity & Gemini'nin ne cevap vereceğini görün — ücretsiz",
    pp_sim_desc: "AI Arama Simülatörü, her türlü soruyu yazmanıza ve ChatGPT, Perplexity, Gemini ve Copilot'tan simüle edilmiş yanıtları görmenize olanak tanır. Web sitenizin AI arama sonuçlarında bahsedilip bahsedilmeyeceğini öğrenin.",
    pp_sim_f1: "4 motorun AI arama yanıtlarını simüle et",
    pp_sim_f2: "Web sitenizin atıf alıp almadığını kontrol edin",
    pp_sim_f3: "Herhangi bir anahtar kelime veya soru test edin",
    pp_sim_f4: "Ücretsiz sınırsız sorgular",
    pp_sim_f5: "26 dil desteği",
    pp_blog_desc: "Blog Ajansı, web siteniz için 25 SEO optimizasyonlu makale yazar — 25 gün boyunca günde bir. Her makale 4 dofollow bağlantı içerir, 26 dile otomatik olarak çevrilir ve zamanında yayımlanır.",
    pp_brand_desc: "AI Marka Takibi, ChatGPT, Perplexity, Gemini ve Copilot'un, kullanıcılar ilgili sorular sorduğunda markanızı anıp anmadığını izler. Gerçek zamanlı bildirimler alın ve rakiplerinizle karşılaştırın.",
    pp_comp_desc: "AI Rakip Casusu, rakiplerinizin SEO stratejilerini gerçek zamanlı olarak izler. Yeni içerik yayımladıklarında, geri bağlantılar edindiklerinde veya AI görünürlük puanlarını geliştirdiklerinde bildirim alın.",
    pp_wp_desc: "Ücretsiz WordPress eklentimiz, TopRankPulse'u WordPress admininize doğrudan getirir. SEO puanları, AI görünürlük takibi ve tek tıkla düzeltmeler ile kontrol panelinizi terk etmeden geri alın.",
    pp_wp_f1: "WordPress admin panelinden tek tıkla SEO düzeltmeleri",
    pp_wp_f2: "Yerleşik AI görünürlük takibi",
    pp_wp_f3: "WooCommerce ürün SEO optimizasyonu",
    pp_wp_f4: "Otomatik şema işaretlemesi",
    pp_wp_f5: "Tüm planlar için sonsuza kadar ücretsiz",
    pp_free_scan: "Ücretsiz ilk tarama",
  },
  ja: {
    pc_tag: "SEOへの過剰支払いをやめましょう", pc_h1: "高額なSEO代理店を置き換え", pc_h1_highlight: "家族の夕食の価格で",
    pc_month: "月", pc_best_value: "最高の価値", pc_cta: "無料で開始",
    fear_warning: "警告", fear_h1: "AIはブランドを推薦します", fear_h1_highlight: "今日",
    fear_cta_btn: "今すぐ開始", bm_add_brand: "ブランド追加", bm_overall: "AI総合可視性",
    attr_visits: "AI訪問", attr_conversions: "コンバージョン", ls_scan: "サイトをスキャン",
  
    pc_sub: "無料でお試しいただき、今日からランキングを開始できます",
    pc_agency: "SEOエージェンシー",
    pc_ads_1: "大きな予算が必要",
    pc_ads_2: "手動キーワードリサーチ",
    pc_ads_3: "クリック向けに最適化、売上向けではない",
    pc_ads_4: "レンタルトラフィック",
    pc_ads_5: "競合に入札で負ける",
    pc_ads_6: "支出を止めるとトラフィックも停止",
    pc_ads_7: "€0の持続的な結果",
    pc_trp_1: "AIが質の高い日々のコンテンツを作成",
    pc_trp_2: "自動キーワードリサーチ",
    pc_trp_3: "質の高いバックリンクが含まれる",
    pc_trp_4: "契約なし — いつでもキャンセル可能",
    pc_trp_5: "一度ランキングすれば、永久にトラフィックが得られる",
    pc_trp_6: "技術的な知識は不要",
    pc_trp_7: "無関係なトラフィックではなく、バイヤーを呼び込むために構築された",
    pc_ag_1: "結果が出るまで数ヶ月",
    pc_ag_2: "週次会議",
    pc_ag_3: "契約に縛られる",
    pc_ag_4: "€2,300で月2回のブログ投稿",
    pc_ag_5: "すべてを所有している",
    pc_ag_6: "トラフィック200%増加、売上0%",
    pc_ag_7: "AIの可視性最適化なし",
    pc_save_title: "20時間以上 & €2,000以上/月を節約",
    pc_save_sub: "エージェンシーやGoogle AdsからTopRankPulseに切り替えて、より多くのお金を手元に残しましょう。",
    pc_save_cta: "プランを見る",
    bm_no_monitors: "監視されているブランドはありません",
    bm_no_monitors_desc: "ブランドを追加して、AI検索エンジンがあなたをどう見ているかを追跡開始しましょう。",
    bm_brand_name: "ブランド名",
    bm_website: "ウェブサイトURL",
    bm_industry: "業界",
    bm_location: "所在地",
    bm_competitors: "競合",
    bm_comma: "カンマで区切って",
    bm_start: "監視を開始",
    bm_recheck: "再チェック",
    bm_citation_score: "引用スコア",
    bm_recommends: "推奨",
    bm_not_cited: "引用なし",
    bm_top_rec: "トップ推奨",
    bm_query_analysis: "クエリ分析",
    bm_last_checked: "最終チェック",
    bm_loading: "AIの可視性を分析中...",
    bm_recommendations: "可視性を向上させる方法",
    bm_high: "高影響",
    bm_medium: "中程度",
    bm_low: "低",
    bm_vis_up: "前回のチェック以来可視性が増加",
    bm_vis_down: "前回のチェック以来可視性が減少",
    attr_desc: "AI検索エンジンがどれだけのトラフィックと収益をもたらしているか正確に確認できます",
    attr_setup: "アトリビューションの設定",
    attr_demo: "デモデータ — トラッキングピクセルをインストールして実際の数値を確認してください",
    attr_revenue: "収益",
    attr_conv_rate: "コンバージョン率",
    attr_traffic_30: "AIトラフィック（30日間）",
    attr_by_source: "AIソース別のトラフィック",
    attr_source_details: "ソースの詳細",
    attr_visits_short: "訪問数",
    attr_insights: "AIインサイト",
    attr_pixel: "トラッキングピクセル",
    attr_copied: "コピーしました",
    attr_copy: "コピー",
    attr_pixel_desc: "このコードをウェブサイトの</head>の前に貼り付けて、実際のAIトラフィックを追跡します。",
    attr_no_sites: "まだトラッキングされているサイトはありません",
    attr_no_sites_desc: "あなたのウェブサイトを追加して、AI検索エンジンがどれだけのトラフィックをもたらしているかを確認してください。",
    attr_add_website: "ウェブサイトを追加",
    ls_stat1: "AIに見えないサイト",
    ls_stat2: "AI検索からの平均訪問数",
    ls_stat3: "無料監査結果",
    ls_f1_t: "AI可視性トラッキング",
    ls_f1_d: "ChatGPT、Perplexity、Geminiがあなたのウェブサイトを引用しているか確認します",
    ls_f2_t: "完全なSEO監査",
    ls_f2_d: "実行可能な推奨事項を含む技術分析",
    ls_f3_t: "音声検索スコア",
    ls_f3_d: "Siri、Alexa、Googleアシスタント用に最適化",
    ls_f4_t: "GEO最適化",
    ls_f4_d: "ローカルSEOについて",
    ls_f5_t: "バックリンク分析",
    ls_f5_d: "ドフォロウ、ノーフォロウおよびドメイン権威を確認",
    ls_f6_t: "サイト速度",
    ls_f6_d: "コアウェブバイタルとパフォーマンススコア",
    ls_more_cities: "他の都市",
    ls_top_cities: "主要都市",
    ls_cta_h1: "無料で始める",
    ls_cta_h2: "SEO監査",
    ls_cta_join: "ビジネスに参加する",
    ls_cta_using: "TopRankPulseを利用中。",
    ls_free: "永遠に無料",
    ls_no_card: "クレジットカード不要",
    ls_langs: "26の言語",
    pl_f1_t: "AI可視性トラッキング",
    pl_f1_d: "ChatGPT、Perplexity、Geminiがあなたのウェブサイトを引用しているか確認します。",
    pl_f2_t: "完全なSEO監査",
    pl_f2_d: "実行可能な推奨事項を伴う技術分析",
    pl_f3_t: "キーワードリサーチ",
    pl_f3_d: "ボリューム、難易度、トレンドに基づいてより良いキーワードを見つけます。",
    pl_f4_t: "音声検索スコア",
    pl_f4_d: "Siri、Alexa、Googleアシスタント用に最適化",
    pl_f5_t: "AI推奨",
    pl_f5_d: "スコアを改善するためのステップバイステップの指示",
    pl_f6_t: "ダッシュボードウィジェット",
    pl_f6_d: "WordPressダッシュボードで直接SEOスコアを表示",
    pl_f7_t: "公開時自動スキャン",
    pl_f7_d: "公開時に新しい投稿を自動的に分析",
    pl_f8_t: "WooCommerce SEO",
    pl_f8_d: "商品のSEOスコア、AI説明、Googleショッピングの最適化",
    pl_f9_t: "ブログエージェント (€25)",
    pl_f9_d: "あなたのサイトへのバックリンク付き25のSEO記事",
    pl_s3_t: "サイトをスキャン",
    pl_s3_d: "'今すぐスキャン'をクリックして、30秒でSEOスコア+AI可視性レポートを取得します。",
    pl_w1_t: "製品SEOスコア",
    pl_w1_d: "各製品はリアルタイムのSEOスコアを取得します。",
    pl_w2_t: "AI説明生成器",
    pl_w2_d: "ワンクリックで生成されるAIのSEO製品説明。",
    pl_w3_t: "Googleショッピング対応",
    pl_w3_d: "Googleショッピング用の強化された製品スキーママークアップ。",
    fear_h1_2: "ランクする",
    fear_desc: "ChatGPT、Gemini、Perplexityは、上位ページから回答を引き出します。もしあなたが現在ランクしていない場合、AIは競合他社を推奨します — そして、追いつくことはますます難しくなります。",
    fear_m1_label: "第1月",
    fear_m1_title: "あなたの競合がコンテンツを公開します",
    fear_m1_desc: "待っている間に、彼らはSEO権威を築き、AIエンジンに引用されています。",
    fear_m3_label: "3ヶ月目",
    fear_m3_title: "AIが彼らを推薦し始める",
    fear_m3_desc: "ChatGPTとPerplexityはデフォルトで競合他社を引用します。あなたのトラフィックが減少します。",
    fear_m6_label: "6ヶ月目",
    fear_m6_title: "あなたは見えない。彼らがあなたのニッチを支配しています。",
    fear_m6_desc: "AIモデルは既に効果的なものを強化します。追いつくためには10倍の努力とお金が必要です。",
    fear_urgency: "待っている間に、顧客を失います。",
    fear_cta_h: "競合他社より先にランキングを始める",
    fear_cta_sub: "今日ランキングを取得しているブランドが明日のデフォルトAI推奨となります。あなたであることを確実にしましょう。",
    pp_what_clients_say: "クライアントの声",
    pp_start_trial: "無料トライアルを開始",
    pp_download_plugin: "プラグインをダウンロード",
    pp_ready: "準備ができたら",
    pp_start: "開始",
    pp_join: "TopRankPulseを利用する何千もの企業に参加してください。",
    pp_ai_vis_name: "AI可視性追跡",
    pp_ai_vis_tag: "ChatGPT、Perplexity、Geminiがあなたのウェブサイトを引用しているか確認",
    pp_ai_vis_desc: "AI可視性追跡は、世界をリードするAI検索エンジン（ChatGPT、Perplexity、Gemini、Copilot）が、ユーザーが関連する質問をした際にあなたのウェブサイトを言及しているかどうかを監視します。",
    pp_ai_vis_f1: "4つのAIエンジン全体でのリアルタイム引用監視",
    pp_ai_vis_f2: "毎週の可視性トレンドレポート",
    pp_ai_vis_f3: "競合他社の引用比較",
    pp_ai_vis_f4: "音声検索の準備スコア",
    pp_ai_vis_f5: "AI最適化されたコンテンツの推奨",
    pp_ai_vis_f6: "自動検出による26言語サポート",
    pp_seo_name: "完全SEO監査",
    pp_seo_tag: "AIによる推奨を伴う技術的SEO分析",
    pp_seo_desc: "私たちの完全SEO監査は、技術的SEO、コンテンツの質、バックリンク、ページ速度、モバイル最適化、AIの準備状況を含む50以上のランキング要因を分析します。",
    pp_seo_f1: "50以上のランキング要因を分析",
    pp_seo_f2: "技術的SEOチェック（メタタグ、ヘッダー、スキーマ）",
    pp_seo_f3: "コンテンツ品質スコアリング",
    pp_seo_f4: "バックリンクプロファイル分析",
    pp_seo_f5: "コアウェブバイタル評価",
    pp_seo_f6: "モバイルファースト最適化のヒント",
    pp_seo_f7: "AI準備スコア",
    pp_seo_f8: "ダウンロード可能なPDFレポート",
    pp_brand_name: "AIブランド監視",
    pp_brand_tag: "AI検索エンジンがあなたのブランドを言及しているか24/7監視",
    pp_brand_f1: "4つのAIエンジン全体での24/7監視",
    pp_brand_f2: "メールによるリアルタイム引用アラート",
    pp_brand_f3: "競合ベンチマーク比較",
    pp_brand_f4: "グラフによる履歴トレンド追跡",
    pp_brand_f5: "クエリレベルの分析",
    pp_brand_f6: "実行可能なAI最適化提案",
    pp_comp_name: "AI競合スパイ",
    pp_comp_tag: "AIによるリアルタイム競争インテリジェンス",
    pp_comp_f1: "リアルタイム競合SEOモニタリング",
    pp_comp_f2: "コンテンツ変更のアラート",
    pp_comp_f3: "バックリンク獲得の追跡",
    pp_comp_f4: "AI可視性比較",
    pp_comp_f5: "強み/弱みの分析",
    pp_comp_f6: "機会の特定",
    pp_comp_f7: "高影響な変更に対する優先アラート",
    pp_blog_name: "ブログエージェント",
    pp_blog_tag: "25本のSEO記事（各記事に4つのバックリンク）— AIが執筆し、毎日公開",
    pp_blog_f1: "25本のユニークなSEO最適化記事",
    pp_blog_f2: "25日間で1本ずつ公開",
    pp_blog_f3: "各記事に4つのドフォローバックリンク",
    pp_blog_f4: "26言語に自動翻訳",
    pp_blog_f5: "業界に基づいたトピックリサーチ",
    pp_blog_f6: "長文コンテンツ（1,500語以上）",
    pp_blog_f7: "内部リンク構造",
    pp_blog_f8: "スキーママークアップを含む",
    pp_wp_name: "WordPress + WooCommerceプラグイン",
    pp_wp_tag: "AI可視性追跡機能を搭載した無料SEOプラグイン",
    pp_auto_name: "SEOオートパイロット",
    pp_auto_tag: "AIが自動的にSEOを修正 — ただの提案ではありません",
    pp_auto_desc: "SEOオートパイロットは、何を修正すべきかを教えるだけでなく、自動で修正します。当社のAIは、最適化されたメタタイトル、説明、画像の代替テキスト、内部リンク、FAQセクションを自動生成します。WordPressとShopifyでプラグインを通じて動作します。",
    pp_auto_f1: "SEOメタタイトルと説明の自動生成",
    pp_auto_f2: "画像の代替テキストの自動生成",
    pp_auto_f3: "スマート内部リンク提案",
    pp_auto_f4: "スキーママークアップ付きFAQセクションの生成",
    pp_auto_f5: "リンク切れの検出とリダイレクト提案",
    pp_auto_f6: "毎週の自動スキャン",
    pp_auto_f7: "WordPressとShopifyのプラグイン統合",
    pp_auto_f8: "ビフォー/アフターのスコア追跡",
    pp_sim_name: "AI検索シミュレーター",
    pp_sim_tag: "ChatGPT、Perplexity、Geminiがどのように回答するかを無料で確認",
    pp_sim_desc: "AI検索シミュレーターでは、任意の質問を入力し、ChatGPT、Perplexity、Gemini、Copilotからのシミュレーションされた応答を見ることができます。あなたのウェブサイトがAI検索結果に登場するかどうかを確認できます。",
    pp_sim_f1: "4つのエンジンからのAI検索応答をシミュレート",
    pp_sim_f2: "ウェブサイトが引用されているか確認する",
    pp_sim_f3: "任意のキーワードや質問をテストする",
    pp_sim_f4: "無制限の無料クエリ",
    pp_sim_f5: "26言語対応",
    pp_blog_desc: "ブログエージェントは、あなたのウェブサイトのために25本のSEO最適化された記事を書きます — 25日間、1日1本。各記事には4つのドフォローバックリンクが含まれ、26言語に自動翻訳され、予定通りに公開されます。",
    pp_brand_desc: "AIブランドモニタリングは、ChatGPT、Perplexity、Gemini、およびCopilotがユーザーが関連する質問をした際にあなたのブランドに言及するかどうかを追跡します。リアルタイムのアラートを受け取り、競合と比較できます。",
    pp_comp_desc: "AI競合スパイは、リアルタイムで競合のSEO戦略を監視します。彼らが新しいコンテンツを公開したり、バックリンクを獲得したり、AI視認性スコアを向上させた際にアラートを受け取ります。",
    pp_wp_desc: "私たちの無料WordPressプラグインは、TopRankPulseを直接あなたのWordPress管理画面に取り込みます。SEOスコア、AI視認性追跡、ダッシュボードを離れることなくワンクリックで修正を行えます。",
    pp_wp_f1: "WordPress管理画面からのワンクリックSEO修正",
    pp_wp_f2: "内蔵のAI視認性追跡",
    pp_wp_f3: "WooCommerce商品のSEO最適化",
    pp_wp_f4: "自動スキーママークアップ",
    pp_wp_f5: "すべてのプランで永遠に無料",
    pp_free_scan: "初回無料スキャン",
  },
  ko: {
    pc_tag: "SEO에 과다 지출을 중단하세요", pc_h1: "비싼 SEO 대행사를 교체하세요", pc_h1_highlight: "가족 저녁 식사 가격으로",
    pc_month: "월", pc_best_value: "최고의 가치", pc_cta: "무료로 시작",
    fear_warning: "경고", fear_h1: "AI가 브랜드를 추천합니다", fear_h1_highlight: "오늘",
    fear_cta_btn: "지금 시작", bm_add_brand: "브랜드 추가", bm_overall: "전체 AI 가시성",
    attr_visits: "AI 방문", attr_conversions: "전환", ls_scan: "웹사이트 스캔",
  
    pc_sub: "무료로 사용해보고 오늘부터 순위를 올리세요",
    pc_agency: "SEO 에이전시",
    pc_ads_1: "큰 예산이 필요합니다",
    pc_ads_2: "수동 키워드 연구",
    pc_ads_3: "클릭을 최적화, 판매는 아닙니다",
    pc_ads_4: "임대된 트래픽",
    pc_ads_5: "경쟁자가 더 높은 입찰을 합니다",
    pc_ads_6: "지출을 중단하면 트래픽도 중단됩니다",
    pc_ads_7: "지속적인 결과에서 €0",
    pc_trp_1: "AI가 매일 양질의 콘텐츠를 작성합니다",
    pc_trp_2: "자동 키워드 연구",
    pc_trp_3: "우수한 백링크 포함",
    pc_trp_4: "계약 없음 — 언제든지 취소 가능",
    pc_trp_5: "한 번 순위를 올리면 영원히 트래픽을 얻습니다",
    pc_trp_6: "기술 지식이 필요 없습니다",
    pc_trp_7: "무작위 트래픽이 아닌 구매자를 위한 구축",
    pc_ag_1: "결과를 보기까지 몇 개월",
    pc_ag_2: "주간 회의",
    pc_ag_3: "계약에 묶여 있음",
    pc_ag_4: "한 달에 €2,300에 블로그 게시물 2개",
    pc_ag_5: "그들이 모든 것을 소유합니다",
    pc_ag_6: "트래픽 200% 증가, 판매 0%",
    pc_ag_7: "AI 가시성 최적화 없음",
    pc_save_title: "20시간 이상 및 €2,000+/월 절약",
    pc_save_sub: "에이전시나 Google Ads에서 TopRankPulse로 전환하고 더 많은 돈을 남기세요.",
    pc_save_cta: "요금제 보기",
    bm_no_monitors: "아직 모니터링되는 브랜드가 없습니다",
    bm_no_monitors_desc: "브랜드를 추가하여 AI 검색 엔진이 어떻게 보이는지 추적을 시작하세요.",
    bm_brand_name: "브랜드 이름",
    bm_website: "웹사이트 URL",
    bm_industry: "산업",
    bm_location: "위치",
    bm_competitors: "경쟁자",
    bm_comma: "쉼표로 구분",
    bm_start: "모니터링 시작",
    bm_recheck: "재확인",
    bm_citation_score: "인용 점수",
    bm_recommends: "추천",
    bm_not_cited: "인용되지 않음",
    bm_top_rec: "최고 추천",
    bm_query_analysis: "쿼리 분석",
    bm_last_checked: "마지막 확인",
    bm_loading: "AI 가시성 분석 중...",
    bm_recommendations: "가시성을 높이는 방법",
    bm_high: "높은 영향",
    bm_medium: "중간",
    bm_low: "낮은",
    bm_vis_up: "마지막 점검 이후 가시성이 증가함",
    bm_vis_down: "마지막 점검 이후 가시성이 감소함",
    attr_desc: "AI 검색 엔진이 가져오는 트래픽과 수익을 정확히 확인하세요",
    attr_setup: "애트리뷰션 설정",
    attr_demo: "데모 데이터 - 실시간 숫자를 보려면 추적 픽셀을 설치하세요",
    attr_revenue: "수익",
    attr_conv_rate: "전환율",
    attr_traffic_30: "AI 트래픽 (30일)",
    attr_by_source: "AI 출처별 트래픽",
    attr_source_details: "출처 세부정보",
    attr_visits_short: "방문",
    attr_insights: "AI 인사이트",
    attr_pixel: "추적 픽셀",
    attr_copied: "복사됨",
    attr_copy: "복사",
    attr_pixel_desc: "정확한 AI 트래픽 추적을 시작하려면 이 코드를 웹사이트의 </head> 이전에 붙여넣으세요.",
    attr_no_sites: "추적된 사이트가 없습니다",
    attr_no_sites_desc: "웹사이트를 추가하여 AI 검색 엔진이 가져오는 트래픽을 확인하세요.",
    attr_add_website: "웹사이트 추가",
    ls_stat1: "AI에 보이지 않는 사이트",
    ls_stat2: "AI 검색에서의 평균 방문 수",
    ls_stat3: "무료 감사 결과",
    ls_f1_t: "AI 가시성 추적",
    ls_f1_d: "ChatGPT, Perplexity & Gemini가 귀하의 웹사이트를 인용하는지 확인하세요",
    ls_f2_t: "완전한 SEO 감사",
    ls_f2_d: "실행 가능한 권장사항을 포함한 기술 분석",
    ls_f3_t: "음성 검색 점수",
    ls_f3_d: "Siri, Alexa, Google Assistant 최적화",
    ls_f4_t: "GEO 최적화",
    ls_f4_d: "지역 SEO for",
    ls_f5_t: "백링크 분석",
    ls_f5_d: "dofollow, nofollow & 도메인 권한 확인",
    ls_f6_t: "사이트 속도",
    ls_f6_d: "핵심 웹 지표 및 성능 점수",
    ls_more_cities: "더 많은 도시",
    ls_top_cities: "주요 도시",
    ls_cta_h1: "무료 시작하기",
    ls_cta_h2: "SEO 감사",
    ls_cta_join: "다른 기업과 함께하기",
    ls_cta_using: "TopRankPulse 사용 중.",
    ls_free: "영원히 무료",
    ls_no_card: "신용카드 없음",
    ls_langs: "26개 언어",
    pl_f1_t: "AI 가시성 추적",
    pl_f1_d: "ChatGPT, Perplexity 및 Gemini가 당신의 웹사이트를 언급하는지 확인하세요.",
    pl_f2_t: "완전한 SEO 감사",
    pl_f2_d: "실행 가능한 권장 사항과 함께 제공되는 기술적 분석",
    pl_f3_t: "키워드 연구",
    pl_f3_d: "검색량, 난이도 및 트렌드에 맞는 더 나은 키워드 찾기",
    pl_f4_t: "음성 검색 점수",
    pl_f4_d: "Siri, Alexa, Google Assistant를 위해 최적화",
    pl_f5_t: "AI 추천",
    pl_f5_d: "점수를 향상시키기 위한 단계별 지침",
    pl_f6_t: "대시보드 위젯",
    pl_f6_d: "WordPress 대시보드에서 직접 SEO 점수 확인",
    pl_f7_t: "게시 시 자동 스캔",
    pl_f7_d: "게시할 때 새로운 게시물을 자동으로 분석",
    pl_f8_t: "WooCommerce SEO",
    pl_f8_d: "제품 SEO 점수, AI 설명 및 Google 쇼핑 최적화",
    pl_f9_t: "블로그 에이전트 (€25)",
    pl_f9_d: "귀하의 사이트로 링크가 포함된 25개의 SEO 기사",
    pl_s3_t: "귀하의 사이트 스캔",
    pl_s3_d: "'지금 스캔'을 클릭하고 30초 안에 SEO 점수 + AI 가시성 보고서를 받으세요.",
    pl_w1_t: "제품 SEO 점수",
    pl_w1_d: "각 제품의 실시간 SEO 점수.",
    pl_w2_t: "AI 설명 생성기",
    pl_w2_d: "원클릭으로 AI가 생성한 SEO 제품 설명.",
    pl_w3_t: "Google 쇼핑 준비 완료",
    pl_w3_d: "Google 쇼핑을 위한 향상된 제품 스키마 마크업.",
    fear_h1_2: "순위가 매겨진",
    fear_desc: "ChatGPT, Gemini 및 Perplexity는 상위 순위 페이지에서 답변을 가져옵니다. 현재 순위가 없다면 AI는 귀하의 경쟁자를 추천할 것이며, 따라잡는 것은 점점 더 어려워집니다.",
    fear_m1_label: "1개월 차",
    fear_m1_title: "귀하의 경쟁자가 콘텐츠를 게시합니다",
    fear_m1_desc: "대기하는 동안 그들은 SEO 권위를 구축하고 AI 엔진에 의해 인용되고 있습니다.",
    fear_m3_label: "3개월 차",
    fear_m3_title: "AI가 그들을 추천하기 시작합니다",
    fear_m3_desc: "이제 ChatGPT와 Perplexity가 기본적으로 경쟁사를 인용합니다. 트래픽이 감소합니다.",
    fear_m6_label: "6개월 차",
    fear_m6_title: "당신은 보이지 않습니다. 그들이 당신의 틈새를 차지했습니다.",
    fear_m6_desc: "AI 모델은 이미 효과가 있는 것을 강화합니다. 지금 따라잡는 것은 10배 더 많은 노력과 비용이 듭니다.",
    fear_urgency: "기다리는 매일마다 고객을 잃습니다",
    fear_cta_h: "경쟁사보다 먼저 랭킹을 시작하세요",
    fear_cta_sub: "오늘 랭킹에 있는 브랜드가 내일의 기본 AI 추천이 됩니다. 그것이 바로 당신이기를 바랍니다.",
    pp_what_clients_say: "고객의 의견",
    pp_start_trial: "무료 체험 시작",
    pp_download_plugin: "플러그인 다운로드",
    pp_ready: "준비 완료",
    pp_start: "시작",
    pp_join: "수천 개의 TopRankPulse를 사용하는 기업에 참여하세요.",
    pp_ai_vis_name: "AI 가시성 추적",
    pp_ai_vis_tag: "ChatGPT, Perplexity & Gemini가 귀하의 웹사이트를 인용하는지 확인하세요",
    pp_ai_vis_desc: "AI 가시성 추적은 세계 최고의 AI 검색 엔진인 ChatGPT, Perplexity, Gemini, Copilot이 사용자가 관련 질문을 할 때 귀하의 웹사이트를 언급하는지를 모니터링합니다.",
    pp_ai_vis_f1: "4개의 AI 엔진에 대한 실시간 인용 모니터링",
    pp_ai_vis_f2: "주간 가시성 추세 보고서",
    pp_ai_vis_f3: "경쟁사 인용 비교",
    pp_ai_vis_f4: "음성 검색 준비 점수",
    pp_ai_vis_f5: "AI 최적화된 콘텐츠 추천",
    pp_ai_vis_f6: "자동 감지를 통한 26개 언어 지원",
    pp_seo_name: "완벽한 SEO 감사",
    pp_seo_tag: "AI 기반 추천을 통한 기술 SEO 분석",
    pp_seo_desc: "우리의 완벽한 SEO 감사는 기술 SEO, 콘텐츠 품질, 백링크, 페이지 속도, 모바일 최적화, AI 준비 상태를 포함한 50개 이상의 랭킹 요소를 분석합니다.",
    pp_seo_f1: "50개 이상의 랭킹 요소 분석",
    pp_seo_f2: "기술 SEO 체크 (메타 태그, 헤더, 스키마)",
    pp_seo_f3: "콘텐츠 품질 점수",
    pp_seo_f4: "백링크 프로필 분석",
    pp_seo_f5: "핵심 웹 바이탈 평가",
    pp_seo_f6: "모바일 우선 최적화 팁",
    pp_seo_f7: "AI 준비 점수",
    pp_seo_f8: "다운로드 가능한 PDF 보고서",
    pp_brand_name: "AI 브랜드 모니터링",
    pp_brand_tag: "AI 검색 엔진이 귀하의 브랜드를 언급하는지 24/7 추적",
    pp_brand_f1: "4개의 AI 엔진에 대한 24/7 모니터링",
    pp_brand_f2: "이메일을 통한 실시간 인용 알림",
    pp_brand_f3: "경쟁사 벤치마크 비교",
    pp_brand_f4: "차트를 통한 역사적 트렌드 추적",
    pp_brand_f5: "쿼리 수준 분석",
    pp_brand_f6: "실행 가능한 AI 최적화 추천",
    pp_comp_name: "AI 경쟁사 스파이",
    pp_comp_tag: "AI로 구동되는 실시간 경쟁 정보",
    pp_comp_f1: "실시간 경쟁사 SEO 모니터링",
    pp_comp_f2: "콘텐츠 변경 알림",
    pp_comp_f3: "백링크 획득 추적",
    pp_comp_f4: "AI 가시성 비교",
    pp_comp_f5: "강점/약점 분석",
    pp_comp_f6: "기회 식별",
    pp_comp_f7: "고임팩트 변경을 위한 우선 알림",
    pp_blog_name: "블로그 에이전트",
    pp_blog_tag: "AI가 작성한 25개의 SEO 기사 — 각 기사는 4개의 백링크 포함, 매일 발행",
    pp_blog_f1: "25개의 고유한 SEO 최적화 기사",
    pp_blog_f2: "25일 동안 하루에 1개 발행",
    pp_blog_f3: "기사당 4개의 도팔로우 백링크",
    pp_blog_f4: "26개 언어로 자동 번역",
    pp_blog_f5: "업계에 기반한 주제 연구",
    pp_blog_f6: "길이 긴 콘텐츠 (1,500단어 이상)",
    pp_blog_f7: "내부 링크 구조",
    pp_blog_f8: "스키마 마크업 포함",
    pp_wp_name: "WordPress + WooCommerce 플러그인",
    pp_wp_tag: "AI 가시성 추적 기능이 내장된 무료 SEO 플러그인",
    pp_auto_name: "SEO 자율 비행기",
    pp_auto_tag: "AI가 자동으로 SEO를 수정합니다 — 단순한 추천이 아닙니다",
    pp_auto_desc: "SEO 자율 비행기는 무엇을 수정해야 하는지 알려주는 것에 그치지 않고, 실제로 수정합니다. 우리의 AI는 최적화된 메타 제목, 설명, 이미지 ALT 텍스트, 내부 링크 및 FAQ 섹션을 자동으로 생성합니다. WordPress와 Shopify에서 우리의 플러그인을 통해 작동합니다.",
    pp_auto_f1: "SEO 메타 제목 및 설명 자동 생성",
    pp_auto_f2: "이미지 ALT 텍스트 자동 생성",
    pp_auto_f3: "스마트 내부 링크 제안",
    pp_auto_f4: "스키마 마크업을 포함한 FAQ 섹션 생성",
    pp_auto_f5: "끊어진 링크 감지 및 리디렉션 제안",
    pp_auto_f6: "주간 자동 스캔",
    pp_auto_f7: "WordPress 및 Shopify 플러그인 통합",
    pp_auto_f8: "전후 점수 추적",
    pp_sim_name: "AI 검색 시뮬레이터",
    pp_sim_tag: "ChatGPT, Perplexity & Gemini가 답변하는 내용을 확인하세요 — 무료로",
    pp_sim_desc: "AI 검색 시뮬레이터는 어떤 질문이든 입력하고 ChatGPT, Perplexity, Gemini 및 Copilot의 응답을 시뮬레이션하여 보여줍니다. 귀하의 웹사이트가 AI 검색 결과에서 언급되는지 확인하세요.",
    pp_sim_f1: "4개의 엔진에서 AI 검색 응답 시뮬레이션",
    pp_sim_f2: "웹사이트 인용 여부 확인",
    pp_sim_f3: "모든 키워드 또는 질문 테스트",
    pp_sim_f4: "무제한 무료 쿼리",
    pp_sim_f5: "26개 언어 지원",
    pp_blog_desc: "블로그 에이전트가 귀하의 웹사이트를 위해 25개의 SEO 최적화된 기사를 작성합니다 — 하루에 1개씩 25일 동안. 각 기사는 4개의 도팔로우 백링크가 포함되어 있고, 26개 언어로 자동 번역되며 정해진 일정에 맞춰 게시됩니다.",
    pp_brand_desc: "AI 브랜드 모니터링은 사용자가 관련 질문을 할 때 ChatGPT, Perplexity, Gemini, Copilot이 귀하의 브랜드를 언급하는지 추적합니다. 실시간 알림을 받고 경쟁사와 비교해 보세요.",
    pp_comp_desc: "AI 경쟁자 스파이는 귀하의 경쟁자의 SEO 전략을 실시간으로 모니터링합니다. 그들이 새로운 콘텐츠를 게시하거나 백링크를 획득하거나 AI 가시성 점수를 향상시킬 때 알림을 받습니다.",
    pp_wp_desc: "우리의 무료 WordPress 플러그인을 사용하면 TopRankPulse를 WordPress 관리자에 직접 추가할 수 있습니다. 대시보드를 떠나지 않고도 SEO 점수, AI 가시성 추적 및 원클릭 수정을 제공합니다.",
    pp_wp_f1: "WordPress 관리자에서 원클릭 SEO 수정",
    pp_wp_f2: "내장된 AI 가시성 추적",
    pp_wp_f3: "WooCommerce 제품 SEO 최적화",
    pp_wp_f4: "자동 스키마 마크업",
    pp_wp_f5: "모든 플랜에서 영구 무료",
    pp_free_scan: "첫 번째 스캔 무료",
  },
  zh: {
    pc_tag: "停止为SEO多付钱", pc_h1: "替代昂贵的SEO机构", pc_h1_highlight: "仅需一顿家庭晚餐的价格",
    pc_month: "月", pc_best_value: "最佳价值", pc_cta: "免费开始",
    fear_warning: "警告", fear_h1: "AI推荐品牌", fear_h1_highlight: "今天",
    fear_cta_btn: "立即开始", bm_add_brand: "添加品牌", bm_overall: "AI总体可见性",
    attr_visits: "AI访问", attr_conversions: "转化", ls_scan: "扫描您的网站",
  
    pc_sub: "您可以免费试用，从今天开始提升排名",
    pc_agency: "SEO机构",
    pc_ads_1: "您需要一个大预算",
    pc_ads_2: "手动关键词研究",
    pc_ads_3: "优化点击，而非销售",
    pc_ads_4: "租用流量",
    pc_ads_5: "竞争对手出价高于您",
    pc_ads_6: "停止投入流量也随之停止",
    pc_ads_7: "€0的持久结果",
    pc_trp_1: "AI每天撰写高质量内容",
    pc_trp_2: "自动关键词研究",
    pc_trp_3: "包含高质量反向链接",
    pc_trp_4: "无合同 — 随时取消",
    pc_trp_5: "一次排名，永久获得流量",
    pc_trp_6: "无需技术知识",
    pc_trp_7: "旨在吸引买家，而非随机流量",
    pc_ag_1: "需要几个月才能看到结果",
    pc_ag_2: "每周会议",
    pc_ag_3: "锁定合同",
    pc_ag_4: "每月€2,300获得两篇博客文章",
    pc_ag_5: "他们拥有一切",
    pc_ag_6: "流量上涨200%，销售0%",
    pc_ag_7: "未进行AI可见性优化",
    pc_save_title: "节省20+小时和€2,000+/月",
    pc_save_sub: "从代理商或Google Ads切换到TopRankPulse，将更多钱留在口袋里。",
    pc_save_cta: "查看计划",
    bm_no_monitors: "尚未监测任何品牌",
    bm_no_monitors_desc: "添加您的品牌以开始跟踪AI搜索引擎如何看待您。",
    bm_brand_name: "品牌名称",
    bm_website: "网站网址",
    bm_industry: "行业",
    bm_location: "地点",
    bm_competitors: "竞争对手",
    bm_comma: "用逗号分隔",
    bm_start: "开始监测",
    bm_recheck: "重新检查",
    bm_citation_score: "引用分数",
    bm_recommends: "推荐",
    bm_not_cited: "未引用",
    bm_top_rec: "最佳推荐",
    bm_query_analysis: "查询分析",
    bm_last_checked: "上次检查时间",
    bm_loading: "正在分析AI可见性...",
    bm_recommendations: "如何提升您的可见性",
    bm_high: "高影响",
    bm_medium: "中等",
    bm_low: "低",
    bm_vis_up: "自上次检查以来可见性增加",
    bm_vis_down: "自上次检查以来可见性减少",
    attr_desc: "准确查看AI搜索引擎带来的流量和收入",
    attr_setup: "设置归因",
    attr_demo: "演示数据 - 安装追踪像素以查看真实数据",
    attr_revenue: "收入",
    attr_conv_rate: "转化率",
    attr_traffic_30: "AI流量（30天）",
    attr_by_source: "按AI来源的流量",
    attr_source_details: "来源详情",
    attr_visits_short: "访问量",
    attr_insights: "AI洞察",
    attr_pixel: "追踪像素",
    attr_copied: "已复制",
    attr_copy: "复制",
    attr_pixel_desc: "将此内容粘贴在您的网站</head>之前以开始追踪真实的AI流量。",
    attr_no_sites: "尚未追踪任何网站",
    attr_no_sites_desc: "添加您的网站以查看AI搜索引擎带来的流量。",
    attr_add_website: "添加您的网站",
    ls_stat1: "对AI不可见的网站",
    ls_stat2: "来自AI搜索的平均访问量",
    ls_stat3: "免费审核结果",
    ls_f1_t: "AI可见性追踪",
    ls_f1_d: "检查ChatGPT、Perplexity和Gemini是否引用您的网站",
    ls_f2_t: "完整的SEO审核",
    ls_f2_d: "技术分析与可操作的建议",
    ls_f3_t: "语音搜索评分",
    ls_f3_d: "为Siri、Alexa、Google助手进行优化",
    ls_f4_t: "地理优化",
    ls_f4_d: "本地SEO",
    ls_f5_t: "反向链接分析",
    ls_f5_d: "检查dofollow、nofollow和域名权威",
    ls_f6_t: "网站速度",
    ls_f6_d: "核心网络指标和性能评分",
    ls_more_cities: "更多城市在",
    ls_top_cities: "顶级城市在",
    ls_cta_h1: "开始你的免费",
    ls_cta_h2: "SEO审核",
    ls_cta_join: "加入在",
    ls_cta_using: "使用TopRankPulse的企业。",
    ls_free: "永久免费",
    ls_no_card: "无信用卡",
    ls_langs: "26种语言",
    pl_f1_t: "AI可见性跟踪",
    pl_f1_d: "查看ChatGPT、Perplexity和Gemini是否引用了你的网站",
    pl_f2_t: "完整的SEO审核",
    pl_f2_d: "提供可行建议的技术分析",
    pl_f3_t: "关键词研究",
    pl_f3_d: "找到更好的关键词，包含流量、难度和趋势",
    pl_f4_t: "语音搜索评分",
    pl_f4_d: "为Siri、Alexa、Google Assistant优化",
    pl_f5_t: "AI建议",
    pl_f5_d: "逐步指导来提升你的评分",
    pl_f6_t: "仪表板小部件",
    pl_f6_d: "WordPress仪表板中的SEO评分",
    pl_f7_t: "发布时自动扫描",
    pl_f7_d: "发布时自动分析新帖子",
    pl_f8_t: "WooCommerce SEO",
    pl_f8_d: "产品SEO评分、AI描述和Google购物优化",
    pl_f9_t: "博客代理 (€25)",
    pl_f9_d: "25篇带有链接到你网站的SEO文章",
    pl_s3_t: "扫描你的站点",
    pl_s3_d: "点击“立即扫描”并在30秒内获取你的SEO评分和AI可见性报告。",
    pl_w1_t: "产品SEO评分",
    pl_w1_d: "每个产品都会获得实时SEO评分。",
    pl_w2_t: "AI描述生成器",
    pl_w2_d: "一键生成SEO产品描述的AI。",
    pl_w3_t: "Google购物准备就绪",
    pl_w3_d: "适用于Google购物的增强产品架构标记。",
    fear_h1_2: "排名",
    fear_desc: "ChatGPT、Gemini和Perplexity从排名靠前的页面提取答案。如果你现在没有排名，AI会推荐你的竞争对手——而且这只会变得更加困难。",
    fear_m1_label: "第1个月",
    fear_m1_title: "你的竞争对手发布内容",
    fear_m1_desc: "在你等待的同时，他们正在建立SEO权威，并被AI引擎引用。",
    fear_m3_label: "第3个月",
    fear_m3_title: "AI开始推荐他们",
    fear_m3_desc: "ChatGPT和Perplexity现在默认引用你的竞争对手。你的流量下降。",
    fear_m6_label: "第6个月",
    fear_m6_title: "你已经隐形。他们占据了你的垂直市场。",
    fear_m6_desc: "AI模型强化已经有效的内容。现在追赶需要10倍的努力和资金。",
    fear_urgency: "你越等，失去的客户就越多",
    fear_cta_h: "在竞争对手之前开始排名",
    fear_cta_sub: "今天排名的品牌，明天将成为默认的AI推荐。确保你是其中之一。",
    pp_what_clients_say: "客户评价",
    pp_start_trial: "开始免费试用",
    pp_download_plugin: "下载插件",
    pp_ready: "准备好",
    pp_start: "开始",
    pp_join: "加入成千上万使用TopRankPulse的企业。",
    pp_ai_vis_name: "AI可见性跟踪",
    pp_ai_vis_tag: "查看ChatGPT、Perplexity和Gemini是否引用你的网站",
    pp_ai_vis_desc: "AI可见性跟踪监控世界领先的AI搜索引擎 — ChatGPT、Perplexity、Gemini和Copilot — 在用户提问相关问题时是否提到你的网站。",
    pp_ai_vis_f1: "4个AI引擎的实时引用监控",
    pp_ai_vis_f2: "每周可见性趋势报告",
    pp_ai_vis_f3: "竞争对手引用比较",
    pp_ai_vis_f4: "语音搜索准备评分",
    pp_ai_vis_f5: "AI优化内容推荐",
    pp_ai_vis_f6: "支持26种语言并具有自动检测功能",
    pp_seo_name: "全面SEO审计",
    pp_seo_tag: "技术SEO分析与AI驱动的建议",
    pp_seo_desc: "我们的全面SEO审计分析50多个排名因素，包括技术SEO、内容质量、反向链接、页面速度、移动优化和AI准备程度。",
    pp_seo_f1: "分析50多个排名因素",
    pp_seo_f2: "技术SEO检查（元标签、标题、架构）",
    pp_seo_f3: "内容质量评分",
    pp_seo_f4: "反向链接分析",
    pp_seo_f5: "核心网页指标评估",
    pp_seo_f6: "移动优先优化建议",
    pp_seo_f7: "AI准备评分",
    pp_seo_f8: "可下载的PDF报告",
    pp_brand_name: "AI品牌监控",
    pp_brand_tag: "全天候监控AI搜索引擎是否提及你的品牌",
    pp_brand_f1: "4个AI引擎的全天候监控",
    pp_brand_f2: "通过电子邮件实时引用警报",
    pp_brand_f3: "竞争对手基准比较",
    pp_brand_f4: "带图表的历史趋势跟踪",
    pp_brand_f5: "查询级分析",
    pp_brand_f6: "可操作的 AI 优化建议",
    pp_comp_name: "AI 竞争对手间谍",
    pp_comp_tag: "由 AI 驱动的实时竞争情报",
    pp_comp_f1: "实时竞争对手 SEO 监控",
    pp_comp_f2: "内容变更提醒",
    pp_comp_f3: "反向链接获取跟踪",
    pp_comp_f4: "AI 能见度比较",
    pp_comp_f5: "强项/弱项分析",
    pp_comp_f6: "机会识别",
    pp_comp_f7: "重要变化的优先提醒",
    pp_blog_name: "博客代理",
    pp_blog_tag: "25 篇每篇 4 个反向链接的 SEO 文章 — 由 AI 撰写，每日发布",
    pp_blog_f1: "25 篇独特的 SEO 优化文章",
    pp_blog_f2: "每天发布 1 篇，持续 25 天",
    pp_blog_f3: "每篇文章 4 个 dofollow 反向链接",
    pp_blog_f4: "自动翻译成 26 种语言",
    pp_blog_f5: "基于您行业的主题研究",
    pp_blog_f6: "长格式内容（1500+ 字）",
    pp_blog_f7: "内部链接结构",
    pp_blog_f8: "包含模式标记",
    pp_wp_name: "WordPress + WooCommerce 插件",
    pp_wp_tag: "带有内置 AI 能见度跟踪的免费 SEO 插件",
    pp_auto_name: "SEO 自动驾驶仪",
    pp_auto_tag: "AI 自动修复您的 SEO — 不仅仅是建议",
    pp_auto_desc: "SEO 自动驾驶仪不仅告诉您需要修复什么 — 它会为您修复。我们的 AI 自动生成优化的 meta 标题、描述、图片替代文本、内部链接和常见问题部分。通过我们的插件与 WordPress 和 Shopify 兼容。",
    pp_auto_f1: "自动生成 SEO meta 标题和描述",
    pp_auto_f2: "自动生成图片替代文本",
    pp_auto_f3: "智能内部链接建议",
    pp_auto_f4: "带模式标记的 FAQ 部分生成",
    pp_auto_f5: "断开链接检测及重定向建议",
    pp_auto_f6: "每周自动扫描",
    pp_auto_f7: "WordPress 和 Shopify 插件集成",
    pp_auto_f8: "前后评分跟踪",
    pp_sim_name: "AI 搜索模拟器",
    pp_sim_tag: "查看 ChatGPT、Perplexity 和 Gemini 的回答 — 免费",
    pp_sim_desc: "AI 搜索模拟器让您可以输入任何问题，并查看来自 ChatGPT、Perplexity、Gemini 和 Copilot 的模拟回复。找出您的网站是否会在 AI 搜索结果中被提及。",
    pp_sim_f1: "模拟 4 个引擎的 AI 搜索回复",
    pp_sim_f2: "检查您的网站是否被引用",
    pp_sim_f3: "测试任何关键词或问题",
    pp_sim_f4: "免费无限查询",
    pp_sim_f5: "支持26种语言",
    pp_blog_desc: "博客代理为您的网站撰写25篇SEO优化文章——每天一篇，持续25天。每篇文章包含4个dofollow反向链接，自动翻译成26种语言，并按计划发布。",
    pp_brand_desc: "AI品牌监测跟踪当用户提出相关问题时，ChatGPT、Perplexity、Gemini和Copilot是否提到您的品牌。获取实时警报并与竞争对手进行基准比较。",
    pp_comp_desc: "AI竞争对手监控实时监测您的竞争对手的SEO策略。当他们发布新内容、获得反向链接或提高AI可见性分数时，获取警报。",
    pp_wp_desc: "我们的免费WordPress插件将TopRankPulse直接引入您的WordPress管理后台。在不离开仪表盘的情况下获取SEO评分、AI可见性跟踪和一键修复。",
    pp_wp_f1: "从WordPress管理后台一键修复SEO",
    pp_wp_f2: "内置AI可见性跟踪",
    pp_wp_f3: "WooCommerce产品SEO优化",
    pp_wp_f4: "自动化模式标记",
    pp_wp_f5: "所有计划永久免费",
    pp_free_scan: "首次扫描免费",
  },
  ar: {
    pc_tag: "توقف عن الدفع الزائد لـ SEO", pc_h1: "استبدل وكالات SEO المكلفة", pc_h1_highlight: "بسعر عشاء عائلي",
    pc_month: "شهر", pc_best_value: "أفضل قيمة", pc_cta: "ابدأ مجاناً",
    fear_warning: "تحذير", fear_h1: "الذكاء الاصطناعي يوصي بالعلامات التجارية", fear_h1_highlight: "اليوم",
    fear_cta_btn: "ابدأ الآن", bm_add_brand: "إضافة علامة تجارية", bm_overall: "رؤية AI الإجمالية",
    attr_visits: "زيارات AI", attr_conversions: "تحويلات", ls_scan: "فحص موقعك",
  
    pc_sub: "يمكنك تجربته مجانًا وبدء الترتيب اليوم",
    pc_agency: "وكالة SEO",
    pc_ads_1: "تحتاج إلى ميزانية كبيرة",
    pc_ads_2: "بحث يدوي عن الكلمات الرئيسية",
    pc_ads_3: "مُحسَّنة للنقرات، وليس للمبيعات",
    pc_ads_4: "حركة مرور مستأجرة",
    pc_ads_5: "المنافسون يتجاوزونك في العروض",
    pc_ads_6: "تتوقف الحركة عندما تتوقف عن الإنفاق",
    pc_ads_7: "€0 في نتائج دائمة",
    pc_trp_1: "AI تكتب محتوى يومي بجودة عالية",
    pc_trp_2: "بحث تلقائي عن الكلمات الرئيسية",
    pc_trp_3: "روابط خلفية ذات جودة مشمولة",
    pc_trp_4: "لا عقود - ألغِ في أي وقت",
    pc_trp_5: "احتل مرتبة واحدة، واحصل على حركة مرور إلى الأبد",
    pc_trp_6: "لا حاجة لمعرفه تقنية",
    pc_trp_7: "مصمم لجلب المشترين، وليس حركة مرور عشوائية",
    pc_ag_1: "شهور لرؤية النتائج",
    pc_ag_2: "اجتماعات أسبوعية",
    pc_ag_3: "مقفل في عقود",
    pc_ag_4: "2 منشورات مدونة/شهر مقابل €2,300",
    pc_ag_5: "هم يمتلكون كل شيء",
    pc_ag_6: "زيادة الحركة 200%، المبيعات 0%",
    pc_ag_7: "عدم تحسين رؤية AI",
    pc_save_title: "وفر 20+ ساعة و€2,000+/شهر",
    pc_save_sub: "انتقل من الوكالات أو إعلانات Google إلى TopRankPulse واحتفظ بالمزيد من المال في جيبك.",
    pc_save_cta: "رؤية الخطط",
    bm_no_monitors: "لا علامات تجارية يتم مراقبتها بعد",
    bm_no_monitors_desc: "أضف علامتك التجارية لبدء تتبع كيف ترى محركات بحث AI لك.",
    bm_brand_name: "اسم العلامة التجارية",
    bm_website: "رابط الموقع",
    bm_industry: "الصناعة",
    bm_location: "الموقع",
    bm_competitors: "المنافسون",
    bm_comma: "مفصولة بفواصل",
    bm_start: "ابدأ المراقبة",
    bm_recheck: "إعادة التحقق",
    bm_citation_score: "درجة الاقتباس",
    bm_recommends: "يوصي",
    bm_not_cited: "لم يُستشهد به",
    bm_top_rec: "أفضل توصية",
    bm_query_analysis: "تحليل الاستعلام",
    bm_last_checked: "آخر فحص",
    bm_loading: "جارٍ تحليل رؤية الذكاء الاصطناعي...",
    bm_recommendations: "كيفية زيادة رؤيتك",
    bm_high: "تأثير عالي",
    bm_medium: "متوسط",
    bm_low: "منخفض",
    bm_vis_up: "زيادة الرؤية منذ آخر فحص",
    bm_vis_down: "انخفاض الرؤية منذ آخر فحص",
    attr_desc: "شاهد بالضبط كم من الحركة والإيرادات تجلبها محركات البحث بالذكاء الاصطناعي",
    attr_setup: "إعداد النسب",
    attr_demo: "بيانات تجريبية - قم بتثبيت بكسل التتبع لرؤية الأرقام الحقيقية",
    attr_revenue: "الإيرادات",
    attr_conv_rate: "معدل التحويل",
    attr_traffic_30: "حركة الذكاء الاصطناعي (30 يومًا)",
    attr_by_source: "الحركة حسب المصدر الذكي",
    attr_source_details: "تفاصيل المصدر",
    attr_visits_short: "زيارات",
    attr_insights: "رؤى الذكاء الاصطناعي",
    attr_pixel: "بكسل التتبع",
    attr_copied: "تم النسخ",
    attr_copy: "نسخ",
    attr_pixel_desc: "ألصق هذا قبل </head> على موقعك لبدء تتبع حركة الذكاء الاصطناعي الحقيقية.",
    attr_no_sites: "لا توجد مواقع تم تتبعها بعد",
    attr_no_sites_desc: "أضف موقعك لترى كم من الحركة تجلبها محركات البحث بالذكاء الاصطناعي.",
    attr_add_website: "أضف موقعك",
    ls_stat1: "مواقع غير مرئية للذكاء الاصطناعي",
    ls_stat2: "متوسط الزيارات من البحث الذكي",
    ls_stat3: "نتائج التدقيق المجاني",
    ls_f1_t: "تتبع رؤية الذكاء الاصطناعي",
    ls_f1_d: "تحقق مما إذا كانت ChatGPT وPerplexity وGemini تشير إلى موقعك",
    ls_f2_t: "تدقيق SEO كامل",
    ls_f2_d: "تحليل تقني مع توصيات قابلة للتنفيذ",
    ls_f3_t: "نتيجة البحث الصوتي",
    ls_f3_d: "تحسين لـ Siri وAlexa وGoogle Assistant",
    ls_f4_t: "تحسين GEO",
    ls_f4_d: "SEO المحلي لـ",
    ls_f5_t: "تحليل الروابط الخلفية",
    ls_f5_d: "تحقق من الروابط الدائمة وغير الدائمة وسلطة النطاق",
    ls_f6_t: "سرعة الموقع",
    ls_f6_d: "مقاييس الأداء الأساسية ودرجة الأداء",
    ls_more_cities: "مدن أكثر في",
    ls_top_cities: "أعلى المدن في",
    ls_cta_h1: "ابدأ مجانًا",
    ls_cta_h2: "تدقيق SEO",
    ls_cta_join: "انضم إلى الشركات في",
    ls_cta_using: "تستخدم TopRankPulse.",
    ls_free: "مجاني للأبد",
    ls_no_card: "لا تحتاج إلى بطاقة ائتمان",
    ls_langs: "26 لغة",
    pl_f1_t: "تتبع الرؤية بالذكاء الاصطناعي",
    pl_f1_d: "تحقق مما إذا كانت ChatGPT وPerplexity وGemini تستشهد بموقعك الإلكتروني",
    pl_f2_t: "تدقيق SEO كامل",
    pl_f2_d: "تحليل تقني مع توصيات قابلة للتنفيذ",
    pl_f3_t: "بحث عن الكلمات المفتاحية",
    pl_f3_d: "ابحث عن كلمات مفتاحية أفضل من حيث الحجم والصعوبة والاتجاهات",
    pl_f4_t: "درجة البحث الصوتي",
    pl_f4_d: "تحسين لSiri وAlexa وGoogle Assistant",
    pl_f5_t: "توصيات الذكاء الاصطناعي",
    pl_f5_d: "تعليمات خطوة بخطوة لتحسين درجتك",
    pl_f6_t: "أداة لوحة المعلومات",
    pl_f6_d: "درجة SEO مباشرة في لوحة معلومات WordPress الخاصة بك",
    pl_f7_t: "فحص تلقائي عند النشر",
    pl_f7_d: "يحلل المنشورات الجديدة تلقائيًا عند النشر",
    pl_f8_t: "تحسين SEO WooCommerce",
    pl_f8_d: "درجات SEO للمنتجات، أوصاف ذكاء اصطناعي وتحسين Google Shopping",
    pl_f9_t: "وكيل المدونة (€25)",
    pl_f9_d: "25 مقالة SEO مع روابط خلفية لموقعك",
    pl_s3_t: "افحص موقعك",
    pl_s3_d: "انقر على 'افحص الآن' واحصل على درجتك في SEO + تقرير الرؤية بالذكاء الاصطناعي خلال 30 ثانية.",
    pl_w1_t: "درجة SEO للمنتجات",
    pl_w1_d: "كل منتج يحصل على درجة SEO في الوقت الحقيقي.",
    pl_w2_t: "مولد الأوصاف بالذكاء الاصطناعي",
    pl_w2_d: "أوصاف منتجات مولدة بالذكاء الاصطناعي بنقرة واحدة.",
    pl_w3_t: "جاهز للتسوق على Google",
    pl_w3_d: "تحسين تنسيق مخطط المنتج للتسوق على Google.",
    fear_h1_2: "الذي يتصدر",
    fear_desc: "تجذب ChatGPT وGemini وPerplexity الإجابات من الصفحات ذات الترتيب الأعلى. إذا لم تكن تتصدر الآن، سيقترح الذكاء الاصطناعي منافسيك - وسيكون من الصعب اللحاق بهم.",
    fear_m1_label: "الشهر 1",
    fear_m1_title: "ينشر منافسك محتوى",
    fear_m1_desc: "بينما تنتظر، يقومون ببناء authority SEO ويتم الاستشهاد بهم من قِبل محركات الذكاء الاصطناعي.",
    fear_m3_label: "الشهر 3",
    fear_m3_title: "يبدأ الذكاء الاصطناعي في التوصية بهم",
    fear_m3_desc: "يستشهد ChatGPT وPerplexity بمنافسيك بشكل افتراضي الآن. ينخفض عدد الزوار لديك.",
    fear_m6_label: "الشهر 6",
    fear_m6_title: "أنت غير مرئي. هم يمتلكون مجالك.",
    fear_m6_desc: "تعزز نماذج الذكاء الاصطناعي ما يعمل بالفعل. اللحاق بالركب الآن يكلف 10 أضعاف الجهد والمال.",
    fear_urgency: "كل يوم تنتظر فيه، تخسر زبائن",
    fear_cta_h: "ابدأ بالترتيب قبل أن يفعل منافسوك",
    fear_cta_sub: "تتحول العلامات التجارية التي تتصدر الترتيب اليوم إلى توصيات الذكاء الاصطناعي الافتراضية غدًا. تأكد من كونك أحدها.",
    pp_what_clients_say: "ماذا يقول العملاء",
    pp_start_trial: "ابدأ التجربة المجانية",
    pp_download_plugin: "تحميل الإضافة",
    pp_ready: "جاهز لـ",
    pp_start: "ابدأ",
    pp_join: "انضم إلى الآلاف من الشركات التي تستخدم TopRankPulse.",
    pp_ai_vis_name: "تتبع رؤية الذكاء الاصطناعي",
    pp_ai_vis_tag: "اكتشف إذا كان ChatGPT وPerplexity وGemini يستشهدون بموقعك",
    pp_ai_vis_desc: "يعمل تتبع رؤية الذكاء الاصطناعي على مراقبة ما إذا كانت محركات بحث الذكاء الاصطناعي الرائدة في العالم - ChatGPT وPerplexity وGemini وCopilot - تذكر موقعك عندما يطرح المستخدمون أسئلة ذات صلة.",
    pp_ai_vis_f1: "مراقبة الاستشهادات في الوقت الحقيقي عبر 4 محركات ذكاء اصطناعي",
    pp_ai_vis_f2: "تقارير اتجاه الرؤية الأسبوعية",
    pp_ai_vis_f3: "مقارنة استشهادات المنافسين",
    pp_ai_vis_f4: "تقييم جاهزية البحث الصوتي",
    pp_ai_vis_f5: "توصيات محتوى محسنة بالذكاء الاصطناعي",
    pp_ai_vis_f6: "دعم بـ 26 لغة مع الكشف التلقائي",
    pp_seo_name: "تدقيق SEO كامل",
    pp_seo_tag: "تحليل تقني SEO مع توصيات مدعومة بالذكاء الاصطناعي",
    pp_seo_desc: "يقوم تدقيق SEO الكامل لدينا بتحليل أكثر من 50 عامل ترتيب بما في ذلك SEO التقني وجودة المحتوى والروابط الخلفية وسرعة الصفحة وتحسين الهواتف المحمولة وجاهزية الذكاء الاصطناعي.",
    pp_seo_f1: "تحليل أكثر من 50 عامل ترتيب",
    pp_seo_f2: "فحوصات SEO التقنية (علامات التعريف، العناوين، المخططات)",
    pp_seo_f3: "تقييم جودة المحتوى",
    pp_seo_f4: "تحليل ملف الروابط الخلفية",
    pp_seo_f5: "تقييم Core Web Vitals",
    pp_seo_f6: "نصائح تحسين الهواتف المحمولة أولاً",
    pp_seo_f7: "درجة جاهزية الذكاء الاصطناعي",
    pp_seo_f8: "تقرير PDF قابل للتنزيل",
    pp_brand_name: "مراقبة العلامة التجارية بالذكاء الاصطناعي",
    pp_brand_tag: "مراقبة 24/7 إذا كانت محركات البحث بالذكاء الاصطناعي تذكر علامتك التجارية",
    pp_brand_f1: "مراقبة على مدار 24 ساعة طوال الأسبوع عبر 4 محركات ذكاء اصطناعي",
    pp_brand_f2: "تنبيهات استشهاد في الوقت الحقيقي عبر البريد الإلكتروني",
    pp_brand_f3: "مقارنة معايير المنافسين",
    pp_brand_f4: "تتبع الاتجاهات التاريخية باستخدام الرسوم البيانية",
    pp_brand_f5: "تحليل على مستوى الاستعلام",
    pp_brand_f6: "توصيات تحسين الذكاء الاصطناعي القابلة للتنفيذ",
    pp_comp_name: "مراقبة المنافسين باستخدام الذكاء الاصطناعي",
    pp_comp_tag: "ذكاء تنافسي في الوقت الحقيقي مدعوم بالذكاء الاصطناعي",
    pp_comp_f1: "مراقبة SEO للمنافسين في الوقت الحقيقي",
    pp_comp_f2: "تنبيهات تغييرات المحتوى",
    pp_comp_f3: "تتبع اكتساب الروابط الخلفية",
    pp_comp_f4: "مقارنة الرؤية باستخدام الذكاء الاصطناعي",
    pp_comp_f5: "تحليل القوة والضعف",
    pp_comp_f6: "تحديد الفرص",
    pp_comp_f7: "تنبيهات أولوية للتغييرات ذات التأثير العالي",
    pp_blog_name: "وكيل المدونة",
    pp_blog_tag: "25 مقال SEO مع 4 روابط خلفية لكل منها — كتبها الذكاء الاصطناعي، منشورة يومياً",
    pp_blog_f1: "25 مقال فريدة محسّنة لـ SEO",
    pp_blog_f2: "تم نشر مقال واحد يومياً لمدة 25 يوماً",
    pp_blog_f3: "4 روابط خلفية دوفولو لكل مقال",
    pp_blog_f4: "مترجمة تلقائياً إلى 26 لغة",
    pp_blog_f5: "بحث عن الموضوعات بناءً على مجالك",
    pp_blog_f6: "محتوى طويل (أكثر من 1500 كلمة)",
    pp_blog_f7: "هيكل الربط الداخلي",
    pp_blog_f8: "تضمين ترميز السكيما",
    pp_wp_name: "إضافة WordPress + WooCommerce",
    pp_wp_tag: "إضافة SEO مجانية مع تتبع الرؤية بالذكاء الاصطناعي مدمجة",
    pp_auto_name: "التحكم الذاتي في SEO",
    pp_auto_tag: "يصلح الذكاء الاصطناعي SEO تلقائياً - ليس مجرد توصيات",
    pp_auto_desc: "التحكم الذاتي في SEO لا يذكرك فقط بما يجب إصلاحه - بل يقوم بإصلاحه لك. يقوم الذكاء الاصطناعي لدينا تلقائياً بإنشاء عناوين ميتا محسّنة، وأوصاف، ونصوص بديلة للصور، وروابط داخلية، وأقسام FAQ. يعمل مع WordPress و Shopify من خلال إضافاتنا.",
    pp_auto_f1: "توليد عناوين ميتا ووصف SEO تلقائياً",
    pp_auto_f2: "توليد نصوص بديلة للصور تلقائياً",
    pp_auto_f3: "اقتراحات ربط داخلي ذكي",
    pp_auto_f4: "توليد قسم FAQ مع ترميز السكيما",
    pp_auto_f5: "الكشف عن الروابط المعطلة واقتراحات التوجيه",
    pp_auto_f6: "عمليات مسح آلية أسبوعياً",
    pp_auto_f7: "تكامل إضافات WordPress و Shopify",
    pp_auto_f8: "تتبع النتائج قبل/بعد",
    pp_sim_name: "محاكي البحث بالذكاء الاصطناعي",
    pp_sim_tag: "شاهد ماذا ستجيب ChatGPT و Perplexity و Gemini — مجاناً",
    pp_sim_desc: "يتيح لك محاكي البحث بالذكاء الاصطناعي كتابة أي سؤال ورؤية ردود محاكاة من ChatGPT و Perplexity و Gemini و Copilot. اكتشف ما إذا كان سيتم ذكر موقعك في نتائج بحث الذكاء الاصطناعي.",
    pp_sim_f1: "محاكاة ردود البحث بالذكاء الاصطناعي من 4 محركات",
    pp_sim_f2: "تحقق مما إذا تم الإشارة إلى موقعك الإلكتروني",
    pp_sim_f3: "اختبر أي كلمة مفتاحية أو سؤال",
    pp_sim_f4: "استفسارات غير محدودة ومجانية",
    pp_sim_f5: "دعم لـ 26 لغة",
    pp_blog_desc: "عميل المدونة يكتب 25 مقالًا محسنًا لـ SEO لموقعك الإلكتروني - واحد يوميًا لمدة 25 يومًا. يتضمن كل مقال 4 روابط دوفولو، يُترجم تلقائيًا إلى 26 لغة، وينشر حسب الجدول الزمني.",
    pp_brand_desc: "تتبع مراقبة العلامة التجارية بالذكاء الاصطناعي ما إذا كانت ChatGPT، Perplexity، Gemini، وCopilot تذكر علامتك التجارية عندما يسأل المستخدمون أسئلة ذات صلة. احصل على تنبيهات في الوقت الفعلي وقارن مع المنافسين.",
    pp_comp_desc: "تتبع منافس الذكاء الاصطناعي استراتيجيات SEO للمنافسين في الوقت الفعلي. احصل على تنبيهات عندما ينشرون محتوى جديدًا، ويكتسبون روابط خلفية، أو يحسنون درجة ظهورهم بالذكاء الاصطناعي.",
    pp_wp_desc: "يقدم المكون الإضافي المجاني لـ WordPress TopRankPulse مباشرة إلى لوحة تحكم WordPress الخاصة بك. احصل على درجات SEO، وتتبع ظهور الذكاء الاصطناعي، وإصلاحات بنقرة واحدة دون مغادرة لوحة التحكم.",
    pp_wp_f1: "إصلاحات SEO بنقرة واحدة من لوحة تحكم WordPress",
    pp_wp_f2: "تتبع ظهور الذكاء الاصطناعي مدمج",
    pp_wp_f3: "تحسين SEO لمنتجات WooCommerce",
    pp_wp_f4: "توسيم مخطط تلقائي",
    pp_wp_f5: "مجاني إلى الأبد لجميع الخطط",
    pp_free_scan: "الفحص الأول مجاني",
  },
  hi: {
    pc_tag: "SEO के लिए अधिक भुगतान बंद करें", pc_h1: "महंगी SEO एजेंसियों को बदलें", pc_h1_highlight: "एक पारिवारिक रात्रिभोज की कीमत पर",
    pc_month: "महीना", pc_best_value: "सर्वोत्तम मूल्य", pc_cta: "मुफ्त शुरू करें",
    fear_warning: "चेतावनी", fear_h1: "AI ब्रांड्स की सिफारिश करता है", fear_h1_highlight: "आज",
    fear_cta_btn: "अभी शुरू करें", bm_add_brand: "ब्रांड जोड़ें", bm_overall: "समग्र AI दृश्यता",
    attr_visits: "AI विज़िट", attr_conversions: "रूपांतरण", ls_scan: "अपनी वेबसाइट स्कैन करें",
  
    pc_sub: "आप इसे मुफ्त में आज़मा सकते हैं और आज ही रैंकिंग शुरू कर सकते हैं",
    pc_agency: "SEO एजेंसी",
    pc_ads_1: "आपको बड़ा बजट चाहिए",
    pc_ads_2: "हैंड-ऑफ़ कीवर्ड रिसर्च",
    pc_ads_3: "क्लिक्स के लिए अनुकूलित, बिक्री के लिए नहीं",
    pc_ads_4: "किराए पर लिया गया ट्रैफ़िक",
    pc_ads_5: "प्रतिस्पर्धी आपको आगे निकाल देते हैं",
    pc_ads_6: "खर्च करना बंद करते ही ट्रैफ़िक रुक जाता है",
    pc_ads_7: "€0 के दीर्घकालिक परिणाम",
    pc_trp_1: "AI गुणवत्ता वाली दैनिक सामग्री लिखती है",
    pc_trp_2: "स्वचालित कीवर्ड रिसर्च",
    pc_trp_3: "गुणवत्ता की बैकलिंक्स शामिल हैं",
    pc_trp_4: "कोई अनुबंध नहीं - कभी भी रद्द करें",
    pc_trp_5: "एक बार रैंक करें, हमेशा के लिए ट्रैफ़िक पाएं",
    pc_trp_6: "कोई तकनीकी ज्ञान की आवश्यकता नहीं",
    pc_trp_7: "खरीदार लाने के लिए बनाया गया, रैंडम ट्रैफ़िक नहीं",
    pc_ag_1: "परिणाम देखने के लिए महीने",
    pc_ag_2: "साप्ताहिक बैठकें",
    pc_ag_3: "अनुबंधों में फंसे",
    pc_ag_4: "€2,300 के लिए 2 ब्लॉग पोस्ट/महिना",
    pc_ag_5: "वे सब कुछ नियंत्रित करते हैं",
    pc_ag_6: "ट्रैफ़िक 200% ऊपर, बिक्री 0%",
    pc_ag_7: "कोई AI दृश्यता अनुकूलन नहीं",
    pc_save_title: "20+ घंटे और €2,000+/महिना बचाएं",
    pc_save_sub: "एजेंसियों या Google Ads से TopRankPulse पर स्विच करें और अपने जेब में अधिक पैसा रखें।",
    pc_save_cta: "योजना देखें",
    bm_no_monitors: "अभी तक कोई ब्रांड मानीटर नहीं किया गया",
    bm_no_monitors_desc: "अपने ब्रांड को जोड़ें ताकि आप ट्रैक कर सकें कि AI सर्च इंजन आपको कैसे देखते हैं।",
    bm_brand_name: "ब्रांड नाम",
    bm_website: "वेबसाइट URL",
    bm_industry: "उद्योग",
    bm_location: "स्थान",
    bm_competitors: "प्रतिस्पर्धी",
    bm_comma: "कोमा द्वारा पृथक",
    bm_start: "मॉनिटरिंग शुरू करें",
    bm_recheck: "फिर से जांचें",
    bm_citation_score: "उद्धरण स्कोर",
    bm_recommends: "सिफारिश करता है",
    bm_not_cited: "उद्धृत नहीं किया गया",
    bm_top_rec: "शीर्ष सिफारिश",
    bm_query_analysis: "क्वेरी विश्लेषण",
    bm_last_checked: "अंतिम जांच",
    bm_loading: "एआई दृश्यता का विश्लेषण कर रहे हैं...",
    bm_recommendations: "आपकी दृश्यता बढ़ाने के तरीके",
    bm_high: "उच्च प्रभाव",
    bm_medium: "मध्यम",
    bm_low: "कम",
    bm_vis_up: "अंतिम जांच के बाद दृश्यता बढ़ी",
    bm_vis_down: "अंतिम जांच के बाद दृश्यता घटी",
    attr_desc: "सही-सही देखें कि एआई खोज इंजन आपको कितना ट्रैफिक और राजस्व लाते हैं",
    attr_setup: "एट्रिब्यूशन सेटअप करें",
    attr_demo: "डेमो डेटा — असली नंबर देखने के लिए ट्रैकिंग पिक्सेल इंस्टॉल करें",
    attr_revenue: "राजस्व",
    attr_conv_rate: "परिवर्त. दर",
    attr_traffic_30: "एआई ट्रैफिक (30 दिन)",
    attr_by_source: "एआई स्रोत द्वारा ट्रैफिक",
    attr_source_details: "स्रोत विवरण",
    attr_visits_short: "द visites",
    attr_insights: "एआई इनसाइट्स",
    attr_pixel: "ट्रैकिंग पिक्सेल",
    attr_copied: "कॉपी किया गया",
    attr_copy: "कॉपी करें",
    attr_pixel_desc: "अपने वेबसाइट के </head> से पहले इसे पेस्ट करें ताकि असली एआई ट्रैफिक का ट्रैक रख सकें।",
    attr_no_sites: "कोई साइट अभी तक ट्रैक नहीं की गई",
    attr_no_sites_desc: "देखें कि एआई खोज इंजन आपको कितना ट्रैफिक लाते हैं, अपने वेबसाइट को जोड़ें।",
    attr_add_website: "अपनी वेबसाइट जोड़ें",
    ls_stat1: "साइटें एआई के लिए अदृश्य",
    ls_stat2: "एआई खोज से औसत विज़िट",
    ls_stat3: "फ्री ऑडिट परिणाम",
    ls_f1_t: "एआई दृश्यता ट्रैकिंग",
    ls_f1_d: "जांचें कि क्या ChatGPT, Perplexity & Gemini आपकी वेबसाइट का उल्लेख करते हैं",
    ls_f2_t: "पूर्ण SEO ऑडिट",
    ls_f2_d: "संवेदनशील विश्लेषण के साथ क्रियाशील अनुशंसाएं",
    ls_f3_t: "वॉयस सर्च स्कोर",
    ls_f3_d: "Siri, Alexa, Google सहायक के लिए अनुकूलित करें",
    ls_f4_t: "ज्योग्राफिक अनुकूलन",
    ls_f4_d: "स्थानीय SEO के लिए",
    ls_f5_t: "बैकलिंक विश्लेषण",
    ls_f5_d: "डोफॉलो, नोफॉलो और डोमेन प्राधिकरण की जांच करें",
    ls_f6_t: "साइट गति",
    ls_f6_d: "कोर वेब विटल्स और प्रदर्शन अंक",
    ls_more_cities: "अधिक शहरों में",
    ls_top_cities: "शीर्ष शहरों में",
    ls_cta_h1: "अपना निःशुल्क आरंभ करें",
    ls_cta_h2: "SEO ऑडिट",
    ls_cta_join: "शामिल हों व्यवसायों में",
    ls_cta_using: "TopRankPulse का उपयोग करके।",
    ls_free: "सदैव निःशुल्क",
    ls_no_card: "कोई क्रेडिट कार्ड नहीं",
    ls_langs: "26 भाषाएँ",
    pl_f1_t: "AI दृश्यता ट्रैकिंग",
    pl_f1_d: "देखें कि क्या ChatGPT, Perplexity और Gemini आपकी वेबसाइट का उल्लेख करते हैं",
    pl_f2_t: "पूर्ण SEO ऑडिट",
    pl_f2_d: "कार्रवाई योग्य सिफारिशों के साथ तकनीकी विश्लेषण",
    pl_f3_t: "कीवर्ड अनुसंधान",
    pl_f3_d: "वॉल्यूम, कठिनाई और प्रवृत्तियों के साथ बेहतर कीवर्ड खोजें",
    pl_f4_t: "वॉयस सर्च स्कोर",
    pl_f4_d: "Siri, Alexa, Google Assistant के लिए अनुकूलित करें",
    pl_f5_t: "AI सिफारिशें",
    pl_f5_d: "अपने स्कोर में सुधार के लिए चरण-दर-चरण निर्देश",
    pl_f6_t: "डैशबोर्ड विजेट",
    pl_f6_d: "आपके WordPress डैशबोर्ड में सीधा SEO स्कोर",
    pl_f7_t: "प्रकाशन पर ऑटो-स्कैन",
    pl_f7_d: "प्रकाशित होने पर नए पोस्टों का स्वचालित विश्लेषण करता है",
    pl_f8_t: "WooCommerce SEO",
    pl_f8_d: "उत्पाद SEO स्कोर, AI विवरण और Google शॉपिंग अनुकूलन",
    pl_f9_t: "ब्लॉग एजेंट (€25)",
    pl_f9_d: "आपकी साइट के लिए बैकलिंक के साथ 25 SEO लेख",
    pl_s3_t: "अपनी साइट स्कैन करें",
    pl_s3_d: "'अब स्कैन करें' पर क्लिक करें और 30 सेकंड में अपना SEO स्कोर + AI दृश्यता रिपोर्ट प्राप्त करें।",
    pl_w1_t: "उत्पाद SEO स्कोर",
    pl_w1_d: "प्रत्येक उत्पाद को वास्तविक समय का SEO स्कोर प्राप्त होता है।",
    pl_w2_t: "AI विवरण जनरेटर",
    pl_w2_d: "एक-क्लिक AI जनित SEO उत्पाद विवरण।",
    pl_w3_t: "Google शॉपिंग के लिए तैयार",
    pl_w3_d: "Google शॉपिंग के लिए उन्नत उत्पाद स्कीमा मार्कअप।",
    fear_h1_2: "जो रैंक करते हैं",
    fear_desc: "ChatGPT, Gemini और Perplexity शीर्ष रैंकिंग पृष्ठों से उत्तर खींचते हैं। यदि आप अब रैंक नहीं कर रहे हैं, तो AI आपके प्रतिस्पर्धियों की सिफारिश करेगा - और पीछे पकड़ना केवल कठिन होता जाएगा।",
    fear_m1_label: "महीना 1",
    fear_m1_title: "आपका प्रतियोगी सामग्री प्रकाशित करता है",
    fear_m1_desc: "जब आप इंतज़ार कर रहे हैं, वे SEO प्रामाणिकता बना रहे हैं और AI इंजनों द्वारा उद्धृत हो रहे हैं।",
    fear_m3_label: "महीना 3",
    fear_m3_title: "AI उन्हें अनुशंसित करना शुरू करता है",
    fear_m3_desc: "ChatGPT और Perplexity अब आपके प्रतिस्पर्धियों को डिफ़ॉल्ट रूप से उद्धृत करते हैं। आपकी ट्रैफ़िक घटती है।",
    fear_m6_label: "महीना 6",
    fear_m6_title: "आप अदृश्य हैं। वे आपके क्षेत्र में हैं।",
    fear_m6_desc: "AI मॉडल्स वही दोहराते हैं जो पहले से काम करता है। अब गति पकड़ने में 10 गुना अधिक प्रयास और पैसे लगते हैं।",
    fear_urgency: "हर दिन जिस दिन आप इंतज़ार करते हैं, आप ग्राहकों को खोते हैं",
    fear_cta_h: "अपने प्रतिस्पर्धियों से पहले रैंकिंग शुरू करें",
    fear_cta_sub: "आज रैंकिंग करने वाले ब्रांड कल के डिफ़ॉल्ट AI अनुशंसाएँ बनते हैं। सुनिश्चित करें कि यह आप हैं।",
    pp_what_clients_say: "ग्राहक क्या कहते हैं",
    pp_start_trial: "मुफ्त ट्रायल शुरू करें",
    pp_download_plugin: "प्लगइन डाउनलोड करें",
    pp_ready: "तैयार हैं",
    pp_start: "शुरू करें",
    pp_join: "TopRankPulse का उपयोग करने वाले हजारों व्यवसायों में शामिल हों।",
    pp_ai_vis_name: "AI दृश्यता ट्रैकिंग",
    pp_ai_vis_tag: "देखें कि क्या ChatGPT, Perplexity और Gemini आपकी वेबसाइट को उद्धृत करते हैं",
    pp_ai_vis_desc: "AI दृश्यता ट्रैकिंग यह मॉनिटर करती है कि क्या दुनिया के प्रमुख AI सर्च इंजनों — ChatGPT, Perplexity, Gemini, और Copilot — आपकी वेबसाइट का उल्लेख करते हैं जब उपयोगकर्ता प्रासंगिक प्रश्न पूछते हैं।",
    pp_ai_vis_f1: "4 AI इंजनों में रियल-टाइम उद्धरण मॉनिटरिंग",
    pp_ai_vis_f2: "साप्ताहिक दृश्यता रुझान रिपोर्ट",
    pp_ai_vis_f3: "प्रतिस्पर्धी उद्धरण तुलना",
    pp_ai_vis_f4: "वॉइस सर्च तैयारी स्कोर",
    pp_ai_vis_f5: "AI-उपन्यस्त सामग्री अनुशंसाएँ",
    pp_ai_vis_f6: "26-भाषा समर्थन स्वचालित पहचान के साथ",
    pp_seo_name: "पूर्ण SEO ऑडिट",
    pp_seo_tag: "AI-संचालित अनुशंसाओं के साथ तकनीकी SEO विश्लेषण",
    pp_seo_desc: "हमारा पूर्ण SEO ऑडिट 50+ रैंकिंग कारकों का विश्लेषण करता है जिसमें तकनीकी SEO, सामग्री गुणवत्ता, बैकलिंक्स, पृष्ठ गति, मोबाइल अनुकूलन और AI तैयारता शामिल है।",
    pp_seo_f1: "50+ रैंकिंग कारकों का विश्लेषण किया गया",
    pp_seo_f2: "तकनीकी SEO जाँच (मेटा टैग, हेडर, स्कीमा)",
    pp_seo_f3: "सामग्री गुणवत्ता स्कोरिंग",
    pp_seo_f4: "बैकलिंक प्रोफ़ाइल विश्लेषण",
    pp_seo_f5: "कोर वेब विटल्स मूल्यांकन",
    pp_seo_f6: "मोबाइल-प्रथम अनुकूलन टिप्स",
    pp_seo_f7: "AI तैयारता स्कोर",
    pp_seo_f8: "डाउनलोड करने योग्य PDF रिपोर्ट",
    pp_brand_name: "AI ब्रांड निगरानी",
    pp_brand_tag: "यदि AI सर्च इंजनों में आपके ब्रांड का उल्लेख हो तो 24/7 ट्रैकिंग",
    pp_brand_f1: "4 AI इंजनों में 24/7 मॉनिटरिंग",
    pp_brand_f2: "ईमेल के माध्यम से रियल-टाइम उद्धरण अलर्ट",
    pp_brand_f3: "प्रतिस्पर्धी मानक तुलना",
    pp_brand_f4: "चार्ट के साथ ऐतिहासिक प्रवृत्ति ट्रैकिंग",
    pp_brand_f5: "क्वेरी-स्तरीय विश्लेषण",
    pp_brand_f6: "क्रियान्वयन योग्य AI ऑप्टिमाइजेशन सिफारिशें",
    pp_comp_name: "AI प्रतियोगी जासूस",
    pp_comp_tag: "AI द्वारा संचालित वास्तविक समय प्रतिस्पर्धात्मक बुद्धिमत्ता",
    pp_comp_f1: "वास्तविक समय प्रतियोगी SEO मॉनिटरिंग",
    pp_comp_f2: "सामग्री परिवर्तन अलर्ट",
    pp_comp_f3: "बैकलिंक अधिग्रहण ट्रैकिंग",
    pp_comp_f4: "AI दृश्यता तुलना",
    pp_comp_f5: "शक्ति/कमजोरी विश्लेषण",
    pp_comp_f6: "अवसर पहचान",
    pp_comp_f7: "उच्च प्रभाव परिवर्तन के लिए प्राथमिकता अलर्ट",
    pp_blog_name: "ब्लॉग एजेंट",
    pp_blog_tag: "25 SEO लेख, प्रत्येक में 4 बैकलिंक — AI द्वारा लिखित, दैनिक प्रकाशित",
    pp_blog_f1: "25 अद्वितीय SEO-ऑप्टिमाइज्ड लेख",
    pp_blog_f2: "25 दिनों में 1 प्रति दिन प्रकाशित",
    pp_blog_f3: "प्रत्येक लेख में 4 dofollow बैकलिंक",
    pp_blog_f4: "26 भाषाओं में स्वचालित रूप से अनुवादित",
    pp_blog_f5: "आपकी उद्योग के आधार पर शीर्षक अनुसंधान",
    pp_blog_f6: "लंबे फॉर्म की सामग्री (1,500+ शब्द)",
    pp_blog_f7: "आंतरिक लिंकिंग संरचना",
    pp_blog_f8: "स्कीमा मार्कअप शामिल",
    pp_wp_name: "WordPress + WooCommerce प्लगइन",
    pp_wp_tag: "AI दृश्यता ट्रैकिंग वाला मुफ्त SEO प्लगइन",
    pp_auto_name: "SEO ऑटोपायलट",
    pp_auto_tag: "AI स्वचालित रूप से आपकी SEO को ठीक करता है — सिर्फ सिफारिशें नहीं",
    pp_auto_desc: "SEO ऑटोपायलट आपको यह नहीं बताता कि क्या ठीक करना है — यह इसे आपके लिए ठीक करता है। हमारी AI स्वचालित रूप से ऑप्टिमाइज्ड मेटा शीर्षक, विवरण, छवि ऑल्ट टेक्स्ट, आंतरिक लिंक, और FAQ सेक्शन जनरेट करती है। हमारे प्लगइन्स के माध्यम से WordPress और Shopify के साथ काम करता है।",
    pp_auto_f1: "SEO मेटा शीर्षक और विवरण स्वचालित रूप से उत्पन्न करें",
    pp_auto_f2: "छवि ऑल्ट टेक्स्ट स्वचालित रूप से उत्पन्न करें",
    pp_auto_f3: "स्मार्ट आंतरिक लिंकिंग सुझाव",
    pp_auto_f4: "स्कीमा मार्कअप के साथ FAQ सेक्शन जनरेशन",
    pp_auto_f5: "टूटे लिंक पहचान और रीडायरेक्ट सुझाव",
    pp_auto_f6: "साप्ताहिक स्वचालित स्कैन",
    pp_auto_f7: "WordPress और Shopify प्लगइन एकीकरण",
    pp_auto_f8: "पहले/बाद का स्कोर ट्रैकिंग",
    pp_sim_name: "AI सर्च सिम्युलेटर",
    pp_sim_tag: "देखें कि ChatGPT, Perplexity और Gemini क्या उत्तर देंगे — मुफ्त में",
    pp_sim_desc: "AI सर्च सिम्युलेटर आपको कोई भी प्रश्न टाइप करने और ChatGPT, Perplexity, Gemini, और Copilot से सिम्युलेटेड प्रतिक्रियाएं देखने की अनुमति देता है। जानें कि क्या आपकी वेबसाइट AI सर्च परिणामों में उल्लेखित होगी।",
    pp_sim_f1: "4 इंजन से AI खोज प्रतिक्रियाएँ सिम्युलेट करें",
    pp_sim_f2: "जांचें कि आपकी वेबसाइट का उल्लेख होता है या नहीं",
    pp_sim_f3: "कोई भी कीवर्ड या प्रश्न जांचें",
    pp_sim_f4: "मुफ्त असीमित प्रश्न",
    pp_sim_f5: "26 भाषाओं का समर्थन",
    pp_blog_desc: "ब्लॉग एजेंट आपके लिए 25 SEO-इष्टतम लेख लिखता है - 25 दिनों में एक प्रति। हर लेख में 4 डोफॉलो बैकलिंक्स होते हैं, 26 भाषाओं में स्वतः अनुवादित होता है, और समय पर प्रकाशित होता है।",
    pp_brand_desc: "AI ब्रांड मॉनिटरिंग यह ट्रैक करती है कि क्या ChatGPT, Perplexity, Gemini और Copilot आपके ब्रांड का उल्लेख करते हैं जब उपयोगकर्ता संबंधित प्रश्न पूछते हैं। वास्तविक समय में सूचनाएं प्राप्त करें और प्रतियोगियों के खिलाफ मानक सेट करें।",
    pp_comp_desc: "AI प्रतियोगी जासूस आपके प्रतियोगियों की SEO रणनीतियों की वास्तविक समय में निगरानी करता है। जब वे नई सामग्री प्रकाशित करते हैं, बैकलिंक्स प्राप्त करते हैं, या उनकी AI दृश्यता स्कोर में सुधार होता है तो सूचनाएं प्राप्त करें।",
    pp_wp_desc: "हमारा मुफ्त WordPress प्लगइन TopRankPulse को सीधे आपके WordPress प्रशासन में लाता है। SEO स्कोर, AI दृश्यता ट्रैकिंग, और एक-क्लिक सुधार बिना अपने डैशबोर्ड को छोड़े प्राप्त करें।",
    pp_wp_f1: "WordPress प्रशासन से एक-क्लिक SEO सुधार",
    pp_wp_f2: "बिल्ट-इन AI दृश्यता ट्रैकिंग",
    pp_wp_f3: "WooCommerce उत्पाद SEO अनुकूलन",
    pp_wp_f4: "स्वचालित स्कीमा मार्कअप",
    pp_wp_f5: "सभी योजनाओं के लिए हमेशा के लिए मुफ्त",
    pp_free_scan: "मुफ्त पहला स्कैन",
  },
  id: {
    pc_tag: "Berhenti bayar mahal untuk SEO", pc_h1: "Ganti agensi SEO mahal", pc_h1_highlight: "dengan harga makan malam keluarga",
    pc_month: "bulan", pc_best_value: "NILAI TERBAIK", pc_cta: "MULAI GRATIS",
    fear_warning: "PERINGATAN", fear_h1: "AI merekomendasikan merek", fear_h1_highlight: "HARI INI",
    fear_cta_btn: "MULAI SEKARANG", bm_add_brand: "Tambah merek", bm_overall: "Visibilitas AI keseluruhan",
    attr_visits: "Kunjungan AI", attr_conversions: "Konversi", ls_scan: "SCAN WEBSITE ANDA",
  
    pc_sub: "Anda dapat mencobanya secara gratis dan mulai merangking hari ini",
    pc_agency: "Agensi SEO",
    pc_ads_1: "Anda membutuhkan anggaran besar",
    pc_ads_2: "Penelitian kata kunci manual",
    pc_ads_3: "Dioptimalkan untuk klik, bukan penjualan",
    pc_ads_4: "Lalu lintas sewaan",
    pc_ads_5: "Kompetitor mengalahkan tawaran Anda",
    pc_ads_6: "Lalu lintas berhenti saat Anda berhenti membelanjakan",
    pc_ads_7: "€0 dalam hasil tahan lama",
    pc_trp_1: "AI menulis konten berkualitas harian",
    pc_trp_2: "Penelitian kata kunci otomatis",
    pc_trp_3: "Backlink berkualitas termasuk",
    pc_trp_4: "Tanpa kontrak — batal kapan saja",
    pc_trp_5: "Rangking sekali, dapatkan lalu lintas selamanya",
    pc_trp_6: "Tidak perlu pengetahuan teknis",
    pc_trp_7: "Dibangun untuk mendatangkan pembeli, bukan lalu lintas acak",
    pc_ag_1: "Bulan untuk melihat hasil",
    pc_ag_2: "Rapat mingguan",
    pc_ag_3: "Terikat kontrak",
    pc_ag_4: "2 artikel blog/bulan seharga €2,300",
    pc_ag_5: "Mereka memiliki segalanya",
    pc_ag_6: "Lalu lintas meningkat 200%, Penjualan 0%",
    pc_ag_7: "Tidak ada optimasi visibilitas AI",
    pc_save_title: "Hemat 20+ jam & €2,000+/bulan",
    pc_save_sub: "Beralih dari agensi atau Google Ads ke TopRankPulse dan simpan lebih banyak uang di saku Anda.",
    pc_save_cta: "LIHAT RENCANA",
    bm_no_monitors: "Belum Ada Merek yang Dipantau",
    bm_no_monitors_desc: "Tambahkan merek Anda untuk mulai melacak bagaimana mesin pencari AI melihat Anda.",
    bm_brand_name: "Nama Merek",
    bm_website: "URL Situs Web",
    bm_industry: "Industri",
    bm_location: "Lokasi",
    bm_competitors: "Kompetitor",
    bm_comma: "dipisahkan dengan koma",
    bm_start: "Mulai Memantau",
    bm_recheck: "Periksa Ulang",
    bm_citation_score: "Skor Sitasi",
    bm_recommends: "Merekomendasikan",
    bm_not_cited: "Tidak dikutip",
    bm_top_rec: "Rekomendasi Teratas",
    bm_query_analysis: "Analisis Kuery",
    bm_last_checked: "Terakhir diperiksa",
    bm_loading: "Menganalisis visibilitas AI...",
    bm_recommendations: "Cara meningkatkan visibilitas Anda",
    bm_high: "Dampak Tinggi",
    bm_medium: "Sedang",
    bm_low: "Rendah",
    bm_vis_up: "Visibilitas meningkat sejak pemeriksaan terakhir",
    bm_vis_down: "Visibilitas menurun sejak pemeriksaan terakhir",
    attr_desc: "Lihat dengan tepat seberapa banyak lalu lintas dan pendapatan yang dibawa oleh mesin pencari AI",
    attr_setup: "Atur Atribusi",
    attr_demo: "Data demo — pasang pixel pelacakan untuk melihat angka yang nyata",
    attr_revenue: "Pendapatan",
    attr_conv_rate: "Tingkat Konv.",
    attr_traffic_30: "Lalu lintas AI (30 Hari)",
    attr_by_source: "Lalu lintas berdasarkan Sumber AI",
    attr_source_details: "Detail Sumber",
    attr_visits_short: "kunjungan",
    attr_insights: "Wawasan AI",
    attr_pixel: "Pixel Pelacakan",
    attr_copied: "Disalin",
    attr_copy: "Salin",
    attr_pixel_desc: "Tempelkan ini sebelum </head> di situs web Anda untuk mulai melacak lalu lintas AI yang nyata.",
    attr_no_sites: "Belum ada Situs yang Dilacak",
    attr_no_sites_desc: "Tambahkan situs web Anda untuk melihat seberapa banyak lalu lintas yang dibawa oleh mesin pencari AI.",
    attr_add_website: "Tambahkan Situs Web Anda",
    ls_stat1: "situs tidak terlihat oleh AI",
    ls_stat2: "rata-rata kunjungan dari pencarian AI",
    ls_stat3: "hasil audit gratis",
    ls_f1_t: "Pelacakan Visibilitas AI",
    ls_f1_d: "Periksa apakah ChatGPT, Perplexity & Gemini menyebutkan situs web Anda",
    ls_f2_t: "Audit SEO Lengkap",
    ls_f2_d: "Analisis teknis dengan rekomendasi yang dapat ditindaklanjuti",
    ls_f3_t: "Skor Pencarian Suara",
    ls_f3_d: "Optimalkan untuk Siri, Alexa, Google Assistant",
    ls_f4_t: "Optimisasi GEO",
    ls_f4_d: "SEO Lokal untuk",
    ls_f5_t: "Analisis Backlink",
    ls_f5_d: "Periksa dofollow, nofollow & otoritas domain",
    ls_f6_t: "Kecepatan Situs",
    ls_f6_d: "Core Web Vitals & skor kinerja",
    ls_more_cities: "Lebih banyak kota di",
    ls_top_cities: "Kota-kota teratas di",
    ls_cta_h1: "MULAI GRATIS",
    ls_cta_h2: "AUDIT SEO",
    ls_cta_join: "Bergabung dengan bisnis di",
    ls_cta_using: "menggunakan TopRankPulse.",
    ls_free: "Gratis selamanya",
    ls_no_card: "Tanpa kartu kredit",
    ls_langs: "26 bahasa",
    pl_f1_t: "Pelacakan Visibilitas AI",
    pl_f1_d: "Lihat apakah ChatGPT, Perplexity & Gemini menyebutkan situs Anda",
    pl_f2_t: "Audit SEO Lengkap",
    pl_f2_d: "Analisis teknis dengan rekomendasi yang dapat ditindaklanjuti",
    pl_f3_t: "Riset Kata Kunci",
    pl_f3_d: "Cari kata kunci yang lebih baik dengan volume, kesulitan & tren",
    pl_f4_t: "Skor Pencarian Suara",
    pl_f4_d: "Optimalkan untuk Siri, Alexa, Google Assistant",
    pl_f5_t: "Rekomendasi AI",
    pl_f5_d: "Instruksi langkah demi langkah untuk meningkatkan skor Anda",
    pl_f6_t: "Widget Dasbor",
    pl_f6_d: "Skor SEO langsung di dasbor WordPress Anda",
    pl_f7_t: "Pemindaian Otomatis Saat Publikasi",
    pl_f7_d: "Secara otomatis menganalisis posting baru saat diterbitkan",
    pl_f8_t: "SEO WooCommerce",
    pl_f8_d: "Skor SEO produk, deskripsi AI & optimisasi Google Shopping",
    pl_f9_t: "Agen Blog (€25)",
    pl_f9_d: "25 artikel SEO dengan tautan balik ke situs Anda",
    pl_s3_t: "Pindai Situs Anda",
    pl_s3_d: "Klik 'Pindai Sekarang' dan dapatkan skor SEO + laporan visibilitas AI dalam 30 detik.",
    pl_w1_t: "Skor SEO Produk",
    pl_w1_d: "Setiap produk mendapatkan skor SEO secara real-time.",
    pl_w2_t: "Generator Deskripsi AI",
    pl_w2_d: "Deskripsi produk SEO yang dihasilkan AI dengan satu klik.",
    pl_w3_t: "Siap Google Shopping",
    pl_w3_d: "Markup skema produk yang ditingkatkan untuk Google Shopping.",
    fear_h1_2: "yang peringkat",
    fear_desc: "ChatGPT, Gemini, dan Perplexity mengambil jawaban dari halaman dengan peringkat teratas. Jika Anda tidak memiliki peringkat sekarang, AI akan merekomendasikan pesaing Anda — dan semakin sulit untuk mengejar.",
    fear_m1_label: "Bulan 1",
    fear_m1_title: "Pesaing Anda menerbitkan konten",
    fear_m1_desc: "Sementara Anda menunggu, mereka membangun otoritas SEO dan mendapatkan kutipan dari mesin AI.",
    fear_m3_label: "Bulan 3",
    fear_m3_title: "AI mulai merekomendasikan mereka",
    fear_m3_desc: "ChatGPT dan Perplexity kini secara default mengutip pesaing Anda. Lalu lintas Anda menurun.",
    fear_m6_label: "Bulan 6",
    fear_m6_title: "Anda tak terlihat. Mereka menguasai ceruk Anda.",
    fear_m6_desc: "Model AI memperkuat apa yang sudah berhasil. Mengejar ketinggalan sekarang membutuhkan usaha dan uang 10x lebih banyak.",
    fear_urgency: "Setiap hari Anda menunggu, Anda kehilangan pelanggan",
    fear_cta_h: "Mulailah meranking sebelum pesaing Anda",
    fear_cta_sub: "Merek yang meranking hari ini menjadi rekomendasi AI default besok. Pastikan itu Anda.",
    pp_what_clients_say: "APA KATA KLIEN",
    pp_start_trial: "Mulai Uji Coba Gratis",
    pp_download_plugin: "Unduh Plugin",
    pp_ready: "SIAP UNTUK",
    pp_start: "MULAI",
    pp_join: "Bergabunglah dengan ribuan bisnis yang menggunakan TopRankPulse.",
    pp_ai_vis_name: "Pelacakan Visibilitas AI",
    pp_ai_vis_tag: "Lihat apakah ChatGPT, Perplexity & Gemini mengutip situs web Anda",
    pp_ai_vis_desc: "Pelacakan Visibilitas AI memantau apakah mesin pencari AI terkemuka di dunia — ChatGPT, Perplexity, Gemini, dan Copilot — menyebutkan situs web Anda ketika pengguna mengajukan pertanyaan yang relevan.",
    pp_ai_vis_f1: "Pemantauan kutipan waktu nyata di 4 mesin AI",
    pp_ai_vis_f2: "Laporan tren visibilitas mingguan",
    pp_ai_vis_f3: "Perbandingan kutipan pesaing",
    pp_ai_vis_f4: "Skor kesiapan pencarian suara",
    pp_ai_vis_f5: "Rekomendasi konten yang dioptimalkan AI",
    pp_ai_vis_f6: "Dukungan 26 bahasa dengan deteksi otomatis",
    pp_seo_name: "Audit SEO Lengkap",
    pp_seo_tag: "Analisis SEO teknis dengan rekomendasi bertenaga AI",
    pp_seo_desc: "Audit SEO Lengkap kami menganalisis 50+ faktor perankingan termasuk SEO teknis, kualitas konten, backlink, kecepatan halaman, optimasi mobile, dan kesiapan AI.",
    pp_seo_f1: "50+ faktor perankingan dianalisis",
    pp_seo_f2: "Pemeriksaan SEO teknis (meta tags, header, skema)",
    pp_seo_f3: "Penilaian kualitas konten",
    pp_seo_f4: "Analisis profil backlink",
    pp_seo_f5: "Penilaian Core Web Vitals",
    pp_seo_f6: "Tips optimasi mobile-first",
    pp_seo_f7: "Skor kesiapan AI",
    pp_seo_f8: "Laporan PDF yang dapat diunduh",
    pp_brand_name: "Pemantauan Merek AI",
    pp_brand_tag: "Pemantauan 24/7 jika mesin pencari AI menyebutkan merek Anda",
    pp_brand_f1: "Pemantauan 24/7 di 4 mesin AI",
    pp_brand_f2: "Pemberitahuan kutipan waktu nyata melalui email",
    pp_brand_f3: "Perbandingan tolok ukur pesaing",
    pp_brand_f4: "Pelacakan tren historis dengan grafik",
    pp_brand_f5: "Analisis tingkat kueri",
    pp_brand_f6: "Rekomendasi optimasi AI yang dapat ditindaklanjuti",
    pp_comp_name: "AI Kompetitor Spy",
    pp_comp_tag: "Intelijen kompetitif waktu nyata yang didorong oleh AI",
    pp_comp_f1: "Pemantauan SEO pesaing secara waktu nyata",
    pp_comp_f2: "Pemberitahuan perubahan konten",
    pp_comp_f3: "Pelacakan akuisisi backlink",
    pp_comp_f4: "Perbandingan visibilitas AI",
    pp_comp_f5: "Analisis kekuatan/kelemahan",
    pp_comp_f6: "Identifikasi peluang",
    pp_comp_f7: "Pemberitahuan prioritas untuk perubahan berdampak tinggi",
    pp_blog_name: "Blog Agent",
    pp_blog_tag: "25 artikel SEO dengan 4 backlink masing-masing — ditulis oleh AI, diterbitkan setiap hari",
    pp_blog_f1: "25 artikel unik yang dioptimalkan untuk SEO",
    pp_blog_f2: "Diterbitkan 1 per hari selama 25 hari",
    pp_blog_f3: "4 backlink dofollow per artikel",
    pp_blog_f4: "Diterjemahkan secara otomatis ke dalam 26 bahasa",
    pp_blog_f5: "Riset topik berdasarkan industri Anda",
    pp_blog_f6: "Konten panjang (1.500+ kata)",
    pp_blog_f7: "Struktur tautan internal",
    pp_blog_f8: "Markup skema termasuk",
    pp_wp_name: "Plugin WordPress + WooCommerce",
    pp_wp_tag: "Plugin SEO gratis dengan pelacakan visibilitas AI terintegrasi",
    pp_auto_name: "SEO Autopilot",
    pp_auto_tag: "AI secara otomatis memperbaiki SEO Anda — bukan hanya rekomendasi",
    pp_auto_desc: "SEO Autopilot tidak hanya memberitahu Anda apa yang perlu diperbaiki — tetapi memperbaikinya untuk Anda. AI kami secara otomatis menghasilkan judul meta yang dioptimalkan, deskripsi, teks alt gambar, tautan internal, dan bagian FAQ. Bekerja dengan WordPress dan Shopify melalui plugin kami.",
    pp_auto_f1: "Menghasilkan judul & deskripsi meta SEO secara otomatis",
    pp_auto_f2: "Menghasilkan teks alt gambar secara otomatis",
    pp_auto_f3: "Saran tautan internal yang cerdas",
    pp_auto_f4: "Generasi bagian FAQ dengan markup skema",
    pp_auto_f5: "Deteksi tautan rusak & saran pengalihan",
    pp_auto_f6: "Pindai otomatis mingguan",
    pp_auto_f7: "Integrasi plugin WordPress & Shopify",
    pp_auto_f8: "Pelacakan skor sebelum/setelah",
    pp_sim_name: "Simulator Pencarian AI",
    pp_sim_tag: "Lihat jawaban dari ChatGPT, Perplexity & Gemini — secara gratis",
    pp_sim_desc: "Simulator Pencarian AI memungkinkan Anda mengetik pertanyaan apa pun dan melihat respons yang disimulasikan dari ChatGPT, Perplexity, Gemini, dan Copilot. Temukan apakah situs web Anda akan disebutkan dalam hasil pencarian AI.",
    pp_sim_f1: "Simulasikan respons pencarian AI dari 4 mesin",
    pp_sim_f2: "Periksa apakah situs web Anda disebutkan",
    pp_sim_f3: "Uji kata kunci atau pertanyaan apa pun",
    pp_sim_f4: "Pertanyaan tanpa batas gratis",
    pp_sim_f5: "Dukungan 26 bahasa",
    pp_blog_desc: "Blog Agent menulis 25 artikel yang dioptimalkan SEO untuk situs web Anda — satu per hari selama 25 hari. Setiap artikel mencakup 4 backlink dofollow, diterjemahkan otomatis ke dalam 26 bahasa, dan diterbitkan sesuai jadwal.",
    pp_brand_desc: "AI Brand Monitoring melacak apakah ChatGPT, Perplexity, Gemini, dan Copilot menyebutkan merek Anda ketika pengguna mengajukan pertanyaan relevan. Dapatkan pemberitahuan waktu nyata dan bandingkan dengan pesaing.",
    pp_comp_desc: "AI Competitor Spy memantau strategi SEO pesaing Anda secara real-time. Dapatkan pemberitahuan saat mereka menerbitkan konten baru, memperoleh backlink, atau meningkatkan skor visibilitas AI mereka.",
    pp_wp_desc: "Plugin WordPress gratis kami membawa TopRankPulse langsung ke admin WordPress Anda. Dapatkan skor SEO, pelacakan visibilitas AI, dan perbaikan dengan satu klik tanpa meninggalkan dasbor Anda.",
    pp_wp_f1: "Perbaikan SEO satu klik dari admin WordPress",
    pp_wp_f2: "Pelacakan visibilitas AI bawaan",
    pp_wp_f3: "Optimasi SEO produk WooCommerce",
    pp_wp_f4: "Markup skema otomatis",
    pp_wp_f5: "Gratis selamanya untuk semua paket",
    pp_free_scan: "Pemindaian pertama gratis",
  },

  no: {
    pc_tag: "Slutt å betale for mye for SEO",
    pc_h1: "Bytt ut dyre SEO-byråer",
    pc_h1_highlight: "for prisen av en familielunsj",
    pc_sub: "Du kan prøve det gratis og begynne å rangere i dag",
    pc_month: "måned",
    pc_best_value: "BESTE VERDI",
    pc_agency: "SEO Byrå",
    pc_ads_1: "Du trenger et stort budsjett",
    pc_ads_2: "Manuell nøkkelordforskning",
    pc_ads_3: "Optimalisert for klikk, ikke salg",
    pc_ads_4: "Leid trafikk",
    pc_ads_5: "Konkurrenter byr over deg",
    pc_ads_6: "Trafikken stopper når du slutter å bruke penger",
    pc_ads_7: "€0 i varige resultater",
    pc_trp_1: "AI skriver kvalitetsinnhold daglig",
    pc_trp_2: "Automatisk nøkkelordforskning",
    pc_trp_3: "Kvalitetslenker inkludert",
    pc_trp_4: "Ingen kontrakter — avbestill når som helst",
    pc_trp_5: "Rangér én gang, få trafikk for alltid",
    pc_trp_6: "Ingen teknisk kunnskap nødvendig",
    pc_trp_7: "Bygget for å tiltrekke kjøpere, ikke tilfeldig trafikk",
    pc_cta: "START GRATIS PRØVE",
    pc_ag_1: "Måneder for å se resultater",
    pc_ag_2: "Ukentlige møter",
    pc_ag_3: "Låst inn i kontrakter",
    pc_ag_4: "2 blogginnlegg/måned for €2,300",
    pc_ag_5: "De eier alt",
    pc_ag_6: "Trafikken opp 200%, Salg 0%",
    pc_ag_7: "Ingen AI synlighetsoptimalisering",
    pc_save_title: "Spar 20+ timer & €2,000+/måned",
    pc_save_sub: "Bytt fra byråer eller Google Ads til TopRankPulse og behold mer penger i lommen.",
    pc_save_cta: "SE PLANER",
    bm_no_monitors: "Ingen merker overvåkes enda",
    bm_no_monitors_desc: "Legg til merket ditt for å begynne å følge med på hvordan AI-søkene ser deg.",
    bm_add_brand: "Legg til merket ditt",
    bm_brand_name: "Merkets navn",
    bm_website: "Nettadresse",
    bm_industry: "Industri",
    bm_location: "Lokasjon",
    bm_competitors: "Konkurrenter",
    bm_comma: "komma atskilt",
    bm_start: "Start Overvåking",
    bm_recheck: "Sjekk på nytt",
    bm_overall: "Total AI Synlighet",
    bm_citation_score: "Siteringspoeng",
    bm_recommends: "Anbefaler",
    bm_not_cited: "Ikke sitert",
    bm_top_rec: "Topp Anbefaling",
    bm_query_analysis: "Forespørsel Analyse",
    bm_last_checked: "Sist sjekket",
    bm_loading: "Analyserer AI synlighet...",
    bm_recommendations: "Hvordan øke synligheten din",
    bm_high: "Høy Innvirkning",
    bm_medium: "Moderat",
    bm_low: "Lav",
    bm_vis_up: "Synlighet økt siden forrige sjekk",
    bm_vis_down: "Synlighet redusert siden forrige sjekk",
    attr_desc: "Se nøyaktig hvor mye trafikk og inntekt AI søkemotorer genererer for deg",
    attr_setup: "Sett opp Attribusjon",
    attr_demo: "Demodata — installer sporingpixel for å se ekte tall",
    attr_visits: "AI Besøk",
    attr_conversions: "Konverteringer",
    attr_revenue: "Inntekt",
    attr_conv_rate: "Konv. Rate",
    attr_traffic_30: "AI Trafikk (30 Dager)",
    attr_by_source: "Trafikk etter AI Kilde",
    attr_source_details: "Kildedetaljer",
    attr_visits_short: "besøk",
    attr_insights: "AI Innsikter",
    attr_pixel: "Sporingspixel",
    attr_copied: "Kopiert",
    attr_copy: "Kopier",
    attr_pixel_desc: "Lim dette før </head> på nettstedet ditt for å begynne å spore ekte AI trafikk.",
    attr_no_sites: "Ingen Nettsteder Overvåkes Ennå",
    attr_no_sites_desc: "Legg til nettstedet ditt for å se hvor mye trafikk AI søkemotorer genererer for deg.",
    attr_add_website: "Legg til Nettstedet Ditt",
    ls_stat1: "nettsteder usynlige for AI",
    ls_stat2: "gjennomsnittlige besøk fra AI søk",
    ls_stat3: "gratis revisjonsresultater",
    ls_f1_t: "AI Synlighet Overvåking",
    ls_f1_d: "Sjekk om ChatGPT, Perplexity & Gemini viser til nettstedet ditt",
    ls_f2_t: "Fullstendig SEO-revisjon",
    ls_f2_d: "Teknisk analyse med handlingsbare anbefalinger",
    ls_f3_t: "Stemme Søke Poeng",
    ls_f3_d: "Optimaliser for Siri, Alexa, Google Assistant",
    ls_f4_t: "GEO Optimalisering",
    ls_f4_d: "Lokal SEO for",
    ls_f5_t: "Backlink Analyse",
    ls_f5_d: "Sjekk dofollow, nofollow & domeneautoritet",
    ls_f6_t: "Nettsteds Hastighet",
    ls_f6_d: "Kjerne Web Vitals & ytelsesscore",
    ls_more_cities: "Flere byer i",
    ls_top_cities: "Toppbyer i",
    ls_cta_h1: "START DIN GRATIS",
    ls_cta_h2: "SEO REVISJON",
    ls_cta_join: "Bli med virksomheter i",
    ls_cta_using: "som bruker TopRankPulse.",
    ls_scan: "SCAN NETTSTEDET DITT",
    ls_free: "Gratisk for alltid",
    ls_no_card: "Ingen kredittkort",
    ls_langs: "26 språk",
    pl_f1_t: "AI Synlighet Sporing",
    pl_f1_d: "Se om ChatGPT, Perplexity & Gemini viser til nettstedet ditt",
    pl_f2_t: "Fullstendig SEO-revisjon",
    pl_f2_d: "Teknisk analyse med handlingsbare anbefalinger",
    pl_f3_t: "Nøkkelord Forskning",
    pl_f3_d: "Finn bedre nøkkelord med volum, vanskelighetsgrad & trender",
    pl_f4_t: "Stemme Søke Poeng",
    pl_f4_d: "Optimaliser for Siri, Alexa, Google Assistant",
    pl_f5_t: "AI Anbefalinger",
    pl_f5_d: "Trinn-for-trinn instruksjoner for å forbedre poengsummen din",
    pl_f6_t: "Dashboard-widget",
    pl_f6_d: "SEO poeng direkte i WordPress-dashbordet ditt",
    pl_f7_t: "Auto-Scan ved Publisering",
    pl_f7_d: "Analyserer automatisk nye innlegg når de publiseres",
    pl_f8_t: "WooCommerce SEO",
    pl_f8_d: "Produkt SEO-poeng, AI beskrivelser & Google Shopping optimalisering",
    pl_f9_t: "Blogg Agent (€25)",
    pl_f9_d: "25 SEO-artikler med tilbakekoblinger til nettstedet ditt",
    pl_s3_t: "Scan Nettstedet Ditt",
    pl_s3_d: "Klikk 'Skann Nå' og få din SEO-skåre + AI synlighetsrapport på 30 sekunder.",
    pl_w1_t: "Produkt SEO Skåre",
    pl_w1_d: "Hvert produkt får en sanntids SEO-skåre.",
    pl_w2_t: "AI Beskrivelsesgenerator",
    pl_w2_d: "AI-genererte SEO-produktbeskrivelser med ett klikk.",
    pl_w3_t: "Google Shopping Klar",
    pl_w3_d: "Forbedret produkt schema markup for Google Shopping.",
    fear_warning: "ADVARSEL",
    fear_h1: "AI anbefaler merker",
    fear_h1_2: "som rangerer",
    fear_h1_highlight: "I DAG",
    fear_desc: "ChatGPT, Gemini og Perplexity henter svar fra topp rangerte sider. Hvis du ikke rangerer nå, vil AI anbefale konkurrentene dine — og det blir bare vanskeligere å ta igjen.",
    fear_m1_label: "Måned 1",
    fear_m1_title: "Konkurrenten din publiserer innhold",
    fear_m1_desc: "Mens du venter, bygger de SEO autoritet og blir referert av AI-motorer.",
    fear_m3_label: "Måned 3",
    fear_m3_title: "AI begynner å anbefale dem",
    fear_m3_desc: "ChatGPT og Perplexity refererer nå automatisk til konkurrentene dine. Trafikken din synker.",
    fear_m6_label: "Måned 6",
    fear_m6_title: "Du er usynlig. De eier nisjen din.",
    fear_m6_desc: "AI-modeller forsterker det som allerede fungerer. Å ta igjen nå koster 10x mer innsats og penger.",
    fear_urgency: "Hver dag du venter, mister du kunder",
    fear_cta_h: "Begynn å rangere før konkurrentene dine gjør det",
    fear_cta_sub: "Merker som rangerer i dag blir de standard AI-anbefalingene i morgen. Sørg for at det er deg.",
    fear_cta_btn: "START NÅ",
    pp_what_clients_say: "HVA KUNDER SIER",
    pp_start_trial: "Start Gratis Prøveperiode",
    pp_download_plugin: "Last ned Plugin",
    pp_ready: "KLAR TIL",
    pp_start: "START",
    pp_join: "Bli med tusenvis av bedrifter som bruker TopRankPulse.",
    pp_ai_vis_name: "AI Synlighetsovervåkning",
    pp_ai_vis_tag: "Se om ChatGPT, Perplexity & Gemini refererer til nettstedet ditt",
    pp_ai_vis_desc: "AI Synlighetsovervåkning overvåker om verdens ledende AI-søkemotorer — ChatGPT, Perplexity, Gemini og Copilot — nevner nettstedet ditt når brukere stiller relevante spørsmål.",
    pp_ai_vis_f1: "Sanntids siteringsovervåkning på tvers av 4 AI-motorer",
    pp_ai_vis_f2: "Ukentlige synlighetstrendrapporter",
    pp_ai_vis_f3: "Sammenligning av konkurrenters sitater",
    pp_ai_vis_f4: "Vurdering av tale-søk beredskap",
    pp_ai_vis_f5: "AI-optimaliserte innholdsanbefalinger",
    pp_ai_vis_f6: "26-språks støtte med automatisk deteksjon",
    pp_seo_name: "Komplett SEO-revisjon",
    pp_seo_tag: "Teknisk SEO-analyse med AI-drevne anbefalinger",
    pp_seo_desc: "Vår komplette SEO-revisjon analyserer 50+ rangeringsfaktorer inkludert teknisk SEO, innholds kvalitet, tilbakekoblinger, sidehastighet, mobiloptimalisering og AI-beredskap.",
    pp_seo_f1: "50+ rangeringsfaktorer analysert",
    pp_seo_f2: "Teknisk SEO-sjekker (meta-tagger, overskrifter, skjema)",
    pp_seo_f3: "Innholdskvalitets vurdering",
    pp_seo_f4: "Analyse av tilbakekoblingsprofil",
    pp_seo_f5: "Vurdering av Core Web Vitals",
    pp_seo_f6: "Tips for mobiloptimalisering",
    pp_seo_f7: "AI-beredskaps poeng",
    pp_seo_f8: "Nedlastbar PDF-rapport",
    pp_brand_name: "AI merkeovervåkning",
    pp_brand_tag: "24/7 overvåkning hvis AI-søkende motorer nevner ditt merke",
    pp_brand_f1: "24/7 overvåkning på 4 AI-motorer",
    pp_brand_f2: "Sanntids varsler om sitater via e-post",
    pp_brand_f3: "Sammenligning med konkurrenter",
    pp_brand_f4: "Historisk trendovervåkning med diagrammer",
    pp_brand_f5: "Analyse på forespørsel-nivå",
    pp_brand_f6: "Handlingsbare AI-optimaliseringsanbefalinger",
    pp_comp_name: "AI Konkurrent Spion",
    pp_comp_tag: "Sanntids konkurranseanalyse drevet av AI",
    pp_comp_f1: "Sanntids overvåkning av konkurrentenes SEO",
    pp_comp_f2: "Varsler om innholds endringer",
    pp_comp_f3: "Overvåkning av tilbakekoblingsanskaffelse",
    pp_comp_f4: "Sammenligning av AI-synlighet",
    pp_comp_f5: "Styrke/svakhet analyse",
    pp_comp_f6: "Mulighetsidentifisering",
    pp_comp_f7: "Prioritetsvarsler for høy-innflytelse endringer",
    pp_blog_name: "Blogg Agent",
    pp_blog_tag: "25 SEO-artikler med 4 tilbakekoblinger hver — skrevet av AI, publisert daglig",
    pp_blog_f1: "25 unike SEO-optimaliserte artikler",
    pp_blog_f2: "Publisert 1 per dag i 25 dager",
    pp_blog_f3: "4 dofollow tilbakekoblinger per artikkel",
    pp_blog_f4: "Automatisk oversatt til 26 språk",
    pp_blog_f5: "Tema forskning basert på din bransje",
    pp_blog_f6: "Langt innhold (1,500+ ord)",
    pp_blog_f7: "Intern lenkestruktur",
    pp_blog_f8: "Schema markup inkludert",
    pp_wp_name: "WordPress + WooCommerce-plugin",
    pp_wp_tag: "Gratis SEO-plugin med innebygd AI-synlighet overvåkning",
    pp_auto_name: "SEO Autopilot",
    pp_auto_tag: "AI fikser automatisk SEO-en din — ikke bare anbefalinger",
    pp_auto_desc: "SEO Autopilot sier ikke bare hva du må fikse — den fikser det for deg. Vår AI genererer automatisk optimaliserte metatitler, beskrivelser, bilde-alternativtekster, interne lenker og FAQ-seksjoner. Fungerer med WordPress og Shopify via våre plugins.",
    pp_auto_f1: "Auto-generere SEO metatitler & beskrivelser",
    pp_auto_f2: "Auto-generere bilde-alternativtekster",
    pp_auto_f3: "Smarte forslag til interne lenker",
    pp_auto_f4: "Generering av FAQ-seksjon med skjemaoppmerking",
    pp_auto_f5: "Oppdagelse av ødelagte lenker & omdirigeringsforslag",
    pp_auto_f6: "Automatiserte ukentlige skanninger",
    pp_auto_f7: "Integrasjon med WordPress & Shopify plugins",
    pp_auto_f8: "Overvåking av før/etter poeng",
    pp_sim_name: "AI Søkesimulator",
    pp_sim_tag: "Se hva ChatGPT, Perplexity & Gemini ville svart — gratis",
    pp_sim_desc: "AI Søkesimulator lar deg skrive inn et spørsmål og se simulerte svar fra ChatGPT, Perplexity, Gemini og Copilot. Finn ut om nettstedet ditt ville blitt nevnt i AI søkesultater.",
    pp_sim_f1: "Simulere AI søkesvar fra 4 motorer",
    pp_sim_f2: "Sjekk om nettstedet ditt blir omtalt",
    pp_sim_f3: "Test hvilket som helst nøkkelord eller spørsmål",
    pp_sim_f4: "Gratis ubegrensede forespørselene",
    pp_sim_f5: "Støtte for 26 språk",
    pp_blog_desc: "Blog Agent skriver 25 SEO-optimaliserte artikler for nettstedet ditt — en per dag i 25 dager. Hver artikkel inkluderer 4 dofollow-backlinks, blir automatisk oversatt til 26 språk og publisert etter planen.",
    pp_brand_desc: "AI Merkeovervåking sporer om ChatGPT, Perplexity, Gemini, og Copilot nevner merkevaren din når brukere stiller relevante spørsmål. Få sanntidsvarsler og sammenlign med konkurrenter.",
    pp_comp_desc: "AI Konkurransespion overvåker konkurrentenes SEO-strategier i sanntid. Få varsler når de publiserer nytt innhold, skaffer backlinks, eller forbedrer sin AI synlighetsscore.",
    pp_wp_desc: "Vår gratis WordPress-plugin bringer TopRankPulse direkte inn i WordPress-administrasjonen din. Få SEO-poeng, AI synlighetsovervåking, og ett-klikk fikser uten å forlate dashbordet ditt.",
    pp_wp_f1: "Ett-klikk SEO-fikser fra WordPress-admin",
    pp_wp_f2: "Innebygd AI synlighetsovervåking",
    pp_wp_f3: "SEO-optimalisering av WooCommerce-produkter",
    pp_wp_f4: "Automatiske skjemaoppmerkinger",
    pp_wp_f5: "Gratis for alltid for alle planer",
    pp_free_scan: "Gratis første skanning",
  },

  da: {
    pc_tag: "Stop med at betale for meget for SEO",
    pc_h1: "Erstat dyre SEO-byråer",
    pc_h1_highlight: "til prisen for en familiemiddag",
    pc_sub: "Du kan prøve det gratis og begynde at rangere i dag",
    pc_month: "måned",
    pc_best_value: "BEDSTE VÆRDI",
    pc_agency: "SEO Byrå",
    pc_ads_1: "Du har brug for et stort budget",
    pc_ads_2: "Manuel søgeordsforskning",
    pc_ads_3: "Optimeret til klik, ikke salg",
    pc_ads_4: "Lejet trafik",
    pc_ads_5: "Konkurrenter byder over dig",
    pc_ads_6: "Trafikken stopper, når du stopper med at bruge penge",
    pc_ads_7: "€0 i vedvarende resultater",
    pc_trp_1: "AI skriver kvalitetsindhold dagligt",
    pc_trp_2: "Automatisk søgeordsforskning",
    pc_trp_3: "Kvalitetsbacklinks inkluderet",
    pc_trp_4: "Ingen kontrakter - annuller når som helst",
    pc_trp_5: "Rangér én gang, få trafik for evigt",
    pc_trp_6: "Ingen teknisk viden nødvendig",
    pc_trp_7: "Bygget til at tiltrække købere, ikke tilfældig trafik",
    pc_cta: "START GRATIS PRØVEPERIODE",
    pc_ag_1: "Måneder for at se resultater",
    pc_ag_2: "Ugentlige møder",
    pc_ag_3: "Låst i kontrakter",
    pc_ag_4: "2 blogindlæg/måned for €2.300",
    pc_ag_5: "De ejer alt",
    pc_ag_6: "Trafik op 200%, Salg 0%",
    pc_ag_7: "Ingen AI synlighedsoptimering",
    pc_save_title: "Spar 20+ timer & €2.000+/måned",
    pc_save_sub: "Skift fra byråer eller Google Ads til TopRankPulse og behold flere penge i lommen.",
    pc_save_cta: "SE PLANER",
    bm_no_monitors: "Ingen mærker overvåget endnu",
    bm_no_monitors_desc: "Tilføj dit mærke for at begynde at spore, hvordan AI søgemaskiner ser dig.",
    bm_add_brand: "Tilføj Dit Mærke",
    bm_brand_name: "Mærkenavn",
    bm_website: "Hjemmeside URL",
    bm_industry: "Industri",
    bm_location: "Belægning",
    bm_competitors: "Konkurrenter",
    bm_comma: "kommasepareret",
    bm_start: "Start overvågning",
    bm_recheck: "Genkontrollér",
    bm_overall: "Overordnet AI Synlighed",
    bm_citation_score: "Citationsscore",
    bm_recommends: "Anbefaler",
    bm_not_cited: "Ikke citeret",
    bm_top_rec: "Topanbefaling",
    bm_query_analysis: "Forespørgselsanalyse",
    bm_last_checked: "Sidst kontroleret",
    bm_loading: "Analyserer AI synlighed...",
    bm_recommendations: "Sådan øger du din synlighed",
    bm_high: "Høj indflydelse",
    bm_medium: "Mellem",
    bm_low: "Lav",
    bm_vis_up: "Synlighed øget siden sidste kontrol",
    bm_vis_down: "Synlighed faldet siden sidste kontrol",
    attr_desc: "Se præcist hvor meget trafik og indtægt AI søgemaskiner bringer dig",
    attr_setup: "Opsætning af Attribution",
    attr_demo: "Demo data — installer tracking-pixlen for at se virkelige tal",
    attr_visits: "AI Besøg",
    attr_conversions: "Konverteringer",
    attr_revenue: "Indtægter",
    attr_conv_rate: "Konv. Rate",
    attr_traffic_30: "AI Trafik (30 Dage)",
    attr_by_source: "Trafik efter AI Kilde",
    attr_source_details: "Kildedetaljer",
    attr_visits_short: "besøg",
    attr_insights: "AI Indsigter",
    attr_pixel: "Tracking-pixel",
    attr_copied: "Kopieret",
    attr_copy: "Kopier",
    attr_pixel_desc: "Indsæt dette før </head> på din hjemmeside for at begynde at spore reel AI trafik.",
    attr_no_sites: "Ingen sider er endnu blevet sporet",
    attr_no_sites_desc: "Tilføj din hjemmeside for at se hvor meget trafik AI søgemaskiner bringer dig.",
    attr_add_website: "Tilføj din hjemmeside",
    ls_stat1: "sider usynlige for AI",
    ls_stat2: "gennemsnitlige besøg fra AI søgning",
    ls_stat3: "gratis revisionsresultater",
    ls_f1_t: "AI Synlighedsovervågning",
    ls_f1_d: "Tjek om ChatGPT, Perplexity & Gemini citerer din hjemmeside",
    ls_f2_t: "Fuldt SEO-revision",
    ls_f2_d: "Teknisk analyse med handlingsvenlige anbefalinger",
    ls_f3_t: "Stemmesøgning Score",
    ls_f3_d: "Optimér til Siri, Alexa, Google Assistant",
    ls_f4_t: "GEO Optimering",
    ls_f4_d: "Lokal SEO for",
    ls_f5_t: "Backlink Analyse",
    ls_f5_d: "Tjek dofollow, nofollow & domæneautoritet",
    ls_f6_t: "Hjemmeside Hastighed",
    ls_f6_d: "Core Web Vitals & præstationsscore",
    ls_more_cities: "Flere byer i",
    ls_top_cities: "Topbyer i",
    ls_cta_h1: "START DIN GRATIS",
    ls_cta_h2: "SEO REVISION",
    ls_cta_join: "Deltagende virksomheder i",
    ls_cta_using: "bruger TopRankPulse.",
    ls_scan: "SCAN DIN HJEMMESIDE",
    ls_free: "Gratis for altid",
    ls_no_card: "Ingen kreditkort",
    ls_langs: "26 sprog",
    pl_f1_t: "AI Synlighedssporing",
    pl_f1_d: "Se om ChatGPT, Perplexity & Gemini citerer din hjemmeside",
    pl_f2_t: "Fuldt SEO-revision",
    pl_f2_d: "Teknisk analyse med handlingsvenlige anbefalinger",
    pl_f3_t: "Søgeordsundersøgelse",
    pl_f3_d: "Find bedre søgeord med volumen, sværhedsgrad & tendenser",
    pl_f4_t: "Stemmesøgning Score",
    pl_f4_d: "Optimér til Siri, Alexa, Google Assistant",
    pl_f5_t: "AI Anbefalinger",
    pl_f5_d: "Trin-for-trin instruktioner for at forbedre din score",
    pl_f6_t: "Dashboard Widget",
    pl_f6_d: "SEO-score direkte i dit WordPress-dashboard",
    pl_f7_t: "Auto-Scan ved Udgivelse",
    pl_f7_d: "Analyserer automatisk nye indlæg når de udgives",
    pl_f8_t: "WooCommerce SEO",
    pl_f8_d: "Produkt SEO-score, AI beskrivelser & Google Shopping optimering",
    pl_f9_t: "Blog Agent (€25)",
    pl_f9_d: "25 SEO artikler med backlinks til din side",
    pl_s3_t: "Scan Din Side",
    pl_s3_d: "Klik på 'Scan nu' og få din SEO-score + AI synlighedsrapport på 30 sekunder.",
    pl_w1_t: "Produkt SEO Score",
    pl_w1_d: "Hvert produkt får en realtids SEO-score.",
    pl_w2_t: "AI Beskrivelsesgenerator",
    pl_w2_d: "AI-genererede SEO produktbeskrivelser med ét klik.",
    pl_w3_t: "Google Shopping Klar",
    pl_w3_d: "Forbedret produkt-schema markup til Google Shopping.",
    fear_warning: "ADVARSEL",
    fear_h1: "AI anbefaler brands",
    fear_h1_2: "der rangerer",
    fear_h1_highlight: "I DAG",
    fear_desc: "ChatGPT, Gemini og Perplexity henter svar fra top-rangerede sider. Hvis du ikke rangerer nu, vil AI anbefale dine konkurrenter - og det bliver kun sværere at indhente.",
    fear_m1_label: "Måned 1",
    fear_m1_title: "Din konkurrent publicerer indhold",
    fear_m1_desc: "Mens du venter, bygger de SEO-autoritet og bliver nævnt af AI-motorer.",
    fear_m3_label: "Måned 3",
    fear_m3_title: "AI begynder at anbefale dem",
    fear_m3_desc: "ChatGPT og Perplexity nævner nu dine konkurrenter som standard. Din trafik falder.",
    fear_m6_label: "Måned 6",
    fear_m6_title: "Du er usynlig. De ejer din niche.",
    fear_m6_desc: "AI-modeller styrker det, der allerede fungerer. At indhente nu koster 10x mere indsats og penge.",
    fear_urgency: "Hver dag du venter, mister du kunder",
    fear_cta_h: "Begynd at rangere før dine konkurrenter",
    fear_cta_sub: "De brands, der rangerer i dag, bliver de standard AI-anbefalinger i morgen. Sørg for at være en af dem.",
    fear_cta_btn: "BEGYND NU",
    pp_what_clients_say: "HVADE KUNDER SIGER",
    pp_start_trial: "Start Gratis Prøve",
    pp_download_plugin: "Download Plugin",
    pp_ready: "KLAR TIL",
    pp_start: "START",
    pp_join: "Bliv en del af tusindvis af virksomheder, der bruger TopRankPulse.",
    pp_ai_vis_name: "AI Synlighedsovervågning",
    pp_ai_vis_tag: "Se om ChatGPT, Perplexity & Gemini nævner dit website",
    pp_ai_vis_desc: "AI Synlighedsovervågning overvåger, om verdens førende AI-søgemaskiner — ChatGPT, Perplexity, Gemini og Copilot — nævner dit website, når brugere stiller relevante spørgsmål.",
    pp_ai_vis_f1: "Realtids citationsovervågning på tværs af 4 AI-motorer",
    pp_ai_vis_f2: "Ugentlige synlighedstrendrapporter",
    pp_ai_vis_f3: "Sammenligning af konkurrenters citationer",
    pp_ai_vis_f4: "Vurdering af stemmesøgningsklarhed",
    pp_ai_vis_f5: "AI-optimerede indholdsanbefalinger",
    pp_ai_vis_f6: "Støtte til 26 sprog med automatisk detektion",
    pp_seo_name: "Fuldendt SEO Revision",
    pp_seo_tag: "Teknisk SEO-analyse med AI-drevne anbefalinger",
    pp_seo_desc: "Vores Fuldendt SEO Revision analyserer 50+ ranking faktorer, herunder teknisk SEO, indholdskvalitet, backlinks, sidehastighed, mobiloptimering og AI-parathed.",
    pp_seo_f1: "50+ ranking faktorer analyseret",
    pp_seo_f2: "Tekniske SEO-tjek (meta tags, overskrifter, schema)",
    pp_seo_f3: "Vurdering af indholdskvalitet",
    pp_seo_f4: "Analyse af backlink-profil",
    pp_seo_f5: "Vurdering af Core Web Vitals",
    pp_seo_f6: "Tips til mobil-first optimering",
    pp_seo_f7: "AI-parathed score",
    pp_seo_f8: "Downloadbar PDF-rapport",
    pp_brand_name: "AI Brand Overvågning",
    pp_brand_tag: "24/7 overvågning hvis AI søgemaskiner nævner dit brand",
    pp_brand_f1: "24/7 overvågning på 4 AI-motorer",
    pp_brand_f2: "Realtid citation alarmer via email",
    pp_brand_f3: "Sammenligning med konkurrenter",
    pp_brand_f4: "Historisk trendovervågning med diagrammer",
    pp_brand_f5: "Analyse på forespørgselsniveau",
    pp_brand_f6: "Handlingsbare AI optimeringsanbefalinger",
    pp_comp_name: "AI Konkurrent Spy",
    pp_comp_tag: "Realtids konkurrenceanalyse drevet af AI",
    pp_comp_f1: "Realtids SEO overvågning af konkurrenter",
    pp_comp_f2: "Alarmer om indholdsændringer",
    pp_comp_f3: "Overvågning af backlink erhvervelse",
    pp_comp_f4: "AI synlighed sammenligning",
    pp_comp_f5: "Styrke/svaghed analyse",
    pp_comp_f6: "Identifikation af muligheder",
    pp_comp_f7: "Prioriteringsalarmer for høj-impakt ændringer",
    pp_blog_name: "Blog Agent",
    pp_blog_tag: "25 SEO-artikler med 4 backlinks hver — skrevet af AI, offentliggjort dagligt",
    pp_blog_f1: "25 unikke SEO-optimerede artikler",
    pp_blog_f2: "Offentliggjort 1 om dagen i 25 dage",
    pp_blog_f3: "4 dofollow backlinks pr. artikel",
    pp_blog_f4: "Automatisk oversat til 26 sprog",
    pp_blog_f5: "Emneundersøgelse baseret på din branche",
    pp_blog_f6: "Langt indhold (1.500+ ord)",
    pp_blog_f7: "Intern linking struktur",
    pp_blog_f8: "Schema markup inkluderet",
    pp_wp_name: "WordPress + WooCommerce Plugin",
    pp_wp_tag: "Gratis SEO-plugin med indbygget AI synlighedsovervågning",
    pp_auto_name: "SEO Autopilot",
    pp_auto_tag: "AI retter automatisk dit SEO — ikke kun anbefalinger",
    pp_auto_desc: "SEO Autopilot fortæller ikke kun, hvad du skal rette — den gør det for dig. Vores AI genererer automatisk optimerede metatitler, beskrivelser, billedalttekster, interne links og FAQ-sektioner. Virker med WordPress og Shopify via vores plugins.",
    pp_auto_f1: "Auto-generer SEO metatitler & beskrivelser",
    pp_auto_f2: "Auto-generer billedalttekster",
    pp_auto_f3: "Smukke forslag til intern linking",
    pp_auto_f4: "Generering af FAQ-sektion med schema markup",
    pp_auto_f5: "Opdagelse af brudte links & omdirigeringsforslag",
    pp_auto_f6: "Ugentlige automatiserede scanninger",
    pp_auto_f7: "WordPress & Shopify plugin integration",
    pp_auto_f8: "Før/efter score tracking",
    pp_sim_name: "AI Søgning Simulator",
    pp_sim_tag: "Se hvad ChatGPT, Perplexity & Gemini ville svare — gratis",
    pp_sim_desc: "AI Søgning Simulator lader dig skrive ethvert spørgsmål og se simulerede svar fra ChatGPT, Perplexity, Gemini og Copilot. Find ud af, om din hjemmeside ville blive nævnt i AI søgeresultater.",
    pp_sim_f1: "Simulator AI søgesvar fra 4 motorer",
    pp_sim_f2: "Tjek om din hjemmeside bliver omtalt",
    pp_sim_f3: "Test ethvert nøgleord eller spørgsmål",
    pp_sim_f4: "Gratis ubegrænsede forespørgsler",
    pp_sim_f5: "Understøttelse af 26 sprog",
    pp_blog_desc: "Blog Agent skriver 25 SEO-optimerede artikler til din hjemmeside — en per dag i 25 dage. Hver artikel inkluderer 4 dofollow backlinks, bliver auto-oversat til 26 sprog og offentliggjort efter planen.",
    pp_brand_desc: "AI Brand Monitoring sporer, om ChatGPT, Perplexity, Gemini og Copilot nævner dit brand, når brugere stiller relevante spørgsmål. Få realtidsalarmer og benchmark imod konkurrenter.",
    pp_comp_desc: "AI Competitor Spy overvåger dine konkurrenters SEO-strategier i realtid. Få alarmer, når de udgiver nyt indhold, skaffer backlinks eller forbedrer deres AI synlighedsscore.",
    pp_wp_desc: "Vores gratis WordPress-plugin bringer TopRankPulse direkte ind i din WordPress-admin. Få SEO-scores, AI synlighed tracking og one-click fixes uden at forlade dit dashboard.",
    pp_wp_f1: "One-click SEO fixes fra WordPress admin",
    pp_wp_f2: "AI synlighed tracking indbygget",
    pp_wp_f3: "WooCommerce produkt SEO optimering",
    pp_wp_f4: "Automatisk schema markup",
    pp_wp_f5: "Gratis for altid for alle planer",
    pp_free_scan: "Gratis første scan",
  },

  fi: {
    pc_tag: "Lopeta maksamasta liikaa SEO:sta",
    pc_h1: "Korvaa kalliit SEO-toimistot",
    pc_h1_highlight: "perheen illallisen hinnalla",
    pc_sub: "Voit kokeilla sitä ilmaiseksi ja aloittaa rankingin tänään",
    pc_month: "kuukausi",
    pc_best_value: "PARAS ARVO",
    pc_agency: "SEO-toimisto",
    pc_ads_1: "Tarvitset suuren budjetin",
    pc_ads_2: "Manuaalinen avainsanatutkimus",
    pc_ads_3: "Optimoitu klikkauksille, ei myynnille",
    pc_ads_4: "Vuokratut liikenteet",
    pc_ads_5: "Kilpailijat tarjoavat enemmän",
    pc_ads_6: "Liikenne loppuu, kun lopetat kuluttamisen",
    pc_ads_7: "€0 kestävistä tuloksista",
    pc_trp_1: "AI kirjoittaa laadukasta päivittäistä sisältöä",
    pc_trp_2: "Automaattinen avainsanatutkimus",
    pc_trp_3: "Laadukkaat takalinkit mukana",
    pc_trp_4: "Ei sopimuksia - voit peruuttaa milloin vain",
    pc_trp_5: "Ranking kerran, saa liikennettä ikuisesti",
    pc_trp_6: "Ei teknistä osaamista tarvita",
    pc_trp_7: "Rakennettu tuomaan ostajia, ei satunnaista liikennettä",
    pc_cta: "ALOITA ILMAINEN KOE",
    pc_ag_1: "Kuutta tulosten näkemiseen",
    pc_ag_2: "Viikoittaiset kokoukset",
    pc_ag_3: "Sopimuksiin lukittu",
    pc_ag_4: "2 blogikirjoitusta/kuukausi hintaan €2,300",
    pc_ag_5: "He omistavat kaiken",
    pc_ag_6: "Liikenne nousi 200%, Myynnit 0%",
    pc_ag_7: "Ei AI-näkyvyyden optimointia",
    pc_save_title: "Säästä 20+ tuntia & yli €2,000/kuukausi",
    pc_save_sub: "Siirry toimistoista tai Google Adsista TopRankPulseen ja pidä enemmän rahaa taskussasi.",
    pc_save_cta: "NÄE SUUNNITELMAT",
    bm_no_monitors: "Ei Brandeja Seurattavana Vielä",
    bm_no_monitors_desc: "Lisää brändisi aloittaaksesi seurannan siitä, miten AI-hakukoneet näkevät sinut.",
    bm_add_brand: "Lisää Brändisi",
    bm_brand_name: "Brändin Nimi",
    bm_website: "Verkkosivuston URL",
    bm_industry: "Teollisuus",
    bm_location: "Sijainti",
    bm_competitors: "Kilpailijat",
    bm_comma: "pilkulla erotettu",
    bm_start: "Aloita seuranta",
    bm_recheck: "Tarkista uudelleen",
    bm_overall: "Kokonais AI-näkyvyys",
    bm_citation_score: "Viittauspisteet",
    bm_recommends: "Suositukset",
    bm_not_cited: "Ei viitattu",
    bm_top_rec: "Parhaat suositukset",
    bm_query_analysis: "Hakukyselyn analyysi",
    bm_last_checked: "Viimeksi tarkistettu",
    bm_loading: "Analysoidaan AI-näkyvyyttä...",
    bm_recommendations: "Kuinka lisätä näkyvyyttäsi",
    bm_high: "Korkea vaikuttavuus",
    bm_medium: "Keskitaso",
    bm_low: "Matala",
    bm_vis_up: "Näkyvyys kasvoi viime tarkistuksesta",
    bm_vis_down: "Näkyvyys laski viime tarkistuksesta",
    attr_desc: "Näet tarkalleen, kuinka paljon liikennettä ja tuloja AI-hakukoneet tuovat sinulle",
    attr_setup: "Aseta attribuutio",
    attr_demo: "Demo-data — asenna seurantapikseli nähdäksesi todelliset lukemat",
    attr_visits: "AI-vierailut",
    attr_conversions: "Muutokset",
    attr_revenue: "Tulot",
    attr_conv_rate: "Muutosprosentti",
    attr_traffic_30: "AI-liikenne (30 päivää)",
    attr_by_source: "Liikenne AI-lähteen mukaan",
    attr_source_details: "Lähteen tiedot",
    attr_visits_short: "vierailut",
    attr_insights: "AI-näkyvyys",
    attr_pixel: "Seurantapikseli",
    attr_copied: "Kopioitu",
    attr_copy: "Kopioi",
    attr_pixel_desc: "Liitä tämä ennen </head> verkkosivustollasi aloittaaksesi todellisen AI-liikenteen seurannan.",
    attr_no_sites: "Ei verkkosivustoja seurattu vielä",
    attr_no_sites_desc: "Lisää verkkosivustosi nähdäksesi, kuinka paljon liikennettä AI-hakukoneet tuovat sinulle.",
    attr_add_website: "Lisää verkkosivustosi",
    ls_stat1: "sivustot näkymättömänä AI:lle",
    ls_stat2: "keskimääräiset vierailut AI-hausta",
    ls_stat3: "ilmaiset auditointitulokset",
    ls_f1_t: "AI-näkyvyyden seuranta",
    ls_f1_d: "Tarkista, viittaavatko ChatGPT, Perplexity ja Gemini verkkosivustollesi",
    ls_f2_t: "Kokonaisvaltainen SEO-tarkastus",
    ls_f2_d: "Tekninen analyysi toiminnallisilla suosituksilla",
    ls_f3_t: "Äänihakuindeksi",
    ls_f3_d: "Optimoi Sirille, Alexalle, Google Assistantille",
    ls_f4_t: "GEO-optimointi",
    ls_f4_d: "Paikallinen SEO kohteelle",
    ls_f5_t: "Taustalinkkien analyysi",
    ls_f5_d: "Tarkista dofollow, nofollow ja domainin auktoriteetti",
    ls_f6_t: "Sivuston nopeus",
    ls_f6_d: "Core Web Vitals ja suorituskykyarvio",
    ls_more_cities: "Lisää kaupunkeja kohteessa",
    ls_top_cities: "Parhaat kaupungit kohteessa",
    ls_cta_h1: "ALOITA ILMAINEN",
    ls_cta_h2: "SEO-TARKASTUS",
    ls_cta_join: "Liity yrityksiin kohteessa",
    ls_cta_using: "käyttäen TopRankPulsea.",
    ls_scan: "SKANNAA VERKKOSIVUSTOSI",
    ls_free: "Ilmainen ikuisesti",
    ls_no_card: "Ei luottokorttia",
    ls_langs: "26 kieltä",
    pl_f1_t: "AI-näkyvyyden seuranta",
    pl_f1_d: "Katso, viittaavatko ChatGPT, Perplexity ja Gemini verkkosivustollesi",
    pl_f2_t: "Kokonaisvaltainen SEO-tarkastus",
    pl_f2_d: "Tekninen analyysi toiminnallisilla suosituksilla",
    pl_f3_t: "Avainsanatutkimus",
    pl_f3_d: "Löydä parempia avainsanoja volyymilla, vaikeudella ja trendeillä",
    pl_f4_t: "Äänihakuindeksi",
    pl_f4_d: "Optimoi Sirille, Alexalle, Google Assistantille",
    pl_f5_t: "AI-suositukset",
    pl_f5_d: "Askel askeleelta ohjeet tuloksesi parantamiseen",
    pl_f6_t: "Ohjauspaneeli-widget",
    pl_f6_d: "SEO-tulos suoraan WordPress-ohjauspaneelissasi",
    pl_f7_t: "Automaattinen skannaus julkaisemisen yhteydessä",
    pl_f7_d: "Analysoi automaattisesti uudet julkaisut, kun ne julkaistaan",
    pl_f8_t: "WooCommerce SEO",
    pl_f8_d: "Tuotteen SEO-pisteet, AI-kuvaukset ja Google Shopping -optimointi",
    pl_f9_t: "Blogiagentti (€25)",
    pl_f9_d: "25 SEO-artikkelia taustalinkkien kanssa verkkosivustollesi",
    pl_s3_t: "Skannaa sivustosi",
    pl_s3_d: "Napsauta 'Skannaa nyt' ja saat SEO-pisteesi + AI-näkyvyysraportin 30 sekunnissa.",
    pl_w1_t: "Tuotteen SEO-pisteet",
    pl_w1_d: "Jokaiselle tuotteelle annetaan reaaliaikainen SEO-piste.",
    pl_w2_t: "AI-kuvausgeneroija",
    pl_w2_d: "Yhden napsautuksen AI:lla generoituja SEO-tuotekuvauksia.",
    pl_w3_t: "Google Shopping -valmis",
    pl_w3_d: "Parannettu tuotteen skeema-merkintä Google Shoppingille.",
    fear_warning: "VAROITUS",
    fear_h1: "AI suosittelee brändejä",
    fear_h1_2: "jotka sijoittuvat",
    fear_h1_highlight: "TÄNÄÄN",
    fear_desc: "ChatGPT, Gemini ja Perplexity löytävät vastauksia korkealle sijoittuvilta sivuilta. Jos et ole nyt sijoilla, AI suosittelee kilpailijoitasi — ja se vain vaikeutuu.",
    fear_m1_label: "Kuukausi 1",
    fear_m1_title: "Kilpailijasi julkaisee sisältöä",
    fear_m1_desc: "Kun odotat, he rakentavat SEO-autoriteettia ja saavat mainintoja AI-moottoreilta.",
    fear_m3_label: "Kuukausi 3",
    fear_m3_title: "AI alkaa suositella heitä",
    fear_m3_desc: "ChatGPT ja Perplexity viittaavat nyt automaattisesti kilpailijoihisi. Liikenteesi laskee.",
    fear_m6_label: "Kuukausi 6",
    fear_m6_title: "Olet näkymätön. He hallitsevat aluettasi.",
    fear_m6_desc: "AI-mallit vahvistavat sitä, mikä jo toimii. Jälkijunassa pysyminen maksaa nyt 10 kertaa enemmän vaivannetta ja rahaa.",
    fear_urgency: "Jokainen päivä, jonka odotat, menetät asiakkaita",
    fear_cta_h: "Aloita sijoittaminen ennen kilpailijoitasi",
    fear_cta_sub: "Ne brändit, jotka sijoittuvat tänään, ovat huomisen oletus AI-suosituksia. Varmista, että se olet sinä.",
    fear_cta_btn: "ALOITA NYT",
    pp_what_clients_say: "MITÄ ASIAKKAAT SANOVAT",
    pp_start_trial: "Aloita ilmainen kokeilu",
    pp_download_plugin: "Lataa liitännäinen",
    pp_ready: "VALMIS",
    pp_start: "ALOITA",
    pp_join: "Liity tuhansien TopRankPulsea käyttävien yritysten joukkoon.",
    pp_ai_vis_name: "AI-näkyvyyden seuranta",
    pp_ai_vis_tag: "Katso, viittaavatko ChatGPT, Perplexity ja Gemini verkkosivustollesi",
    pp_ai_vis_desc: "AI-näkyvyyden seuranta seuraa, mainitsevatko maailman johtavat AI-hakukoneet — ChatGPT, Perplexity, Gemini ja Copilot — verkkosivustosi, kun käyttäjät esittävät asiaankuuluvia kysymyksiä.",
    pp_ai_vis_f1: "Reaaliaikainen viittauseuranta 4 AI-moottorissa",
    pp_ai_vis_f2: "Viikoittaiset näkyvyysrapportit",
    pp_ai_vis_f3: "Kilpailijoiden viittauksen vertailu",
    pp_ai_vis_f4: "Äänihakuvalmiuspisteet",
    pp_ai_vis_f5: "AI-optimoidut sisällönsuositukset",
    pp_ai_vis_f6: "26-kielen tuki automaattisella havaitsemisella",
    pp_seo_name: "Kattava SEO-auditointi",
    pp_seo_tag: "Tekninen SEO-analyysi AI-pohjaisilla suosituksilla",
    pp_seo_desc: "Kattava SEO-auditointimme analysoi yli 50 sijoitustekijää, mukaan lukien tekninen SEO, sisällön laatu, takaisinlinkit, sivun latausnopeus, mobiilioptimointi ja AI-valmius.",
    pp_seo_f1: "Yli 50 analysoitua sijoitustekijää",
    pp_seo_f2: "Teknisen SEO:n tarkastukset (meta-tägit, otsikot, schema)",
    pp_seo_f3: "Sisällön laadun arviointi",
    pp_seo_f4: "Takaisinlinkkiprofiilin analyysi",
    pp_seo_f5: "Core Web Vitals -arviointi",
    pp_seo_f6: "Mobiiliensimmäiset optimointivinkit",
    pp_seo_f7: "AI-valmiuspisteet",
    pp_seo_f8: "Ladattava PDF-raportti",
    pp_brand_name: "AI-brändin seuranta",
    pp_brand_tag: "24/7 seuranta, jos AI-hakukoneet mainitsevat brändisi",
    pp_brand_f1: "24/7 seuranta 4 AI-moottorissa",
    pp_brand_f2: "Reaaliaikaiset viittausilmoitukset sähköpostitse",
    pp_brand_f3: "Kilpailija vertailu",
    pp_brand_f4: "Historiallinen trendin seuranta kaavioilla",
    pp_brand_f5: "Kysyntäkohtainen analyysi",
    pp_brand_f6: "Toiminnallisia AI-optimointisuosituksia",
    pp_comp_name: "AI Kilpailija Vakoilija",
    pp_comp_tag: "Reaaliaikainen kilpailija-analyysi AI:n avulla",
    pp_comp_f1: "Reaaliaikainen kilpailijoiden SEO-seuranta",
    pp_comp_f2: "Sisällön muutosten ilmoitukset",
    pp_comp_f3: "Takaisinlinkkien hankinnan seuranta",
    pp_comp_f4: "AI-näkyvyyden vertailu",
    pp_comp_f5: "Vahvuus/heikkousanalyysi",
    pp_comp_f6: "Mahdollisuuksien tunnistaminen",
    pp_comp_f7: "Prioriteetti-ilmoitukset merkittävistä muutoksista",
    pp_blog_name: "Blogiagentti",
    pp_blog_tag: "25 SEO-artikkelia, joissa jokaisessa 4 takaisinlinkkiä - kirjoitettu AI:n avulla, julkaistaan päivittäin",
    pp_blog_f1: "25 ainutlaatuista SEO-optimoitua artikkelia",
    pp_blog_f2: "Julkaistu 1 päivässä 25 päivän ajan",
    pp_blog_f3: "4 dofollow-takaisinlinkkiä per artikkeli",
    pp_blog_f4: "Automaattisesti käännetty 26 kielelle",
    pp_blog_f5: "Aihetutkimus, joka perustuu toimialaasi",
    pp_blog_f6: "Pitkä muotoinen sisältö (yli 1,500 sanaa)",
    pp_blog_f7: "Sisäisten linkkien rakenne",
    pp_blog_f8: "Schema-merkintä mukana",
    pp_wp_name: "WordPress + WooCommerce -lisäosa",
    pp_wp_tag: "Ilmainen SEO-lisäosa, jossa on AI-näkyvyyden seuranta integroitu",
    pp_auto_name: "SEO Autopilotti",
    pp_auto_tag: "AI korjaa SEO:si automaattisesti — ei vain suosituksia",
    pp_auto_desc: "SEO Autopilotti ei vain kerro, mitä sinun pitäisi korjata — se korjaa sen puolestasi. AI meidän järjestelmässämme luo automaattisesti optimoituja metanimiä, kuvauksia, kuvien alt-tekstejä, sisäisiä linkkejä ja usein kysyttyjä kysymyksiä. Toimii WordPressin ja Shopifyn kanssa liitännäistemme avulla.",
    pp_auto_f1: "Automaattisesti luodut SEO metaotsikot & kuvaukset",
    pp_auto_f2: "Automaattisesti luodut kuvien alt-tekstit",
    pp_auto_f3: "Älykkäitä sisäisten linkkien ehdotuksia",
    pp_auto_f4: "Usein kysyttyjen kysymysten osio schema-merkinnöillä",
    pp_auto_f5: "Vaikeiden linkkien tunnistus & uudelleenohjaus ehdotukset",
    pp_auto_f6: "Viikoittaiset automatisoidut tarkistukset",
    pp_auto_f7: "WordPress & Shopify liitännäistekniikka",
    pp_auto_f8: "Ennen/jälkeen pisteiden seuranta",
    pp_sim_name: "AI Hakusimulaattori",
    pp_sim_tag: "Näe, mitä ChatGPT, Perplexity & Gemini vastaisivat — ilmaiseksi",
    pp_sim_desc: "AI Hakusimulaattori antaa sinun kirjoittaa kysymyksen ja nähdä simuloituja vastauksia ChatGPT:ltä, Perplexityltä, Geminiltä ja Copilotilta. Selviä, mainitaanko verkkosivustosi AI hakutuloksissa.",
    pp_sim_f1: "Simuloi AI hakuvastauksia 4 moottorista",
    pp_sim_f2: "Tarkista, mainitaanko verkkosivustosi",
    pp_sim_f3: "Testaa mitä tahansa avainsanaa tai kysymystä",
    pp_sim_f4: "Ilmaiset rajattomat kyselyt",
    pp_sim_f5: "26-kielen tuki",
    pp_blog_desc: "Blogi Agentti kirjoittaa 25 SEO-optimoitua artikkelia verkkosivustollesi — yksi päivässä 25 päivän ajan. Jokainen artikkeli sisältää 4 dofollow-taustalinkkiä, käännetään automaattisesti 26 kielelle ja julkaistaan aikataulun mukaan.",
    pp_brand_desc: "AI Brändin Seuranta seuraa, mainitaanko ChatGPT, Perplexity, Gemini ja Copilot brändisi, kun käyttäjät kysyvät asiaankuuluvia kysymyksiä. Saat reaaliaikaisia hälytyksiä ja voit verrata kilpailijoihisi.",
    pp_comp_desc: "AI Kilpailija Vakooja valvoo kilpailijasi SEO-strategioita reaaliajassa. Saat hälytyksiä, kun he julkaisevat uutta sisältöä, hankkivat taustalinkkejä tai parantavat AI näkyvyysarvoaan.",
    pp_wp_desc: "Ilmainen WordPress-liitännäinen tuo TopRankPulse:n suoraan WordPress-hallintaasi. Saat SEO-pisteet, AI näkyvyyden seurannan ja yhden napsautuksen korjaukset ilman, että sinun tarvitsee poistua ohjauspaneelista.",
    pp_wp_f1: "Yhden napsautuksen SEO-korjaukset WordPress-hallinnasta",
    pp_wp_f2: "Sisäänrakennettu AI näkyvyyden seuranta",
    pp_wp_f3: "WooCommerce-tuotteen SEO-optimointi",
    pp_wp_f4: "Automaattinen schema-merkintä",
    pp_wp_f5: "Ilmainen ikuisesti kaikilla suunnitelmilla",
    pp_free_scan: "Ilmainen ensimmäinen skannaus",
  },

  bg: {
    pc_tag: "Спри да плащаш прекалено много за SEO",
    pc_h1: "Смени скъпите SEO агенции",
    pc_h1_highlight: "за цената на семейна вечеря",
    pc_sub: "Можеш да пробваш безплатно и да започнеш да се подреждаш днес",
    pc_month: "месец",
    pc_best_value: "НАЙ-ДОБРА ЦЕНА",
    pc_agency: "SEO Агенция",
    pc_ads_1: "Нужен ти е голям бюджет",
    pc_ads_2: "Ръчно проучване на ключови думи",
    pc_ads_3: "Оптимизирано за кликвания, не за продажби",
    pc_ads_4: "Наеман трафик",
    pc_ads_5: "Конкурентите те надхвърлят",
    pc_ads_6: "Трафикът спира, когато спреш да харчиш",
    pc_ads_7: "€0 дълготрайни резултати",
    pc_trp_1: "AI пише качествено съдържание ежедневно",
    pc_trp_2: "Автоматично проучване на ключови думи",
    pc_trp_3: "Качествени обратни връзки включени",
    pc_trp_4: "Без договори — анулирай по всяко време",
    pc_trp_5: "Резултатите веднъж подредени, трафик завинаги",
    pc_trp_6: "Не се нуждаеш от технически знания",
    pc_trp_7: "Създадено, за да привлече купувачи, не случайни трафики",
    pc_cta: "ЗАПОЧНИ БЕЗПЛАТЕН ПРЕБИВАНЕ",
    pc_ag_1: "Месеци, за да видиш резултати",
    pc_ag_2: "Седмични срещи",
    pc_ag_3: "Заключен в договори",
    pc_ag_4: "2 блога на месец за €2,300",
    pc_ag_5: "Те притежават всичко",
    pc_ag_6: "Трафик нагоре с 200%, Продажби 0%",
    pc_ag_7: "Няма оптимизация за видимост на AI",
    pc_save_title: "Запази 20+ часа и €2,000+/месец",
    pc_save_sub: "Премини от агенции или Google Ads към TopRankPulse и запази повече пари в джоба си.",
    pc_save_cta: "ВИДИ ПЛАНОВЕ",
    bm_no_monitors: "Все още няма наблюдавани марки",
    bm_no_monitors_desc: "Добави своята марка, за да започнеш да следиш как те виждат AI търсещи машини.",
    bm_add_brand: "Добави своята марка",
    bm_brand_name: "Име на марката",
    bm_website: "URL на уебсайта",
    bm_industry: "Индустрия",
    bm_location: "Локация",
    bm_competitors: "Конкуренти",
    bm_comma: "разделени с запетаи",
    bm_start: "Започни наблюдение",
    bm_recheck: "Проверка отново",
    bm_overall: "Обща AI видимост",
    bm_citation_score: "Оценка за цитиране",
    bm_recommends: "Препоръчва",
    bm_not_cited: "Не е цитирано",
    bm_top_rec: "Най-добра препоръка",
    bm_query_analysis: "Анализ на запитванията",
    bm_last_checked: "Последна проверка",
    bm_loading: "Анализиране на AI видимостта...",
    bm_recommendations: "Как да увеличите видимостта си",
    bm_high: "Висок удар",
    bm_medium: "Среден",
    bm_low: "Нисък",
    bm_vis_up: "Видимостта се е увеличила от последната проверка",
    bm_vis_down: "Видимостта е намаляла от последната проверка",
    attr_desc: "Вижте точно колко трафик и приходи ви носят AI търсачките",
    attr_setup: "Настройка на атрибуцията",
    attr_demo: "Демоданни — инсталирайте проследяващия пиксел, за да видите реални числа",
    attr_visits: "AI посещения",
    attr_conversions: "Конверсии",
    attr_revenue: "Приходи",
    attr_conv_rate: "Конв. ставка",
    attr_traffic_30: "AI трафик (30 дни)",
    attr_by_source: "Трафик по AI източник",
    attr_source_details: "Детайли за източника",
    attr_visits_short: "посещения",
    attr_insights: "AI прозрения",
    attr_pixel: "Проследяващ пиксел",
    attr_copied: "Копирано",
    attr_copy: "Копирай",
    attr_pixel_desc: "Поставете това преди </head> на вашия сайт, за да започнете да проследявате реален AI трафик.",
    attr_no_sites: "Все още няма проследявани сайтове",
    attr_no_sites_desc: "Добавете вашия сайт, за да видите колко трафик ви носят AI търсачките.",
    attr_add_website: "Добавете вашия сайт",
    ls_stat1: "сайтове невидими за AI",
    ls_stat2: "среден брой посещения от AI търсения",
    ls_stat3: "резултати от безплатен одит",
    ls_f1_t: "Проследяване на AI видимост",
    ls_f1_d: "Проверете дали ChatGPT, Perplexity и Gemini цитират вашия уебсайт",
    ls_f2_t: "Пълен SEO одит",
    ls_f2_d: "Технически анализ с приложими препоръки",
    ls_f3_t: "Оценка на гласово търсене",
    ls_f3_d: "Оптимизирайте за Siri, Alexa, Google Assistant",
    ls_f4_t: "GEO оптимизация",
    ls_f4_d: "Локален SEO за",
    ls_f5_t: "Анализ на обратни връзки",
    ls_f5_d: "Проверете dofollow, nofollow и авторитета на домейна",
    ls_f6_t: "Скорост на сайта",
    ls_f6_d: "Основни уеб показатели и резултат за производителност",
    ls_more_cities: "Повече градове в",
    ls_top_cities: "Топ градове в",
    ls_cta_h1: "НАЧАЛО ВАШИЯ БЕЗПЛАТЕН",
    ls_cta_h2: "SEO ОДИТ",
    ls_cta_join: "Присъединете се към бизнеса в",
    ls_cta_using: "използвайки TopRankPulse.",
    ls_scan: "СКАНИРАЙТЕ ВАШИЯ УЕБСАЙТ",
    ls_free: "Безплатно завинаги",
    ls_no_card: "Без кредитна карта",
    ls_langs: "26 езика",
    pl_f1_t: "Проследяване на AI видимост",
    pl_f1_d: "Вижте дали ChatGPT, Perplexity и Gemini цитират вашия уебсайт",
    pl_f2_t: "Пълен SEO одит",
    pl_f2_d: "Технически анализ с приложими препоръки",
    pl_f3_t: "Проучване на ключови думи",
    pl_f3_d: "Намерете по-добри ключови думи с обем, трудност и тенденции",
    pl_f4_t: "Оценка на гласово търсене",
    pl_f4_d: "Оптимизирайте за Siri, Alexa, Google Assistant",
    pl_f5_t: "AI препоръки",
    pl_f5_d: "Стъпка по стъпка инструкции за подобряване на вашия резултат",
    pl_f6_t: "Уиджет на таблото",
    pl_f6_d: "SEO оценка директно в таблото на вашия WordPress",
    pl_f7_t: "Авто-сканиране при публикуване",
    pl_f7_d: "Автоматично анализира нови постове при публикуване",
    pl_f8_t: "WooCommerce SEO",
    pl_f8_d: "SEO оценки на продукти, AI описания и оптимизация за Google Shopping",
    pl_f9_t: "Блог агент (€25)",
    pl_f9_d: "25 SEO статии с обратни връзки към вашия сайт",
    pl_s3_t: "Сканирайте сайта си",
    pl_s3_d: "Натиснете „Сканирай сега“ и получете оценка за SEO + отчет за видимост в AI за 30 секунди.",
    pl_w1_t: "Оценка на продукта за SEO",
    pl_w1_d: "Всеки продукт получава оценка за SEO в реално време.",
    pl_w2_t: "Генератор на AI описания",
    pl_w2_d: "С описания на продукти, генерирани с един клик от AI.",
    pl_w3_t: "Готов за Google Shopping",
    pl_w3_d: "Подобрена схема за маркиране на продукти за Google Shopping.",
    fear_warning: "ПРЕДУПРЕЖДЕНИЕ",
    fear_h1: "AI препоръчва марки",
    fear_h1_2: "които се класират",
    fear_h1_highlight: "ДНЕС",
    fear_desc: "ChatGPT, Gemini и Perplexity извличат отговори от страници с висока класация. Ако не се класирате сега, AI ще препоръча вашите конкуренти — и става все по-трудно да наваксате.",
    fear_m1_label: "Месец 1",
    fear_m1_title: "Вашият конкурент публикува съдържание",
    fear_m1_desc: "Докато вие чакате, те изграждат SEO авторитет и биват цитиран от AI двигатели.",
    fear_m3_label: "Месец 3",
    fear_m3_title: "AI започва да препоръчва тях",
    fear_m3_desc: "ChatGPT и Perplexity сега цитират вашите конкуренти по подразбиране. Вашият трафик спада.",
    fear_m6_label: "Месец 6",
    fear_m6_title: "Вие сте невидими. Те владеят вашата ниша.",
    fear_m6_desc: "AI моделите подсилват това, което вече работи. Наваксването сега струва 10 пъти повече усилия и средства.",
    fear_urgency: "Всеки ден, в който чакате, губите клиенти",
    fear_cta_h: "Започнете да се класирате преди вашите конкуренти",
    fear_cta_sub: "Брандовете, които се класират днес, стават подразбиращи се AI препоръки утре. Убедете се, че това сте вие.",
    fear_cta_btn: "НАЧАЛО СЕГА",
    pp_what_clients_say: "КАКВО КАЗВАТ КЛИЕНТИТЕ",
    pp_start_trial: "Започнете безплатен пробен период",
    pp_download_plugin: "Изтеглете плъгин",
    pp_ready: "ГОТОВ ЗА",
    pp_start: "ЗАПОЧНЕТЕ",
    pp_join: "Присъединете се към хиляди бизнеси, използващи TopRankPulse.",
    pp_ai_vis_name: "Проследяване на видимостта на AI",
    pp_ai_vis_tag: "Вижте дали ChatGPT, Perplexity и Gemini цитират вашия уебсайт",
    pp_ai_vis_desc: "Проследяването на видимостта на AI наблюдава дали водещите AI търсачки в света — ChatGPT, Perplexity, Gemini и Copilot — споменават вашия уебсайт, когато потребителите задават релевантни въпроси.",
    pp_ai_vis_f1: "Наблюдение на цитирането в реално време през 4 AI двигателя",
    pp_ai_vis_f2: "Седмични отчети за тенденции във видимостта",
    pp_ai_vis_f3: "Сравнение на цитиранията на конкурентите",
    pp_ai_vis_f4: "Оценка на готовността за гласово търсене",
    pp_ai_vis_f5: "Препоръки за съдържание, оптимизирани за AI",
    pp_ai_vis_f6: "Подкрепа за 26 езика с авторазпознаване",
    pp_seo_name: "Пълен SEO одит",
    pp_seo_tag: "Технически SEO анализ с AI-базирани препоръки",
    pp_seo_desc: "Нашият пълен SEO одит анализира 50+ фактора за класиране, включително технически SEO, качество на съдържанието, обратни връзки, скорост на страницата, мобилна оптимизация и готовност за AI.",
    pp_seo_f1: "Анализирани 50+ фактора за класиране",
    pp_seo_f2: "Проверки на техническо SEO (мета тагове, заглавия, схема)",
    pp_seo_f3: "Оценка на качеството на съдържанието",
    pp_seo_f4: "Анализ на профила на обратните връзки",
    pp_seo_f5: "Оценка на основните уеб показатели",
    pp_seo_f6: "Съвети за оптимизация с приоритет на мобилни устройства",
    pp_seo_f7: "Оценка на готовността за AI",
    pp_seo_f8: "PDF отчет за сваляне",
    pp_brand_name: "Мониторинг на брандове с AI",
    pp_brand_tag: "24/7 проследяване на споменавания на вашия бранд от AI търсачки",
    pp_brand_f1: "24/7 мониторинг в 4 AI машини",
    pp_brand_f2: "Уведомления за цитати в реално време по имейл",
    pp_brand_f3: "Сравнение с конкурентите",
    pp_brand_f4: "Историческо проследяване на тенденции с графики",
    pp_brand_f5: "Анализ на ниво запитване",
    pp_brand_f6: "Действащи препоръки за оптимизация с AI",
    pp_comp_name: "AI шпион за конкуренти",
    pp_comp_tag: "Интелигентност за конкуренция в реално време, захранвана от AI",
    pp_comp_f1: "Мониторинг на SEO на конкурентите в реално време",
    pp_comp_f2: "Уведомления за промени в съдържанието",
    pp_comp_f3: "Следене на придобиването на обратни връзки",
    pp_comp_f4: "Сравнение на видимостта с AI",
    pp_comp_f5: "Анализ на силни/слаби страни",
    pp_comp_f6: "Идентифициране на възможности",
    pp_comp_f7: "Приоритетни уведомления за важни промени",
    pp_blog_name: "Блог агент",
    pp_blog_tag: "25 SEO статии с 4 обратни връзки всяка — написани от AI, публикувани ежедневно",
    pp_blog_f1: "25 уникални SEO-оптимизирани статии",
    pp_blog_f2: "Публикувана 1 на ден за 25 дни",
    pp_blog_f3: "4 dofollow обратни връзки на статия",
    pp_blog_f4: "Автоматично преведени на 26 езика",
    pp_blog_f5: "Проучване на теми, основано на вашата индустрия",
    pp_blog_f6: "Дълги съдържания (над 1,500 думи)",
    pp_blog_f7: "Структура на вътрешни връзки",
    pp_blog_f8: "Включен схематичен маркер",
    pp_wp_name: "WordPress + WooCommerce Плъгин",
    pp_wp_tag: "Безплатен SEO плъгин с вградена видимост с AI",
    pp_auto_name: "SEO Автопилот",
    pp_auto_tag: "AI автоматично коригира вашето SEO - не просто препоръки",
    pp_auto_desc: "SEO Автопилот не просто ви казва какво да коригирате - той го прави за вас. Нашият AI автоматично генерира оптимизирани мета заглавия, описания, alt текстове на изображения, вътрешни връзки и секции с често задавани въпроси. Направи го с WordPress и Shopify чрез нашите плъгини.",
    pp_auto_f1: "Автоматично генериране на мета заглавия и описания",
    pp_auto_f2: "Автоматично генериране на alt текстове за изображения",
    pp_auto_f3: "Умни предложения за вътрешни връзки",
    pp_auto_f4: "Генериране на секция с често задавани въпроси с schema markup",
    pp_auto_f5: "Откриване на счупени линкове и предложения за пренасочване",
    pp_auto_f6: "Седмични автоматизирани сканирания",
    pp_auto_f7: "Интеграция на плъгини за WordPress и Shopify",
    pp_auto_f8: "Проследяване на резултати преди/след",
    pp_sim_name: "AI Симулатор на Търсене",
    pp_sim_tag: "Вижте какво биха отговорили ChatGPT, Perplexity и Gemini - безплатно",
    pp_sim_desc: "AI Симулатор на Търсене ви позволява да напишете всеки въпрос и да видите симулирани отговори от ChatGPT, Perplexity, Gemini и Copilot. Разберете дали вашият уебсайт ще бъде споменат в резултатите от AI търсене.",
    pp_sim_f1: "Симулирайте AI отговори от 4 търсачки",
    pp_sim_f2: "Проверете дали вашият уебсайт е цитиран",
    pp_sim_f3: "Тествайте всяко ключово слово или въпрос",
    pp_sim_f4: "Безплатни неограничени запитвания",
    pp_sim_f5: "Поддръжка на 26 езика",
    pp_blog_desc: "Blog Agent пише 25 SEO-оптимизирани статии за вашия уебсайт - по една на ден в продължение на 25 дни. Всяка статия включва 4 dofollow обратни връзки, автоматично е преведена на 26 езика и е публикувана по график.",
    pp_brand_desc: "AI Мониторинг на Брандове следи дали ChatGPT, Perplexity, Gemini и Copilot споменават вашия бранд, когато потребителите задават съответстващи въпроси. Получавайте известия в реално време и се сравнявайте с конкуренти.",
    pp_comp_desc: "AI Конкурентен Шпион следи SEO стратегиите на вашите конкуренти в реално време. Получавайте известия, когато публикуват ново съдържание, получават обратни връзки или подобряват своя AI рейтинг за видимост.",
    pp_wp_desc: "Нашият безплатен WordPress плъгин внася TopRankPulse директно във вашето WordPress админ. Получавайте SEO оценки, проследяване на AI видимост и корекции с едно кликване, без да напускате таблото си.",
    pp_wp_f1: "Корекции с едно кликване от WordPress админ",
    pp_wp_f2: "Вградено проследяване на AI видимост",
    pp_wp_f3: "Оптимизация на SEO за продукти в WooCommerce",
    pp_wp_f4: "Автоматичен schema markup",
    pp_wp_f5: "Безплатно завинаги за всички планове",
    pp_free_scan: "Безплатно първо сканиране",
  },

  uk: {
    pc_tag: "Припиніть переплачувати за SEO",
    pc_h1: "Заміна дорогих SEO агентств",
    pc_h1_highlight: "за ціною сімейної вечері",
    pc_sub: "Ви можете спробувати безкоштовно та почати ранжувати сьогодні",
    pc_month: "місяць",
    pc_best_value: "НАЙКРАЩА ПРОПОЗИЦІЯ",
    pc_agency: "SEO агентство",
    pc_ads_1: "Вам потрібен великий бюджет",
    pc_ads_2: "Ручне дослідження ключових слів",
    pc_ads_3: "Оптимізовано для кліків, а не для продажів",
    pc_ads_4: "Орендований трафік",
    pc_ads_5: "Конкуренти переважили вас",
    pc_ads_6: "Трафік зупиняється, коли ви зупиняєте витрати",
    pc_ads_7: "€0 в тривалих результатах",
    pc_trp_1: "AI створює якісний контент щодня",
    pc_trp_2: "Автоматичне дослідження ключових слів",
    pc_trp_3: "Якісні зворотні посилання включені",
    pc_trp_4: "Без контрактів — скасовуйте в будь-який час",
    pc_trp_5: "Раз ранжируйтесь, отримуйте трафік назавжди",
    pc_trp_6: "Не потрібні технічні знання",
    pc_trp_7: "Створено для залучення покупців, а не випадкового трафіку",
    pc_cta: "ПОЧНІТЬ БЕЗКОШТОВНУ ПРОБУ",
    pc_ag_1: "Місяці, щоб побачити результати",
    pc_ag_2: "Щотижневі зустрічі",
    pc_ag_3: "Заблоковані в контрактах",
    pc_ag_4: "2 блоги на місяць за €2,300",
    pc_ag_5: "Вони володіють всім",
    pc_ag_6: "Трафік збільшився на 200%, Продажі 0%",
    pc_ag_7: "Без оптимізації видимості AI",
    pc_save_title: "Зекономте 20+ годин та €2,000+/місяць",
    pc_save_sub: "Перейдіть з агентств або Google Ads на TopRankPulse та залиште більше грошей у своєму гаманці.",
    pc_save_cta: "ПЕРЕГЛЯНУТИ ПЛАНИ",
    bm_no_monitors: "Ще немає моніторингових брендів",
    bm_no_monitors_desc: "Додайте свій бренд, щоб почати відстежувати, як AI пошукові системи вас бачать.",
    bm_add_brand: "Додайте свій бренд",
    bm_brand_name: "Назва бренду",
    bm_website: "URL сайту",
    bm_industry: "Індустрія",
    bm_location: "Місцезнаходження",
    bm_competitors: "Конкуренти",
    bm_comma: "через кому",
    bm_start: "Почати моніторинг",
    bm_recheck: "Перевірити повторно",
    bm_overall: "Загальна видимість в AI",
    bm_citation_score: "Рейтинг цитування",
    bm_recommends: "Рекомендує",
    bm_not_cited: "Не цитовано",
    bm_top_rec: "Найкраща рекомендація",
    bm_query_analysis: "Аналіз запитів",
    bm_last_checked: "Остання перевірка",
    bm_loading: "Аналізую видимість в AI...",
    bm_recommendations: "Як підвищити вашу видимість",
    bm_high: "Високий вплив",
    bm_medium: "Середній",
    bm_low: "Низький",
    bm_vis_up: "Видимість зросла з останньої перевірки",
    bm_vis_down: "Видимість зменшилась з останньої перевірки",
    attr_desc: "Дивіться, скільки трафіку та доходу приносять вам AI пошукові системи",
    attr_setup: "Налаштування атрибуції",
    attr_demo: "Дані для демонстрації — встановіть трекінговий піксель, щоб побачити реальні дані",
    attr_visits: "Візити AI",
    attr_conversions: "Конверсії",
    attr_revenue: "Дохід",
    attr_conv_rate: "Коеф. конверсії",
    attr_traffic_30: "Трафік AI (30 днів)",
    attr_by_source: "Трафік за джерелами AI",
    attr_source_details: "Деталі джерела",
    attr_visits_short: "візити",
    attr_insights: "Інсайти AI",
    attr_pixel: "Трекінговий піксель",
    attr_copied: "Скопійовано",
    attr_copy: "Копіювати",
    attr_pixel_desc: "Вставте це перед </head> на вашому сайті, щоб почати відстежувати реальний трафік AI.",
    attr_no_sites: "Ще не відстежуються сайти",
    attr_no_sites_desc: "Додайте свій сайт, щоб побачити, скільки трафіку приносять вам AI пошукові системи.",
    attr_add_website: "Додати ваш сайт",
    ls_stat1: "сайти невидимі для AI",
    ls_stat2: "середня кількість візитів з AI пошуку",
    ls_stat3: "результати безкоштовного аудиту",
    ls_f1_t: "Відстеження видимості AI",
    ls_f1_d: "Перевірте, чи цитують ваш вебсайт ChatGPT, Perplexity і Gemini",
    ls_f2_t: "Повний SEO аудит",
    ls_f2_d: "Технічний аналіз з практичними рекомендаціями",
    ls_f3_t: "Оцінка голосового пошуку",
    ls_f3_d: "Оптимізуйте для Siri, Alexa, Google Assistant",
    ls_f4_t: "Оптимізація GEO",
    ls_f4_d: "Локальний SEO для",
    ls_f5_t: "Аналіз зворотних посилань",
    ls_f5_d: "Перевірте dofollow, nofollow та авторитет домену",
    ls_f6_t: "Швидкість сайту",
    ls_f6_d: "Основні веб-показники та оцінка продуктивності",
    ls_more_cities: "Більше міст у",
    ls_top_cities: "Топ міста в",
    ls_cta_h1: "ПОЧНІТЬ ВАШ БЕЗКОШТОВНИЙ",
    ls_cta_h2: "SEO АУДИТ",
    ls_cta_join: "Приєднуйтесь до бізнесів у",
    ls_cta_using: "які використовують TopRankPulse.",
    ls_scan: "СКАНУЙТЕ ВАШ ВЕБСАЙТ",
    ls_free: "Безкоштовно назавжди",
    ls_no_card: "Без кредитної картки",
    ls_langs: "26 мов",
    pl_f1_t: "Відстеження видимості AI",
    pl_f1_d: "Дивіться, чи цитують ваш вебсайт ChatGPT, Perplexity і Gemini",
    pl_f2_t: "Повний SEO аудит",
    pl_f2_d: "Технічний аналіз з практичними рекомендаціями",
    pl_f3_t: "Дослідження ключових слів",
    pl_f3_d: "Знайдіть кращі ключові слова з обсягом, складністю та трендами",
    pl_f4_t: "Оцінка голосового пошуку",
    pl_f4_d: "Оптимізуйте для Siri, Alexa, Google Assistant",
    pl_f5_t: "Рекомендації AI",
    pl_f5_d: "Покрокові інструкції для покращення вашого балу",
    pl_f6_t: "Віджет інформаційної панелі",
    pl_f6_d: "SEO-оцінка безпосередньо у вашій панелі управління WordPress",
    pl_f7_t: "Автосканування при публікації",
    pl_f7_d: "Автоматично аналізує нові публікації під час їх публікації",
    pl_f8_t: "SEO для WooCommerce",
    pl_f8_d: "Оцінки SEO продуктів, AI-описи та оптимізація Google Shopping",
    pl_f9_t: "Блог-агент (€25)",
    pl_f9_d: "25 SEO статей з зворотними посиланнями на ваш сайт",
    pl_s3_t: "Скануйте свій сайт",
    pl_s3_d: "Натисніть 'Сканувати зараз' і отримайте свій SEO бал + звіт про видимість AI за 30 секунд.",
    pl_w1_t: "SEO Бал продукту",
    pl_w1_d: "Кожен продукт отримує SEO бал в реальному часі.",
    pl_w2_t: "Генератор описів AI",
    pl_w2_d: "Опис продукту, згенерований AI в один клік.",
    pl_w3_t: "Готовий до Google Shopping",
    pl_w3_d: "Удосконалена схема розмітки продукту для Google Shopping.",
    fear_warning: "ПОПЕРЕЖЕННЯ",
    fear_h1: "AI рекомендує бренди",
    fear_h1_2: "які займають",
    fear_h1_highlight: "СЬОГОДНІ",
    fear_desc: "ChatGPT, Gemini і Perplexity отримують відповіді з найкращих сторінок. Якщо ви зараз не на рейтингу, AI буде рекомендувати ваших конкурентів — і наздогнати їх стає все важче.",
    fear_m1_label: "Місяць 1",
    fear_m1_title: "Ваш конкурент публікує контент",
    fear_m1_desc: "Поки ви чекаєте, вони створюють SEO авторитет і отримують цитування від AI двигунів.",
    fear_m3_label: "Місяць 3",
    fear_m3_title: "AI починає їх рекомендувати",
    fear_m3_desc: "ChatGPT та Perplexity тепер за замовчуванням цитують ваших конкурентів. Ваш трафік падає.",
    fear_m6_label: "Місяць 6",
    fear_m6_title: "Ви невидимі. Вони займають вашу нішу.",
    fear_m6_desc: "AI моделі підкріплюють те, що вже працює. Наздогнати зараз коштує в 10 разів більше зусиль і грошей.",
    fear_urgency: "Кожен день, що ви чекаєте, ви втрачаєте клієнтів.",
    fear_cta_h: "Почніть підніматися в рейтингу, перш ніж це зроблять ваші конкуренти",
    fear_cta_sub: "Бренди, що займають позиції сьогодні, стають стандартними AI рекомендаціями завтра. Переконайтеся, що це ви.",
    fear_cta_btn: "ПОЧАТИ ЗАРАЗ",
    pp_what_clients_say: "ЩО ГОВОРЯТЬ КЛІЄНТИ",
    pp_start_trial: "Розпочати безкоштовний пробний період",
    pp_download_plugin: "Завантажити плагін",
    pp_ready: "ГОТОВІ ДО",
    pp_start: "ПОЧАТИ",
    pp_join: "Приєднуйтеся до тисяч бізнесів, які використовують TopRankPulse.",
    pp_ai_vis_name: "Відстеження видимості AI",
    pp_ai_vis_tag: "Перевірте, чи ChatGPT, Perplexity & Gemini цитують ваш вебсайт",
    pp_ai_vis_desc: "Відстеження видимості AI контролює, чи згадують провідні AI пошукові системи — ChatGPT, Perplexity, Gemini та Copilot — ваш вебсайт, коли користувачі запитують релевантні питання.",
    pp_ai_vis_f1: "Моніторинг цитування в реальному часі у 4 AI системах",
    pp_ai_vis_f2: "Щотижневі звіти про тренди видимості",
    pp_ai_vis_f3: "Порівняння цитування конкурентів",
    pp_ai_vis_f4: "Рейтинг готовності до голосового пошуку",
    pp_ai_vis_f5: "Рекомендації по контенту, оптимізованому для AI",
    pp_ai_vis_f6: "Підтримка 26 мов з автоматичним визначенням",
    pp_seo_name: "Комплексний аудит SEO",
    pp_seo_tag: "Технічний аналіз SEO з рекомендаціями на основі AI",
    pp_seo_desc: "Наш комплексний аудит SEO аналізує 50+ факторів ранжування, включаючи технічне SEO, якість контенту, зворотні посилання, швидкість сторінки, оптимізацію для мобільних пристроїв та готовність до AI.",
    pp_seo_f1: "Аналізовано 50+ факторів ранжування",
    pp_seo_f2: "Перевірки технічного SEO (мета-теги, заголовки, схема)",
    pp_seo_f3: "Оцінка якості контенту",
    pp_seo_f4: "Аналіз профілю зворотних посилань",
    pp_seo_f5: "Оцінка основних веб-показників",
    pp_seo_f6: "Поради з оптимізації для мобільних пристроїв",
    pp_seo_f7: "Оцінка готовності до AI",
    pp_seo_f8: "Завантажуваний звіт у форматі PDF",
    pp_brand_name: "Моніторинг Бренду на основі AI",
    pp_brand_tag: "Моніторинг 24/7, якщо AI пошукові системи згадують ваш бренд",
    pp_brand_f1: "Моніторинг 24/7 на 4 AI-движках",
    pp_brand_f2: "Сповіщення про цитування в реальному часі через електронну пошту",
    pp_brand_f3: "Порівняння з конкурентами",
    pp_brand_f4: "Моніторинг історичних тенденцій з графіками",
    pp_brand_f5: "Аналіз на рівні запитів",
    pp_brand_f6: "Рекомендації з оптимізації, що підлягають дії",
    pp_comp_name: "Шпигун за Конкурентами AI",
    pp_comp_tag: "Конкурентна інформація в реальному часі на основі AI",
    pp_comp_f1: "Моніторинг SEO конкурентів в реальному часі",
    pp_comp_f2: "Сповіщення про зміни в контенті",
    pp_comp_f3: "Моніторинг придбання зворотних посилань",
    pp_comp_f4: "Порівняння видимості AI",
    pp_comp_f5: "Аналіз сильних і слабких сторін",
    pp_comp_f6: "Ідентифікація можливостей",
    pp_comp_f7: "Пріоритетні сповіщення для змін з великим впливом",
    pp_blog_name: "Блог Агент",
    pp_blog_tag: "25 статей SEO з 4 зворотними посиланнями кожна — написані AI, публікуються щоденно",
    pp_blog_f1: "25 унікальних статей, оптимізованих для SEO",
    pp_blog_f2: "Опубліковано 1 на день протягом 25 днів",
    pp_blog_f3: "4 dofollow зворотні посилання на статтю",
    pp_blog_f4: "Авто-переклад на 26 мов",
    pp_blog_f5: "Дослідження теми на основі вашої галузі",
    pp_blog_f6: "Довгий контент (понад 1,500 слів)",
    pp_blog_f7: "Структура внутрішньої переписки",
    pp_blog_f8: "Включений схемний розмітка",
    pp_wp_name: "Плагін WordPress + WooCommerce",
    pp_wp_tag: "Безкоштовний SEO плагін з вбудованим моніторингом видимості AI",
    pp_auto_name: "СЕО Автопілот",
    pp_auto_tag: "Штучний інтелект автоматично виправляє ваше СЕО — не лише рекомендації",
    pp_auto_desc: "СЕО Автопілот не просто говорить вам, що потрібно виправити — він виправляє це за вас. Наш ШІ автоматично генерує оптимізовані мета-назви, описи, альтернативний текст зображень, внутрішні посилання та секції FAQ. Працює з WordPress і Shopify через наші плагіни.",
    pp_auto_f1: "Автоматично генерувати мета-назви та описи СЕО",
    pp_auto_f2: "Автоматично генерувати альтернативний текст для зображень",
    pp_auto_f3: "Розумні пропозиції для внутрішнього зв'язування",
    pp_auto_f4: "Генерація секції FAQ з розміткою схеми",
    pp_auto_f5: "Виявлення зламаних посилань та пропозиції для перенаправлення",
    pp_auto_f6: "Щотижневі автоматизовані сканування",
    pp_auto_f7: "Інтеграція плагінів WordPress та Shopify",
    pp_auto_f8: "Відстеження баллів до/після",
    pp_sim_name: "Імітатор пошуку ШІ",
    pp_sim_tag: "Дивіться, що відповість ChatGPT, Perplexity & Gemini — безкоштовно",
    pp_sim_desc: "Імітатор пошуку ШІ дозволяє вам вводити будь-яке питання та бачити імітовані відповіді від ChatGPT, Perplexity, Gemini та Copilot. Дізнайтеся, чи згадується ваш веб-сайт у результатах пошуку ШІ.",
    pp_sim_f1: "Імітувати відповіді на запити ШІ з 4 движків",
    pp_sim_f2: "Перевірте, чи згадують ваш веб-сайт",
    pp_sim_f3: "Перевірте будь-яке ключове слово чи питання",
    pp_sim_f4: "Безкоштовні безлімітні запити",
    pp_sim_f5: "Підтримка 26 мов",
    pp_blog_desc: "Блог Агент пише 25 статей, оптимізованих для СЕО, для вашого веб-сайту — одна на день впродовж 25 днів. Кожна стаття включає 4 dofollow зворотні посилання, авто-перекладена на 26 мов і опублікована за графіком.",
    pp_brand_desc: "Моніторинг бренду ШІ відстежує, чи згадують ChatGPT, Perplexity, Gemini та Copilot ваш бренд, коли користувачі ставлять релевантні питання. Отримуйте сповіщення в реальному часі та порівнюйте з конкурентами.",
    pp_comp_desc: "ШПІ Конкурента стежить за стратегіями СЕО ваших конкурентів у реальному часі. Отримуйте сповіщення, коли вони публікують новий контент, отримують зворотні посилання або поліпшують свій бал видимості ШІ.",
    pp_wp_desc: "Наш безкоштовний плагін WordPress приносить TopRankPulse безпосередньо у вашу адмін-панель WordPress. Отримуйте оцінки СЕО, відстеження видимості ШІ та виправлення в один клік, не виходячи з панелі управління.",
    pp_wp_f1: "Виправлення СЕО в один клік з адмінки WordPress",
    pp_wp_f2: "Вбудоване відстеження видимості ШІ",
    pp_wp_f3: "Оптимізація SEO продуктів WooCommerce",
    pp_wp_f4: "Автоматична розмітка схеми",
    pp_wp_f5: "Безкоштовно назавжди для всіх планів",
    pp_free_scan: "Безкоштовне перше сканування",
  },
};
